const viVn = {
  "menu.overview": "Tổng quan",
  "menu.sales": "Bán hàng",
  "menu.inventory-management": "Hàng hóa & Kho",
  "menu.crm": "Khách hàng & Đối tác",
  "menu.finance": "Tài chính & Thuế",
  "menu.utilities": "Tiện ích",
  "product.tax-rate": "Thuế suất",
  "table.import.tax-rate": "Thuế suất (%)",
  /* 00.General */
  "general.copyright": "Coffee Management © 2019 All Rights Reserved.",
  "general.refresh": "Làm mới danh sách",
  "general.btn-update": "Cập nhật",
  "general.btn-update-count": "Bổ sung",
  "general.btn-add": "Thêm",
  "general.btn-order": "Đặt sản phẩm ngay!",
  "general.btn-order-preview": "Xem sản phẩm",
  "general.product-unit": "sản phẩm",
  "general.btn-create-make-product": "Tạo định lượng",
  "general.btn-update-make-product": "Cập nhật định lượng",
  "general.btn-cancel": "Hủy",
  "role.default.cashier": "Thu ngân",
  "role.default.kitchen": "Bar / Bếp",
  "role.default.table-pending-payment": "Chạy bàn",
  "general.info": "THÔNG TIN",
  "general.setting": "CÀI ĐẶT",
  "general.function": "TÍNH NĂNG",
  timeCreated: "Thời gian tạo",
  "print.cashier": "Thu ngân",
  "print.invoice": "Hoá đơn",
  "print.name-product": "Tên",
  "print.quantity": "Số lượng",
  "print.price": "Giá",
  "print.total-price": "Thành tiền",
  "print.discount": "Chiết khấu",
  "print.tax": "Thuế",
  "print.fee-other": "Phí",
  "print.shipping": "Vận chuyển",
  "print.amount-to-pay": "Số tiền thanh toán",
  "print.info-bill": "Thông Tin Thanh Toán",
  "print.thank-you": "Chân thành cảm ơn quý khách!",
  "print.copy-right": "Bản quyền thuộc vmass.vn.",

  /* 01.Order */
  "order.to-pending": "Chuyển chế biến",
  "order.to-done": "Chuyển thanh toán",
  "order.done": "Hoàn tất",
  "order.to-refund": "Huỷ do hết hàng",
  "order.to-change": "Điều chỉnh",
  "order.to-bill-draft": "In hoá đơn tạm tính",
  "order.to-bill": "Xuất hóa đơn",
  "order.to-end": "Hoàn tất",
  "order.print-bill": "In hóa đơn",
  "order.to-excel": "Tải về file Excel",
  "order.to-destroy": "Hủy đơn hàng",
  "order.transfer-table": "Chuyển bàn",
  "order.to-bill-now": "In hoá đơn",
  "order.to-bill-all": "In hoá đơn tất cả",
  "order.open-menu": "Thêm sản phẩm",
  "order.search": "Tìm kiếm Mã hoá đơn",
  "order.list-product-in-table": "Danh sách các sản phẩm trong bàn",

  /* 02. Profile */
  "company-uuid": "Mã cửa hàng",
  "company-name": "Tên cửa hàng",
  "profile.fullname": "Họ và tên",
  "profile.username": "Tên đăng nhập",
  "profile.email": "Email",
  "profile.address": "Địa chỉ",
  "profile.description": "Mô tả",
  "profile.avatar": "Hình ảnh cá nhân",
  "profile.company-address": "Địa chỉ cửa hàng",
  "profile.company-website": "Website cửa hàng",
  "profile.company-logo": "Logo cửa hàng",
  "profile.company-image": "Hình ảnh cửa hàng",
  "profile.company-start-time": "Thời gian mở cửa",
  "profile.company-end-time": "Thời gian đóng cửa",
  "profile.company-menu-hash": "Mã menu cửa hàng",
  "profile.company-menu-hash-create": "Tạo mới",
  "profile.phone": "Số điện thoại",
  "profile.birth-day": "Sinh nhật",
  "profile.btn-update": "Cập nhật",
  "pages.responsibilities": "Chuyên môn",
  "menu.contact": "Mạng xã hội",
  "profile.update-personal": "Cập nhật thông tin cá nhân",
  "profile.update-company": "Cập nhật thông tin cửa hàng",
  "profile.companyName": "Tên cửa hàng",
  "profile.bankPay": "Tên ngân hàng",
  "profile.namePay": "Chủ tài khoản",
  "profile.numberPay": "Số tài khoản",

  /* 03.User Login, Logout, Register */
  "user.login-title": "Đăng nhập",
  "user.register": "Đăng ký",
  "user.forgot-password": "Quên mật khẩu",
  "user.username": "Tên đăng nhập",
  "user.email": "Email",
  "user.phone": "Số điện thoại",
  "user.password": "Mật khẩu",
  "user.re-password": "Nhập lại mật khẩu",
  "user.forgot-password-question": "Quên mật khẩu?",
  "user.reset-password-button": "Nhận code mới",
  "user.reset-password-button-submit": "Đổi mật khẩu",
  "user.fullname": "Họ và tên",
  "user.login-button": "Đăng nhập",
  "user.register-button": "Đăng ký",
  "user.no-account": "Chưa có tài khoản? ",
  "user.register-link": "Đăng ký ngay",
  "user.code": "Code",

  /* 04.Menu */
  "menu.partner": "Con người",
  "menu.money": "Tài chính",
  "menu.m": "Sản phẩm",
  "menu.warehouse": "Kho",
  "menu.invoice": "Hóa đơn",
  "menu.sales-invoice": "Hóa đơn bán hàng",
  "menu.einvoice": "Hóa đơn điện tử",
  "menu.order": "Hóa đơn",
  "menu.app": "Trang chủ",
  "menu.affiliates": "Đối tác (Affiliates)",
  "menu.affiliate-list": "Danh sách Đối tác",
  "menu.affiliate-payouts": "Yêu cầu rút tiền",
  "menu.affiliate-commission": "Cấu hình Commission",
  "menu.affiliate-reports": "Báo cáo tổng quan",
  "menu.affiliate-fraud": "Fraud Control",
  "menu.dashboards": "Bán hàng",
  "menu.calendars": "Lịch",
  "menu.analytics": "Báo cáo",
  "menu.faq": "FAQ",
  "menu.view": "Câu hỏi và trả lời",
  "menu.default": "Tổng quát",
  "menu.content": "Content",
  "menu.product": "Sản phẩm",
  "menu.menu": "Sản phẩm",
  "menu.pages": "Quản lý",
  // "menu.thumb-list": "Quản lý sản phẩm",
  // 'menu.order': 'Order',
  "menu.search": "Tìm kiếm",
  "menu.login": "Đăng nhập",
  "menu.register": "Đăng ký",
  "menu.company": "Thông tin cửa hàng",
  "menu.profile": "Thông tin cá nhân",
  "menu.forgot-password": "Thay đổi mật khẩu",
  "menu.applications": "Tài khoản",
  "menu.promotion": "Khuyến mại",
  "menu.todo": "Sự kiện",
  "menu.category": "Danh mục sản phẩm",
  "menu.ui": "UI",
  "menu.table-setting": "Bàn ghế",
  "menu.stock": "Nguyên vật liệu",
  "menu.warehouse-import": "Phiếu nhập kho",
  "menu.warehouse-export": "Phiếu xuất kho",
  "menu.warehouse-transfer": "Phiếu chuyển kho",
  "menu.inventory-audit": "Kiểm kho",
  "menu.stock-return": "Hoàn hàng NCC",
  "menu.stock-disposal": "Tiêu hủy",
  "menu.stock-out": "Xuất kho",
  "stock-out.subtitle": "Quản lý xuất sử dụng, trả nhà cung cấp và tiêu hủy với quy trình duyệt rõ ràng.",
  "stock-out.create": "Tạo phiếu xuất",
  "menu.make-product": "Định lượng",
  "menu.payment": "Bàn chờ thanh toán",
  "menu.table-pending-payment": "Bàn chờ thanh toán",
  "menu.message": "Tin nhắn",
  "menu.ref": "Giới thiệu người mới",
  "menu.upgrade": "Nâng cấp",
  "menu.setting": "Cài đặt",
  "menu.root": "VMASS",
  "menu.user-staff": "Nhân viên",
  "menu.customer": "Khách hàng",
  "menu.company-provider": "Nhà cung cấp",
  "menu.treasury": "Tài sản",
  "menu.income": "Phiếu thu",
  "menu.outcome": "Phiếu chi",
  "menu.cash-flow": "Thu - Chi",
  "menu.role": "Tạo phân quyền ",
  "menu.form-dynamic": "Form tùy chỉnh",
  "menu.user-role": "Tạo tài khoản",
  "menu.qrcode": "QR Code",
  "menu.companies": "Liên kết đại lý",
  "menu.shipping": "Vận chuyển",
  "menu.facebook-settings": "Facebook Fanpage",
  "menu.zalo-settings": "Zalo OA",
  "menu.calendars": "Lịch",
  "menu.booking": "Đặt bàn",
  "menu.analytics": "Báo cáo",
  "menu.pages": "Quản lý",
  "menu.todo": "Công việc",
  "menu.invoice": "Hóa đơn",
  "menu.promotion": "Khuyến mãi",
  "menu.partner": "Đối tác",
  "menu.money": "Sổ quỹ",
  "menu.m": "Sản phẩm",
  "menu.thumb-list": "Sản phẩm",
  "menu.warehouse": "Kho hàng",
  "menu.stock": "Tồn kho",
  "menu.inventory-audit": "Kiểm kê kho",
  "menu.stock-return": "Trả hàng nhập",
  "menu.stock-disposal": "Hủy hàng",
  "menu.table-setting": "Sơ đồ bàn",
  "menu.message": "Tin nhắn",
  "menu.facebook-ads": "Quảng cáo Facebook",
  "menu.fb-ads-dashboard": "Tổng quan",
  "menu.fb-ads-campaigns": "Chiến dịch",
  "menu.fb-ads-reports": "Báo cáo",
  "menu.fb-ads-settings": "Cấu hình",
  "menu.applications": "Ứng dụng",
  "menu.profile": "Thông tin tài khoản",
  "menu.upgrade": "Nâng cấp",
  "menu.setting": "Cài đặt",
  "warehouse.export": "Phiếu xuất kho",
  "warehouse.transfer": "Phiếu chuyển kho",

  /* Shift Session - Chốt ca */
  "menu.shift-session": "Chốt ca",
  "menu.tax-accounting": "Sổ sách & Thuế",
  "menu.ai-copilot": "Trợ lý AI",
  "shift.title": "Quản lý ca làm việc",
  "shift.open": "Mở ca",
  "shift.close": "Chốt ca",
  "shift.current": "Ca hiện tại",
  "shift.history": "Lịch sử ca",
  "shift.no-open": "Chưa có ca nào đang mở",
  "shift.open-hint": 'Nhấn "Mở ca" để bắt đầu ca làm việc mới',
  "shift.open-modal-title": "Mở ca làm việc",
  "shift.close-modal-title": "Chốt ca & Đối soát tiền",
  "shift.detail-modal-title": "Chi tiết ca làm việc",
  "shift.shift-name": "Tên ca",
  "shift.shift-name-placeholder": "VD: Ca sáng, Ca chiều...",
  "shift.staff-name": "Nhân viên",
  "shift.opened-at": "Thời gian mở ca",
  "shift.closed-at": "Thời gian chốt ca",
  "shift.opening-cash": "Tiền mặt đầu ca",
  "shift.opening-cash-hint": "Số tiền mặt có trong két khi bắt đầu ca",
  "shift.actual-cash": "Tiền mặt thực tế cuối ca (VNĐ)",
  "shift.actual-cash-placeholder": "Nhập tiền mặt thực tế đếm được",
  "shift.expected-cash": "Tiền mặt lý thuyết",
  "shift.cash-difference": "Chênh lệch",
  "shift.total-revenue": "Tổng doanh thu",
  "shift.total-cash": "Tiền mặt",
  "shift.total-transfer": "Chuyển khoản",
  "shift.total-card": "Thẻ tín dụng",
  "shift.total-credit": "Công nợ",
  "shift.total-orders": "Tổng đơn hàng",
  "shift.total-products": "Tổng sản phẩm",
  "shift.note": "Ghi chú",
  "shift.note-optional": "Ghi chú (không bắt buộc)",
  "shift.note-explain": "Giải trình chênh lệch",
  "shift.note-explain-required": "Bắt buộc - Nhập lý do chênh lệch tiền mặt",
  "shift.status": "Trạng thái",
  "shift.status-open": "Đang mở",
  "shift.status-closed": "Đã chốt",
  "shift.confirm-open": "Xác nhận mở ca",
  "shift.confirm-close": "Xác nhận chốt ca",
  "shift.require-open": "Vui lòng mở ca trước khi bán hàng",
  "shift.print": "In phiếu chốt ca",
  "shift.print-title": "PHIẾU CHỐT CA",
  "shift.revenue-in-shift": "Doanh thu trong ca",
  "shift.cash-reconciliation": "Đối soát tiền mặt",
  "shift.cash-revenue-add": "+ Doanh thu tiền mặt",
  "shift.expected-cash-equals": "= Tiền mặt lý thuyết",
  "shift.no-data": "Chưa có dữ liệu ca làm việc",
  "shift.detail": "Chi tiết",
  "shift.page-prev": "← Trước",
  "shift.page-next": "Sau →",
  "shift.page-of": "Trang {current} / {total}",
  "shift.open-success": "Mở ca thành công",
  "shift.close-success": "Chốt ca thành công",
  "shift.open-error": "Lỗi khi mở ca",
  "shift.close-error": "Lỗi khi chốt ca",
  "shift.close-warn-difference":
    "Có chênh lệch tiền mặt. Vui lòng nhập giải trình trước khi chốt ca.",
  "shift.store-name": "Cửa hàng",
  "shift.copyright": "Bản quyền vmass.vn",
  "shift.cancel": "Hủy",

  /* 05.Dashboards */
  "dashboards.pending-orders": "Nhận",
  "dashboards.completed-orders": "Đã giao, Thu tiền",
  "dashboards.refund-requests": "Hết hàng, Hủy",
  "dashboards.sales": "Nhận",
  "dashboards.sales-chart": "BIỂU ĐỒ DOANH THU, CHI PHÍ",
  "dashboards.orders": "Đã giao",
  "dashboards.refunds": "Hết hàng",
  "dashboards.calendar": "Lịch",
  "dashboards.best-sellers": "Danh sách các sản phẩm đã bán",
  "dashboards.this-week": "Tuần",
  "dashboards.this-month": "Tháng",
  "dashboards.this-all-sales": "Tất cả doanh số",
  "dashboards.recent-orders": "Recent Orders",
  "dashboards.stock-status": "Thống kê nguyên vật liệu",
  "dashboards.logs": "HOẠT ĐỘNG",
  "dashboards.message": "Tin nhắn",
  "dashboards.area": "Khu",
  "dashboards.status-order": "Tổng hợp trạng thái các sản phẩm",
  "dashboards.pending-order": "Danh sách các sản phẩm chưa nhận",
  "dashboards.order-undelivery": "Danh sách các sản phẩm chưa giao",
  "dashboards.order-pending-payment": "Danh sách các hóa đơn chưa thu tiền",
  "dashboards.total-order": "Tổng số sản phẩm được đặt",
  "dashboards.product-not-receive": "sản phẩm chưa nhận",
  "dashboards.product-not-delivery": "sản phẩm chưa giao",
  "dashboards.table-notyet-pay": "hóa đơn chưa thu tiền",
  "dashboards.product-received-full": "Các sản phẩm đã được nhận hết",
  "dashboards.total-product-received": "Tổng sản phẩm đã nhận",
  "dashboards.product-delivery-full": "Các sản phẩm đã được giao hết",
  "dashboards.total-table-has-customer": "Tổng hóa đơn trong ngày",
  "dashboards.table-payment-full": "Các hóa đơn đã được thanh toán hết",
  "dashboards.list-empty": "Danh sách trống",
  "dashboards.total": "Tổng cộng",
  "dashboards.counter": "Đơn online",
  "dashboards.table": "Bàn",
  "dashboards.ice": "Đá",
  "dashboards.sugar": "Độ ngọt",
  "dashboards.all": "TẤT CẢ",
  "dashboards.completed": "HOÀN THÀNH",
  "dashboards.destroy": "HUỶ",
  "dashboards-empty-product": "Chưa có sản phẩm nào trong danh sách",

  /** Analytics */
  "analytics.dashboards": "Tổng quát",
  "analytics.user-staff": "Nhân viên",
  "analytics.customer": "Khách hàng",
  "analytics.company-provider": "Nhà cung cấp",
  "analytics.treasury": "Tài sản",
  "analytics.income": "Phiếu thu",
  "analytics.outcome": "Phiếu chi",
  "analytics.cash-flow": "Thu - Chi",
  "analytics.role": "Tạo phân quyền",
  "analytics.user-role": "Tạo tài khoản",
  "analytics.form-dynamic": "Form tùy chỉnh",
  "analytics.companies": "Liên kết đại lý",
  "analytics.dashboards.outcome": "THỐNG KÊ CHI PHÍ",
  "analytics.dashboards.income": "THỐNG KÊ DOANH THU",
  "analytics.dashboards.stock-log": "THỐNG KÊ NGUYÊN LIỆU NHẬP",
  "analytics.dashboards.order-payment": "TOP SẢN PHẨM BÁN CHẠY",
  "analytics.dashboards.debt": "THỐNG KÊ CÔNG NỢ",
  "analytics.dashboards.make-product": "THỐNG KÊ NGUYÊN LIỆU SỬ DỤNG",
  "analytics.dashboards.order-table": "THỐNG KÊ TỪNG BÀN",
  "analytics.today": "Hôm nay",
  "analytics.yesterday": "Hôm qua",
  "analytics.7-days-ago": "7 ngày gần đây",
  "analytics.this-week": "Tuần này",
  "analytics.last-week": "Tuần trước",
  "analytics.30-days-ago": "30 ngày gần đây",
  "analytics.this-month": "Tháng này",
  "analytics.last-month": "Tháng trước",
  "analytics.all": "Tất cả",
  "analytics.compare": "So sánh",
  "analytics.update": "Cập nhật",
  "analytics.revenue": "Doanh thu",
  "analytics.costs": "Chi phí",
  "analytics.profit": "Lợi nhuận",
  "analytics.invoice-quantity": "Số lượng hoá đơn",
  "analytics.number-products-sold": "Số sản phẩm đã bán",
  "analytics.average-selling-price": "Giá bán trung bình",
  "analytics.total-product": "Tổng số lượng sản phẩm",
  "analytics.product": "Sản phẩm",
  "analytics.amount-of-inventory": "Lượng hàng tồn kho",
  "analytics.items": "Mặt hàng",
  "analytics.inventory-value": "Giá trị tồn kho",

  /* product */
  "product.tab.add-one": "Thêm 1 sản phẩm",
  "product.tab.add-multiple": "Thêm sản phẩm",
  "product.tab.import-excel": "Nhập từ Excel",
  "product.tab.import-image": "Nhập từ hình ảnh",
  "product.tooltip.category":
    'Là danh mục cha của sản phẩm này. Ví dụ: Danh mục "Cà phê" là danh mục cha của sản phẩm "Cà phê sữa đá".',
  "product.tooltip.categories":
    'Là danh mục cha của các sản phẩm có trong "Sản phẩm", "Danh mục" cha này được tạo trước khi tạo "Sản phẩm". (Lưu ý: Nếu xóa danh mục cha thì các sản phẩm Sản phẩm thuộc danh mục cha cũng bị xóa theo, hãy cẩn thận!).',
  "product.tooltip.price":
    'Giá này là giá bán ra của sản phẩm nếu như "Giá khuyến mãi" không được tick chọn.',
  "product.tooltip.topping":
    'Là nơi để nhập các "sản phẩm phụ" với sản phẩm này và giá tiền tương ứng được cộng thêm vào giá bán.',
  "product.tooltip.ice":
    "Tick chọn 5 ô để khách hàng/người gọi sản phẩm có thể chọn Lượng đá của sản phẩm.",
  "product.tooltip.sugar":
    "Tick chọn 5 ô để khách hàng/người gọi sản phẩm có thể chọn Độ ngọt của sản phẩm.",
  "product.notify.create-stock-success": "Tạo nguyên liệu mới thành công",
  "product.notify.create-stock-error": "Có lỗi xảy ra khi tạo nguyên liệu",
  "product.notify.no-detail": "Không thể tải dữ liệu chi tiết của sản phẩm.",
  "product.import.result": "Kết quả Import",
  "product.import.choose-file": "Chọn file Excel để import sản phẩm",
  "product.import.support-format": "Hỗ trợ định dạng .xlsx và .xls",
  "product.import.download-template": "Tải file mẫu",
  "product.validation.barcode-min": "Cần nhập ít nhất 10 ký tự ({count}/10)",
  "product.placeholder.select-category": "Chọn hoặc tạo danh mục...",
  "product.image.change": "Thay đổi ảnh",
  "product.image.select": "Chọn ảnh",
  "product.confirm.delete": "Bạn có chắc chắn muốn xóa các sản phẩm đã chọn?",
  "category.confirm.delete": "Bạn chắc chắn muốn xoá danh mục này?",
  "category.confirm.delete-all":
    "Bạn có chắc chắn muốn xóa các danh mục đã chọn?",
  "product.confirm.delete-category": "Bạn chắc chắn muốn xoá danh mục này?",
  "product.confirm.apply-master":
    "Bạn có chắc chắn muốn áp dụng các giá trị này cho TẤT CẢ các biến thể không? Hành động này sẽ ghi đè lên các giá trị đã nhập riêng lẻ.",
  "product.error.invalid-data": "Dữ liệu không hợp lệ",
  "product.error.name-required": "Tên sản phẩm cần được thêm vào",
  "product.error.category-required": "Danh mục sản phẩm cần được chọn",
  "product.error.price-required": "Giá bán cần điền vào",
  "product.error.variant-required":
    'Vui lòng điền "Giá bán" và "Số lượng nhập" cho tất cả biến thể',
  "product.error.select-size": "Vui lòng chọn ít nhất một Size trước khi tạo.",

  /* Backend API validation messages */
  "product.api.error.price-invalid": "Giá sản phẩm không hợp lệ (phải >= 0)",
  "product.api.error.promo-price-invalid": "Giá khuyến mãi không hợp lệ (phải >= 0)",
  "product.api.error.barcode-invalid": "Mã barcode không hợp lệ (8-13 chữ số)",
  "product.api.error.sku-duplicate": "Mã SKU đã tồn tại trong hệ thống",
  "product.api.error.category-not-found": "Danh mục sản phẩm không tồn tại",
  "product.api.error.duplicate": "Sản phẩm này đã tồn tại trong hệ thống",
  "product.api.error.limit-reached": "Đã đạt giới hạn sản phẩm. Hãy nâng cấp gói để tạo thêm!",
  "product.api.error.not-found": "Không tìm thấy sản phẩm hoặc không có quyền truy cập",
  "product.api.error.variant-price-invalid": "Giá biến thể không hợp lệ (phải >= 0)",
  "product.api.error.variant-promo-invalid": "Giá khuyến mãi biến thể không hợp lệ (phải >= 0)",
  "product.api.error.import-missing-fields": "Sản phẩm thiếu Tên hoặc Danh mục",

  /* Product OCR */
  "product.ocr.title": "Trích xuất sản phẩm từ hình ảnh",
  "product.ocr.description": "Upload ảnh menu/bảng giá, AI sẽ tự động nhận diện sản phẩm.",
  "product.ocr.prompt-placeholder": "Để trống = tự động theo loại hình kinh doanh",
  "product.ocr.choose-images": "Chọn hình ảnh",
  "product.ocr.more-images": "ảnh khác",
  "product.ocr.show-prompt": "Tùy chỉnh prompt AI",
  "product.ocr.hide-prompt": "Ẩn prompt tùy chỉnh",
  "product.ocr.extract-btn": "Trích xuất dữ liệu",
  "product.ocr.extracting": "Đang xử lý...",
  "product.ocr.save-btn": "Lưu",
  "product.ocr.saving": "Đang lưu...",
  "product.ocr.save-success": "Import sản phẩm thành công!",
  "product.ocr.items": "sản phẩm",
  "product.ocr.col-name": "Tên sản phẩm",
  "product.ocr.col-category": "Danh mục",
  "product.ocr.col-size": "Kích thước",
  "product.ocr.col-price": "Giá bán",
  "product.ocr.col-price-sale": "Giá khuyến mãi",
  "product.ocr.col-barcode": "Mã vạch",
  "product.ocr.step-upload": "Tải ảnh lên",
  "product.ocr.step-mapping": "Ghép cột",
  "product.ocr.step-preview": "Xem & Lưu",
  "product.ocr.mapping-title": "Ghép cột dữ liệu",
  "product.ocr.mapping-desc": "AI đã nhận diện các cột bên trái. Hãy ghép chúng với trường dữ liệu sản phẩm tương ứng.",
  "product.ocr.ai-column": "Cột từ AI",
  "product.ocr.db-field": "Trường dữ liệu",
  "product.ocr.status": "Trạng thái",
  "product.ocr.skip-column": "-- Bỏ qua --",
  "product.ocr.mapped": "Đã ghép",
  "product.ocr.rows-found": "dòng dữ liệu",
  "product.ocr.cols-mapped": "cột đã ghép",
  "product.ocr.back": "Quay lại",
  "product.ocr.next": "Tiếp tục",
  "product.ocr.reset": "Làm mới",
  "product.ocr.preview-title": "Xem trước & Lưu",
  "product.ocr.stat-products": "Sản phẩm",
  "product.ocr.stat-categories": "Danh mục",
  "product.ocr.stat-with-price": "Có giá",
  "product.ocr.import-done": "Hoàn tất!",
  "product.ocr.created": "Tạo mới",
  "product.ocr.updated": "Cập nhật",
  "product.ocr.skipped": "Bỏ qua",
  "product.ocr.raw-result": "Kết quả thô từ AI:",
  "product.ocr.error-no-image": "Vui lòng chọn ít nhất một hình ảnh.",
  "product.ocr.error-no-data": "Không thể trích xuất dữ liệu từ hình ảnh. Vui lòng thử lại.",
  "product.ocr.error-extract": "Đã xảy ra lỗi khi phân tích hình ảnh.",
  "product.ocr.error-empty": "Không có dữ liệu để lưu.",
  "product.ocr.error-save": "Có lỗi xảy ra, vui lòng thử lại.",
  "product.ocr.error-name-required": "Bắt buộc ghép cột 'Tên sản phẩm' để tiếp tục.",

  /* 06.Product */
  "pages.add-new": "THÊM MỚI",
  "pages.add-new-user-staff": "THÊM NHÂN VIÊN",
  "pages.add-new-log": "THÊM PHÚC LỢI",
  "pages.order-new": "ORDER",
  "pages.image": "Hình ảnh sản phẩm",
  "pages.add-new-modal-title": "Thêm sản phẩm",
  "pages.order-new-modal-title": "Đặt sản phẩm mới",
  "pages.update-modal-title": "Cập nhật sản phẩm",
  "pages.display-options": "Hiển thị tùy chọn",
  "pages.orderby": "Sắp xếp : ",
  "pages.product-name": "Tên sản phẩm",
  "pages.product-barcode": "Barcode",
  "pages.product-sku": "Mã sản phẩm",
  "pages.category": "Danh mục sản phẩm",
  "pages.description": "Mô tả",
  "pages.status": "Trạng thái",
  "pages.cancel": "Đóng",
  "pages.submit": "Gửi",
  "pages.delete": "Xóa",
  "pages.delete-forever": "Xóa vĩnh viễn",
  "pages.another-action": "Khác",
  "pages.update": "Sửa thông tin",
  "pages.price": "Giá",
  "pages.select-category": "Chọn 1 danh mục sản phẩm",
  "pages.select-product": "Chọn 1 sản phẩm",
  "pages.order-number": "Trọng lượng",
  "pages.no-selected": "Không có hành động",
  "pages.order-more": "Thêm sản phẩm",
  "pages.total-order-price": "Tổng số tiền",
  "pages.current-order-price": "Thành tiền hiện tại",
  "pages.error-title": "Ooops... có lỗi xảy ra!",
  "pages.error-code": "Lỗi",
  "pages.go-back-home": "Quay lại trang chủ",
  "pages.softhide": "Ẩn sản phẩm",
  "pages.un-softhide": "Hiện sản phẩm",
  "pages.bestter": "Khuyên dùng",
  "pages.un-bestter": "Bỏ khuyên dùng",
  "pages.expand": "Xem biến thể",
  "pages.collapse": "Thu gọn",

  "product.title": "Thông tin sản phẩm",
  "product.price.original": "Giá bán",
  "product.price.sale": "Giá khuyến mãi",
  "product.price.wholesale": "Giá bán sỉ",
  "product.price.cost": "Giá vốn",
  "product.quantity": "Số lượng",
  "product.inventory": "Tồn kho",
  "product.ice": "Lượng đá",
  "product.sugar": "Độ ngọt",
  "product.size": "Kích thước",
  "product.topping": "Topping",
  "product.color": "Màu sắc",
  "product.material": "Chất liệu",
  "product.add.name": "Tên",
  "product.add.value": "Giá bán",
  "product.add_price": "Giá thêm",
  "product.update_cost": "Thêm định lượng",
  "product.edit_cost": "Sửa định lượng",
  "product.search": "Tìm Sản phẩm",
  "product.btn-add": "Tạo sản phẩm",
  "product.variants": "Biến thể",
  "product.variant-name": "Tên biến thể",
  "product.sku": "SKU",
  "product.price": "Giá bán",
  "product.stock": "Tồn kho",
  "product.promo-time": "Thời gian khuyến mãi",

  /* 07.Category */
  "category.add-new-modal-title": "Thêm danh mục sản phẩm",
  "category.update-title": "Cập nhật danh mục sản phẩm",
  "category.title": "Tên sản phẩm",
  "category.thumb-list": "Danh mục sản phẩm",
  "category.nav-tab": "DANH MỤC",
  "category.add-new-category": "THÊM DANH MỤC",
  "category.btn-add": "Tạo danh mục",

  /* 08.Todo */
  "todo.add-new": "THÊM",
  "todo.thumb-list": "Sự kiện",
  "todo.add-new-modal-title": "Thêm sự kiện",
  "todo.update-modal-title": "Cập nhật sự kiện",
  "todo.title": "Tiêu đề",
  "todo.description": "Mô tả",
  "todo.date": "Ngày",
  "todo.time": "Giờ",
  "todo.update-done": "Hoàn thành",
  "todo.update-pending": "Đang chờ",
  "todo.delete": "Xóa",
  "todo.no-selected": "Không có hành động",
  "todo.update": "Sửa",
  "todo.date-time": "Thời gian",
  "todo.orderby": "Sắp xếp : ",
  "todo.btn-add": "Tạo sự kiện",

  /*table setting */
  "table-setting.row": "Hàng ngang",
  "table-setting.col": "Hàng dọc",
  "table-setting.floor": "Khu vực",
  "table-setting.btn-generate": "Tạo bàn",
  "table-setting.map": "Sơ đồ",
  "table-setting.btn-save": "Lưu",
  "table-setting.title": "Cài đặt mô hình bàn ghế",

  /* stock */
  "stock.thumb-list": "Nguyên vật liệu",
  "stock.add-new-modal-title": "Thêm nguyên vật liệu",
  "stock.name": "Tên nguyên liệu",
  "stock.unit": "Đơn vị tính",
  "stock.unit-price": "Đơn giá",
  "stock.unit-price-update": "Giá mua gần đây",
  "stock.unit-price-new": "Đơn giá mới",
  "stock.price": "Thành tiền",
  "stock.count": "Số lượng",
  "stock.count-new": "Số lượng mới nhập",
  "stock.delete": "Xóa nguyên liệu",
  "stock.reset": "Reset về 0",
  "stock.count-update": "Bổ sung nguyên liệu",
  "stock.count-edit": "Chỉnh sửa thông tin nguyên liệu",
  "stock.count-current": "Số lượng còn lại",
  "stock.count-total": "Tổng nhập",
  "stock.update-title": "Bổ sung nguyên liệu",
  "stock.search": "Tìm tên Nguyên vật liệu",
  "stock.btn-add": "Tạo nguyên vật liệu",
  "stock.dashboard.subtitle": "Theo dõi tồn kho theo thời gian thực",
  "stock.dashboard.category": "Danh mục",
  "stock.dashboard.warehouse": "Kho",
  "stock.dashboard.min-stock-threshold": "Tồn tối thiểu",
  "stock.dashboard.status.in-stock": "Còn hàng",
  "stock.dashboard.status.low-stock": "Sắp hết hàng",
  "stock.dashboard.status.out-of-stock": "Hết hàng",
  "stock.dashboard.status.no-cost": "Chưa nhập giá vốn",
  "stock.dashboard.status.inactive": "Ngừng sử dụng",

  /* warehouse */
  "warehouse.add-new-modal-title": "Thêm phiếu",
  "warehouse.phone": "Số điện thoại",
  "warehouse.address": "Địa chỉ",
  "warehouse.code": "Mã số hàng hoá",
  "warehouse.unit": "Đơn vị tính",
  "warehouse.description": "Mô tả",
  "warehouse.btn-add": "Tạo phiếu",

  "warehouse.import-search": "Tìm tên Phiếu nhập kho",
  "warehouse.import": "Phiếu nhập kho",
  "warehouse.import-stock": "Mặt hàng nhập",
  "warehouse.import-title": "Cập nhật phiếu nhập kho",
  "warehouse.import-name": "Tên người nhập kho",
  "warehouse.import-quantity": "Số lượng nhập",
  "warehouse.import-price": "Giá nhập",
  "warehouse.btn-add-import": "Tạo phiếu nhập kho",

  "warehouse.export-search": "Tìm tên Phiếu xuất kho",
  "warehouse.export": "Phiếu xuất kho",
  "warehouse.export-stock": "Mặt hàng xuất",
  "warehouse.export-title": "Cập nhật phiếu xuất kho",
  "warehouse.export-name": "Tên người xuất kho",
  "warehouse.export-quantity": "Số lượng xuất kho",
  "warehouse.export-price": "Giá xuất",
  "warehouse.btn-add-export": "Tạo phiếu xuất kho",

  "warehouse.transfer-search": "Tìm tên Phiếu chuyển kho",
  "warehouse.transfer": "Phiếu chuyển kho",
  "warehouse.transfer-stock": "Mặt hàng chuyển kho",
  "warehouse.transfer-title": "Cập nhật phiếu chuyển kho",
  "warehouse.transfer-name": "Tên người chuyển kho",
  "warehouse.transfer-quantity": "Số lượng chuyển",
  "warehouse.transfer-price": "Giá chuyển kho",
  "warehouse.transfer-name-carrier": "Tên người vận chuyển",
  "warehouse.transfer-phone-carrier": "SĐT người vận chuyển",
  "warehouse.transfer-receiving-warehouse": "Chuyển đến kho",
  "warehouse.transportation": "Phương tiện vận chuyển",
  "warehouse.cost-transfer": "Phí vận chuyển",
  "warehouse.btn-add-transfer": "Tạo phiếu chuyển kho",

  /* make product */
  "make-product.thumb-list": "Định lượng",
  "make-product.add-new-modal-title": "Thêm định lượng",
  "make-product.name": "Tên",
  "make-product.unit": "Đơn vị",
  "make-product.count": "Số lượng",
  "make-product.make-more": "Thêm",
  "make-product.product-name": "Tên sản phẩm",
  "make-product.stock-name": "Tên nguyên liệu",
  "make-product.select-stock": "Chọn 1 nguyên liệu",
  "make-product.add-modal-title": "Tạo mới",
  "make-product.update-modal-title": "Chỉnh sửa",
  "make-product.number-product-used": "Số nguyên liệu sử dụng",
  "make-product.price": "Giá bán",
  "make-product.cost": "Giá Cost",
  "make-product.percent-cost": "Phần trăm giá cost/giá bán",
  "make-product.btn-add": "Tạo định lượng",

  /* FAQ */
  "faq.title": "Hướng dẫn",
  "faq.text-title": "Câu hỏi",
  "faq.text-content": "Trả lời",
  "faq.modal-title": "Câu hỏi và Trả lời",

  /** Ref */
  "ref.name": "Tên chủ quán",
  "ref.companyName": "Tên quán",
  "ref.email": "Email",
  "ref.phone": "Số điện thoại",
  "ref.address": "Địa chỉ",
  "ref.content": "Lời nhắn",
  "ref.title": "Thông tin người được giới thiệu",
  "ref.sub-title":
    "Hoa hồng giới thiệu của bạn hiện tại là 30% trên số tiền hợp đồng của người được giới thiệu ký với VMASS. Thông tin của bạn sẽ được gửi tự động cho VMASS dựa trên thông tin cá nhân của bạn đã cung cấp.",
  "ref.btn-submit": "Gửi giới thiệu",

  /** Chat */
  "chat.messages": "Tin nhắn",
  "chat.messages-inbox": "Hộp thư đến",
  "chat.messages-new": "Danh bạ",
  "chat.start-conversation": "Bắt đầu cuộc trò chuyện!",

  /** Discount */
  "discount.add-new-modal-title": "Thêm chiết khấu",
  "discount.note": "Ghi chú",
  "discount.type": "Loại giá trị",
  "discount.value": "Giá trị",
  "discount.user": "Nhân viên",
  "discount.products": "Sản phẩm",
  "discount.select-all-products": "Tất cả sản phẩm",
  "discount.select-one-type": "Chọn loại giá trị",
  "discount.select-one-product": "Chọn 1 sản phẩm",
  "discount.select-one-type-product": "Chọn 1 danh mục sản phẩm",
  "discount.to-bill": "Thêm khác",
  "discount.add-feetax": "Thêm Chiết khấu, Thuế, Phụ phí",
  "discount.discount": "Chiết khấu",
  "discount.tax": "Thuế",
  "discount.fee-other": "Phí khác",
  "order.adjustment.add-products-first":
    "Vui lòng thêm sản phẩm trước khi nhập mã",
  "order.adjustment.invalid-code": "Mã khuyến mại không hợp lệ",
  "order.adjustment.apply": "Áp dụng",
  "order.adjustment.note-optional": "Ghi chú (tùy chọn)",
  "order.adjustment.promo-code": "Mã khuyến mại",
  "order.adjustment.promo-placeholder": "Nhập mã khuyến mại",
  "order.adjustment.coupon-help":
    "Nhập mã và nhấn Áp dụng để nhận chiết khấu.",
  "order.adjustment.remove-code": "Bỏ mã khuyến mại",
  "order.adjustment.discount-value": "Giá trị chiết khấu",
  "order.adjustment.estimated-discount": "Số tiền giảm dự kiến",
  "order.adjustment.discount-note-placeholder":
    "Ví dụ: Khách hàng thân thiết",
  "order.adjustment.subtotal": "Tạm tính",
  "order.adjustment.total-after-discount": "Tổng sau chiết khấu",
  "order.adjustment.tax-title": "Thêm thuế",
  "order.adjustment.tax-rate": "Thuế suất",
  "order.adjustment.other": "Khác",
  "order.adjustment.tax-value": "Giá trị thuế",
  "order.adjustment.estimated-tax": "Tiền thuế dự kiến",
  "order.adjustment.calculation": "Cách tính",
  "order.adjustment.tax-added": "Cộng thêm vào đơn hàng",
  "order.adjustment.tax-added-help":
    "Thuế sẽ được cộng thêm vào tổng tiền thanh toán.",
  "order.adjustment.tax-included": "Đã bao gồm trong giá",
  "order.adjustment.tax-included-help":
    "Thuế đã được tính trong giá sản phẩm/dịch vụ.",
  "order.adjustment.tax-note-placeholder":
    "Ví dụ: Thuế VAT cho đơn bán lẻ",
  "order.adjustment.total-payment": "Tổng thanh toán",
  "order.adjustment.fee-title": "Thêm phụ phí",
  "order.adjustment.fee-name": "Tên phụ phí",
  "order.adjustment.shipping-fee": "Phí vận chuyển",
  "order.adjustment.service-fee": "Phí dịch vụ",
  "order.adjustment.packing-fee": "Phí đóng gói",
  "order.adjustment.other-fee": "Phí khác",
  "order.adjustment.fee-value": "Giá trị phụ phí",
  "order.adjustment.estimated-fee": "Phụ phí dự kiến",
  "order.adjustment.apply-on": "Áp dụng trên",
  "order.adjustment.calculation-base": "Cơ sở tính phụ phí",
  "order.adjustment.fixed-fee-base-help":
    "Phụ phí cố định theo VNĐ không phụ thuộc cơ sở tính.",
  "order.adjustment.after-discount": "Tổng tiền sau chiết khấu",
  "order.adjustment.fee-note-placeholder": "Ví dụ: Giao hàng nội thành",

  /** Customer */
  "customer.add-new-modal-title": "Thêm khách hàng",
  "customer.title": "Thông tin khách hàng",
  "customer.name": "Tên khách hàng",
  "customer.phone": "Số điện thoại",
  "customer.email": "Email",
  "customer.address": "Địa chỉ",
  "customer.point": "Số điểm hiện tại",
  "customer.armorial": "Huy hiệu",
  "customer.used-item": "Số lần sử dụng sản phẩm",
  "customer.tags": "Tags",
  "customer.info": "INFO",
  "customer.used": "SẢN PHẨM ĐÃ MUA",
  "customer.setting": "CÀI ĐẶT",
  "customer.search": "Tìm Số điện thoại KH",
  "customer.btn-add": "Tạo khách hàng",
  "customer.amount-spent": "Số tiền đã chi tiêu",
  "customer.debt": "Công nợ",
  "customer.modern.subtitle": "Quản lý và chăm sóc khách hàng",
  "customer.modern.total-customers": "Tổng khách hàng",
  "customer.modern.total-spent": "Tổng chi tiêu",
  "customer.modern.vip": "Khách hàng VIP",
  "customer.modern.new": "Khách hàng mới",
  "customer.modern.last-order": "Lần mua gần nhất",
  "customer.modern.sleeping": "Ngủ quên",

  /** Income, Outcome, Treasury */
  action: "Hành động",
  name: "Tên",
  phone: "Số điện thoại",
  email: "Email",
  address: "Địa chỉ",
  price: "Số tiền",
  note: "Mô tả",
  time: "Thống kê",
  "time-created": "Thời gian tạo",
  "user.created": "Người nhập liệu",
  "select-one-time": "Chọn 1 loại",
  "select-one-time-discount": "Chọn 1 loại giảm giá",
  "select-one-time-gift": "Chọn 1 loại quà tặng",

  "income.title": "Phiếu thu",
  "income.sub_title": "Tiêu đề",
  "income.add-new-modal-title": "Thêm phiếu thu",
  "income.name": "Tên người nộp",
  "income.search": "Tìm tên Phiếu thu",
  "income.btn-add": "Tạo phiếu thu",

  "outcome.title": "Phiếu chi",
  "outcome.sub_title": "Tiêu đề",
  "outcome.add-new-modal-title": "Thêm phiếu chi",
  "outcome.name": "Tên người nhận",
  "outcome.search": "Tìm tên Phiếu chi",
  "outcome.btn-add": "Tạo phiếu chi",

  "treasury.name": "Tên tài sản",
  "treasury.title": "Tài sản",
  "treasury.add-new-modal-title": "Thêm tài sản",
  "treasury.timeCreated": "Thời gian tạo",
  "treasury.search": "Tìm tên Tài sản",
  "treasury.btn-add": "Tạo tài sản",

  /** Break Event */
  "breakeven.title": "Điểm hòa vốn",

  /** Company Provider */
  "company-provider.info": "Thông tin",
  "company-provider.title": "Nhà cung cấp",
  "company-provider.title-log": "Thêm giao dịch",
  "company-provider.title-log-add": "Thêm giao dịch",
  "company-provider.title-log-add-more": "Thanh toán nợ",
  "company-provider.add-new-modal-title": "Thêm nhà cung cấp",
  "company-provider.name": "Tên nhà cung cấp",
  "company-provider.item_name": "Mặt hàng cung cấp",
  "company-provider.total_price_income": "Tổng số tiền nhập",
  "company-provider.total_price_outcome": "Đã thanh toán",
  "company-provider.total_price_pending": "Còn lại",
  "company-provider.price": "Số tiền",
  "company-provider.item_product": "Mặt hàng cung cấp",
  // 'company-provider.name': 'Tên nhà cung cấp',
  "company-provider.search": "Tìm tên Nhà cung cấp",
  "company-provider.btn-add": "Tạo nhà cung cấp",
  "company-provider.transaction": "Giao dịch",
  "company-provider.sku": "SKU",
  "company-provider.price_new": "Đơn giá",
  "company-provider.quantity": "Số lượng",
  "company-provider.debt": "Còn nợ",
  "company-provider.total": "Tổng giá trị",
  "company-provider.time": "Thời gian",
  "company-provider.action": "Hành động",

  "provider.kpi.total": "Tổng NCC",
  "provider.kpi.total-debt": "Tổng công nợ",
  "provider.kpi.paid": "Đã trả hết",
  "provider.kpi.in-debt": "Còn nợ",
  "provider.kpi.no-transaction": "Chưa có giao dịch",


  /** User Staff */
  "user-staff.title": "Thông tin nhân viên",
  "user-staff.add-new-modal-title": "Thêm nhân viên",
  "user-staff.add-new-logs-modal-title": "Thêm khác",
  // 'user-staff.title': 'Nhân viên',
  "user-staff.permission_name": "Vị trí công việc",
  "user-staff.date_join": "Ngày vào làm",
  "user-staff.date_get_salary": "Ngày thanh toán lương",
  "user-staff.hour_working_on_day": "Số giờ làm việc trong ngày",
  "user-staff.status_working": "Tình trạng công việc",
  "user-staff.salary_by": "Tính lương theo",
  "user-staff.salary_value": "Mức lương",
  "user-staff.working_hours": "Giờ làm việc",
  "user-staff.current_commission": "Tiền hoa hồng",
  "user-staff.current_bonus": "Tiền thưởng",
  "user-staff.current_overtime": "Tiền tăng ca",
  "user-staff.current_advence": "Tiền tạm ứng",
  "user-staff.current_fined": "Tiền phạt",
  "user-staff.current_dayoff": "Tiền nghỉ phép",
  "user-staff.current_day_working": "Ngày công tháng này",
  "user-staff.current_salary": "Lương tháng này",
  "user-staff.total_salary": "Tổng lương",
  "user-staff.total_day_working": "Tổng ngày công",
  "user-staff.working_hours_from": "* Làm từ",
  "user-staff.working_hours_to": "* Làm đến",
  "user-staff.logs_users_staff": "Tên nhân viên",
  "user-staff.logs_type": "Loại",
  "user-staff.logs_value_salary": "Số tiền",
  "user-staff.logs_value_hour": "Giờ",
  "user-staff.overtime_coefficient": "Hệ số lương tăng ca",
  "user-staff.select-all-users": "Chọn nhân viên",
  "user-staff.select-one": "Chọn một loại",
  "user-staff.name": "Tên nhân viên",
  "user-staff.phone": "Số điện thoại",
  "user-staff.address": "Địa chỉ",
  "user-staff.email": "Email",
  "user-staff.search": "Tìm tên Nhân viên",
  "user-staff.btn-add": "Tạo nhân viên",
  "user-staff.add-log-title": "Thêm thông tin lương nhân viên",
  "user-staff.kpi.total": "Tổng nhân viên",
  "user-staff.kpi.active": "Đang làm việc",
  "user-staff.kpi.inactive": "Nghỉ việc",
  "user-staff.kpi.manager": "Quản lý",
  "user-staff.kpi.revenue-today": "Doanh thu hôm nay",
  "user-staff.kpi.current": "Theo dữ liệu hiện tại",
  "user-staff.kpi.current-page": "Trong trang hiện tại",
  "user-staff.kpi.today": "Hôm nay",
  "user-staff.search-placeholder": "Tìm nhân viên...",
  "user-staff.filter.position-all": "Vị trí: Tất cả",
  "user-staff.filter.status-all": "Trạng thái: Tất cả",
  "user-staff.filter.shift-all": "Ca làm việc: Tất cả",
  "user-staff.filter.clear": "Bộ lọc",
  "user-staff.table.employee": "Nhân viên",
  "user-staff.table.position": "Vị trí",
  "user-staff.table.shift": "Ca làm việc",
  "user-staff.table.phone": "SĐT",
  "user-staff.table.revenue-today": "Doanh thu hôm nay",
  "user-staff.table.bills": "Hóa đơn",
  "user-staff.table.status": "Trạng thái",
  "user-staff.table.action": "Thao tác",
  "user-staff.action.call": "Gọi điện",
  "user-staff.action.message": "Nhắn tin",
  "user-staff.action.edit": "Sửa",
  "user-staff.action.more": "Thêm",
  "user-staff.action.delete": "Xóa",
  "user-staff.empty": "Chưa có dữ liệu nhân viên",
  "user-staff.detail.empty": "Chọn một nhân viên để xem chi tiết",
  "user-staff.detail.tab.info": "Thông tin",
  "user-staff.detail.tab.schedule": "Lịch làm việc",
  "user-staff.detail.tab.performance": "Hiệu suất",
  "user-staff.detail.tab.salary": "Lương thưởng",
  "user-staff.detail.tab.permission": "Quyền",
  "user-staff.detail.basic": "Thông tin cơ bản",
  "user-staff.detail.staff-code": "Mã nhân viên",
  "user-staff.detail.birthday": "Ngày sinh",
  "user-staff.detail.schedule": "Lịch làm việc",
  "user-staff.detail.performance": "Hiệu suất hôm nay",
  "user-staff.detail.salary": "Lương thưởng",
  "user-staff.detail.permission": "Quyền",
  "user-staff.detail.dynamic-fields": "Trường mở rộng",
  "user-staff.today.revenue": "Doanh thu",
  "user-staff.today.bills": "Số hóa đơn",
  "user-staff.today.products": "Sản phẩm phục vụ",
  "user-staff.today.revenue-per-hour": "Doanh thu/giờ",
  "user-staff.total.revenue": "Tổng doanh thu",

  /** Role */
  "role.name": "Tên phân quyền",
  "role.title": "Phân quyền",
  "role.add-new-modal-title": "Thêm phân quyền",
  "role.btn-add": "Tạo phân quyền",

  /** User Role */
  "user-role.title": "Nhân viên phân quyền",
  "user-role.name": "Tên nhân viên",
  "user-role.add-new-modal-title": "Thêm nhân viên phân quyền",
  "user-role.select-one": "Chọn một quyền",
  "user-role.place-holder-password": "Để trống nếu không thay đổi",
  "user-role.btn-add": "Tạo tài khoản",

  /** Form Dynamic */
  "form-dynamic.title": "Form tùy chỉnh",
  "form-dynamic.add-new-modal-title": "Thêm Form tùy chỉnh",
  "form-dynamic.label": "Tiêu đề",
  "form-dynamic.alias": "Loại form",
  "form-dynamic.select-one-alias": "Chọn 1 form",
  "form-dynamic.type": "Kiểu dữ liệu",
  "form-dynamic.select-one-type": "Chọn 1 kiểu",
  "form-dynamic.btn-add": "Tạo form tuỳ chỉnh",

  "url.placeholder": "http:// or https://",

  /** Compananies */
  "companies.find-company-uuid": "Tìm Mã cửa hàng",
  "companies.title": "Liên kết đại lý",
  "companies.add-new-modal-title": "Thêm liên kết",
  "companies.name": "Tên liên kết",
  "companies.type": "Loại liên kết",
  "companies.unset": "Chưa liên kết",
  "companies.btn-add": "Tạo liên kết",

  /** Promotion */
  "promotion.thumb-list": "Chương trình khuyến mại",
  "promotion-add": "Thêm khuyến mại",
  "promotion-update": "Cập nhật khuyến mại",
  "promotion-name": "Tên chương trình khuyến mại",
  "promotion-code": "Mã code",
  "promotion-quantity": "Số lượng áp dụng",
  "promotion-description": "Mô tả chương trình",
  "promotion-max-per-customer": "Số lượt tối đa cho mỗi khách hàng",
  "promotion-date_start": "Ngày bắt đầu",
  "promotion-date_end": "Ngày kết thúc",
  "promotion-isAutoUse": "Tự động kích hoạt",

  /** Calendar */
  "calendar.add-event": "Thêm sự kiện",

  /** Booking */
  "menu.booking": "Đặt bàn",
  "booking.title": "Quản lý đặt bàn",
  "booking.add-new": "Thêm đặt bàn",
  "booking.today": "Hôm nay",
  "booking.week": "Tuần này",
  "booking.month": "Tháng này",
  "booking.calendar": "Lịch",
  "booking.settings": "Cài đặt",
  "booking.customer-name": "Tên khách hàng",
  "booking.customer-phone": "Số điện thoại",
  "booking.customer-email": "Email",
  "booking.date": "Ngày đặt",
  "booking.time": "Giờ đến",
  "booking.party-size": "Số người",
  "booking.table": "Bàn",
  "booking.special-requests": "Yêu cầu đặc biệt",
  "booking.notes": "Ghi chú",
  "booking.status": "Trạng thái",
  "booking.status.pending": "Chờ xác nhận",
  "booking.status.confirmed": "Đã xác nhận",
  "booking.status.cancelled": "Đã hủy",
  "booking.status.completed": "Hoàn thành",
  "booking.status.no_show": "Không đến",
  "booking.deposit": "Đặt cọc",
  "booking.deposit-required": "Yêu cầu đặt cọc",
  "booking.deposit-amount": "Số tiền đặt cọc",
  "booking.confirm": "Xác nhận",
  "booking.cancel": "Hủy",
  "booking.complete": "Hoàn thành",
  "booking.source": "Nguồn đặt",
  "booking.no-bookings": "Chưa có đặt bàn nào",

  /** Wizard */
  "wizard.title": "Cài đặt nhanh",
  "wizard.sub-title":
    "The setup wizard will guide you through some steps to get your store up and running quickly.",
  "wizard.next": "Tiếp theo",
  "wizard.prev": "Trước",
  "wizard.finish": "Kết thúc",
  "wizard.skip": "Bỏ qua",
  "wizard.step-name-1": "Bước 1",
  "wizard.step-desc-1": "Thông tin cơ bản",
  "wizard.step-name-2": "Bước 2",
  "wizard.step-desc-2": "Thêm sản phẩm",
  "wizard.step-name-3": "Bước 3",
  "wizard.step-desc-3": "Thông tin thanh toán",
  "wizard.content-thanks": "Cảm ơn!",
  "wizard.registered":
    "Thông tin của bạn đã được ghi nhận, chúc bạn trải nghiệm phần mềm vui vẻ!",

  /* Facebook Settings */
  "facebook.settings-title": "Facebook Fanpage",
  "facebook.config-guide": "Cấu hình Webhook (Dành cho Kỹ thuật):",
  "facebook.callback-url": "Callback URL:",
  "facebook.verify-token": "Verify Token:",
  "facebook.fields": "Fields:",
  "facebook.guide": "Hướng dẫn",
  "facebook.guide-step-1": "Nhấn nút 'Kết nối Fanpage mới'",
  "facebook.guide-step-2": "Đăng nhập Facebook (nếu cần)",
  "facebook.guide-step-3": "Chọn Fanpage bạn muốn kết nối",
  "facebook.guide-step-4": "Cấp quyền cho ứng dụng",
  "facebook.guide-step-5": "Hoàn tất!",
  "facebook.connect-new": "Kết nối Fanpage mới",
  "facebook.description":
    "Kết nối Fanpage để nhận và trả lời tin nhắn khách hàng từ Facebook Messenger.",
  "facebook.how-to-connect": "Cách kết nối Fanpage:",
  "facebook.upgrade-warning":
    "Bạn cần nâng cấp lên gói Basic để kết nối Fanpage.",
  "facebook.upgrade-now": "Nâng cấp ngay",
  "facebook.connect-new-locked": "Kết nối Fanpage mới (Yêu cầu gói Basic)",
  "facebook.loading": "Đang tải...",
  "facebook.no-pages": "Chưa có Fanpage nào được kết nối.",
  "facebook.page-name": "Tên Fanpage",
  "facebook.page-id": "Page ID",
  "facebook.connected-date": "Ngày kết nối",
  "facebook.action": "Thao tác",
  "facebook.disconnect": "Hủy kết nối",
  "facebook.go-to-messenger": "Vào chat",
  "facebook.manual.btn": "Nhập Token thủ công",
  "facebook.manual.title": "Kết nối bằng Page Access Token",
  "facebook.manual.desc":
    "Dán Page Access Token vào ô bên dưới. Bạn có thể lấy token từ Facebook Developer Tools hoặc Business Suite.",
  "facebook.manual.guide": "Hướng dẫn lấy Token",
  "facebook.manual.guide-title": "Cách lấy Page Access Token:",
  "facebook.manual.guide-step-1":
    "Truy cập Facebook Graph API Explorer (developers.facebook.com/tools/explorer)",
  "facebook.manual.guide-step-2":
    "Chọn ứng dụng (App) và Fanpage cần kết nối",
  "facebook.manual.guide-step-3":
    "Cấp quyền: pages_show_list, pages_messaging, pages_read_engagement",
  "facebook.manual.guide-step-4":
    "Nhấn 'Generate Access Token' và copy token",
  "facebook.manual.placeholder": "Dán Page Access Token vào đây...",
  "facebook.manual.connect-btn": "Kết nối",
  "facebook.manual.connecting": "Đang kết nối...",
  "facebook.manual.error-empty": "Vui lòng nhập Page Access Token",
  "facebook.manual.error-failed": "Không thể kết nối. Vui lòng kiểm tra lại token.",
  "facebook.manual.error-no-selection": "Vui lòng chọn ít nhất 1 Fanpage để kết nối",
  "facebook.manual.check-btn": "Kiểm tra",
  "facebook.manual.checking": "Đang kiểm tra...",
  "facebook.manual.select-pages": "Chọn Fanpage cần kết nối:",
  "facebook.manual.select-all": "Chọn tất cả",
  "facebook.manual.deselect-all": "Bỏ chọn tất cả",
  "facebook.manual.pages-selected": "trang đã chọn",

  /* Settings - General */
  "settings.general": "Cấu hình chung",
  "settings.general.ui-title": "Giao diện hiển thị",
  "settings.general.font-size-label": "Cỡ chữ hiển thị",
  "settings.general.font-size-small": "Nhỏ",
  "settings.general.font-size-large": "Lớn",
  "settings.general.preview-text":
    "Xem trước: Đây là văn bản mẫu với cỡ chữ {size}px",
  "settings.general.report-title": "Cấu hình báo cáo",
  "settings.general.daily-report-time": "Giờ báo cáo hằng ngày",
  "settings.general.select-time-placeholder": "Chọn khung giờ...",
  "settings.general.report-note":
    "(Hệ thống sẽ gửi email báo cáo doanh thu vào các khung giờ đã chọn)",

  /* Settings - Invoice */
  "settings.invoice.title": "Cài đặt hóa đơn",
  "settings.invoice.section-1": "1. Cài đặt in hoá đơn khách hàng",
  "settings.invoice.print-at-counter": "In hoá đơn khi đặt sản phẩm tại quầy",
  "settings.invoice.section-2": "2. Cài đặt in hoá đơn bếp",
  "settings.invoice.print-kitchen":
    'In hoá đơn bếp khi thu ngân bấm nút "Chuyển chế biến"',
  "settings.invoice.section-3":
    "3. Quy trình chuyển bước khi đặt sản phẩm tại quầy",
  "settings.invoice.process-1": "Order và Hoàn thành ngay",
  "settings.invoice.process-2": "Order > Chuyển chế biến > Hoàn thành",
  "settings.invoice.process-3": "Order > Chuyển Thanh toán > Hoàn thành",
  "settings.invoice.process-4":
    "Order > Chuyển Thu ngân > Chuyển Bar/Bếp > Hoàn thành",
  "settings.invoice.process-4-title":
    "4. Quy trình chuyển bước khi đặt sản phẩm bằng QrCode",
  "settings.invoice.process-4-flow":
    "Order > Chuyển chế biến > Chuyển thanh toán > Hoàn thành",
  "settings.invoice.process-3-old": "Order > Chuyển thanh toán > Hoàn thành",
  "settings.invoice.process-4-old":
    "Order > Chuyển chế biến > Chuyển thanh toán > Hoàn thành",

  /* Settings - Email */
  "settings.email.title": "Cấu hình Email",
  "settings.email.guide-title": "Cách tạo App Password Gmail:",
  "settings.email.guide-step-1": "Vào Google Account",
  "settings.email.guide-step-2": "Bảo mật → Bật Xác minh 2 bước",
  "settings.email.guide-step-3": 'Tìm "App Password" hoặc nhấn vào đây',
  "settings.email.guide-step-4":
    'Chọn ứng dụng: Mail, Thiết bị: Other, nhập "VMASS"',
  "settings.email.guide-step-5":
    "Copy password 16 ký tự (có dạng: abcd efgh ijkl mnop)",
  "settings.email.smtp-custom-title": "SMTP tùy chỉnh:",
  "settings.email.description":
    "Cấu hình email riêng để gửi thông báo cho khách hàng từ địa chỉ email của cửa hàng thay vì email mặc định của VMASS.",
  "settings.email.mode-default": "Sử dụng email mặc định của VMASS",
  "settings.email.mode-custom": "Sử dụng email riêng",
  "settings.email.default-note":
    "Hệ thống sẽ gửi email từ địa chỉ vmass.vn@gmail.com. Tắt để cấu hình email riêng.",
  "settings.email.type-label": "Loại Email",
  "settings.email.type-gmail": "Gmail (App Password)",
  "settings.email.type-smtp": "SMTP tùy chỉnh (Zoho, Office 365...)",
  "settings.email.address-label": "Địa chỉ Email",
  "settings.email.password-label": "Mật khẩu Email",
  "settings.email.app-password-label": "App Password",
  "settings.email.create-app-password": "Tạo App Password tại đây",
  "settings.email.smtp-server-config": "Cấu hình SMTP Server",
  "settings.email.smtp-host": "SMTP Host",
  "settings.email.smtp-port": "Port",
  "settings.email.smtp-secure": "Bảo mật",
  "settings.email.quick-config": "Cấu hình nhanh:",
  "settings.email.test-button": "Gửi email test",
  "settings.email.save-button": "Lưu cấu hình",
  "settings.email.saving": "Đang lưu...",
  "settings.email.success": "Đã lưu cấu hình email thành công!",
  "settings.email.guide-button": "Hướng dẫn",

  /* Settings - Shipping */
  "settings.shipping.title": "Cài đặt vận chuyển",
  "settings.shipping.subtitle":
    "Kết nối với các đơn vị vận chuyển để tạo đơn giao hàng tự động",
  "settings.shipping.upgrade-warn":
    "Bạn cần nâng cấp lên gói Basic để sử dụng tính năng Kết nối vận chuyển.",
  "settings.shipping.upgrade-btn": "Nâng cấp ngay",
  "settings.shipping.business-type-label": "Ngành hàng của bạn:",
  "settings.business.cafe": "Quán cà phê",
  "settings.business.restaurant": "Nhà hàng",
  "settings.business.retail": "Bán lẻ",
  "settings.business.other": "Khác",
  "settings.shipping.business-fit":
    "Các đơn vị vận chuyển dưới đây phù hợp với ngành hàng của bạn",
  "settings.shipping.connected-title": "Đơn vị đã kết nối",
  "settings.shipping.edit-btn": "Sửa",
  "settings.shipping.disconnect-btn": "Ngắt kết nối",
  "settings.shipping.available-title": "Đơn vị vận chuyển có sẵn",
  "settings.shipping.status-connected": "Đã kết nối",
  "settings.shipping.connect-btn": "Kết nối ngay",
  "settings.shipping.guide-title": "Hướng dẫn",
  "settings.shipping.modal.connect-title": "Kết nối {name}",
  "settings.shipping.modal.token": "API Token",
  "settings.shipping.modal.shop-id": "Shop ID",
  "settings.shipping.modal.client-id": "Client ID",
  "settings.shipping.modal.secret-key": "Secret Key",
  "settings.shipping.modal.token-placeholder":
    "Nhập API Token từ nhà vận chuyển",
  "settings.shipping.modal.shop-id-placeholder": "Nhập Shop ID (nếu có)",
  "settings.shipping.modal.client-id-placeholder": "Nhập Client ID",
  "settings.shipping.modal.secret-key-placeholder": "Nhập Secret Key",
  "settings.shipping.modal.current-token":
    "Token hiện tại: {token} (để trống nếu không muốn thay đổi)",
  "settings.shipping.modal.sandbox-label":
    "Chế độ Sandbox (test) - Bỏ tick khi dùng thật",
  "settings.shipping.modal.origin-title": "Địa chỉ gửi hàng (Shop origin)",
  "settings.shipping.modal.origin-desc":
    "Thông tin này dùng để tính phí vận chuyển chính xác",
  "settings.shipping.modal.province": "Tỉnh/Thành gửi",
  "settings.shipping.modal.district": "Quận/Huyện gửi",
  "settings.shipping.modal.ward": "Phường/Xã gửi",
  "settings.shipping.modal.select-province": "Chọn Tỉnh/Thành",
  "settings.shipping.modal.select-district": "Chọn Quận/Huyện",
  "settings.shipping.modal.select-ward": "Chọn Phường/Xã",
  "settings.shipping.modal.cancel": "Hủy",
  "settings.shipping.modal.connect": "Kết nối",
  "settings.shipping.modal.connecting": "Đang kết nối...",
  "settings.shipping.alert.missing-token": "Vui lòng nhập API Token",
  "settings.shipping.alert.connect-success": "Kết nối thành công",
  "settings.shipping.alert.connect-error": "Lỗi kết nối đơn vị vận chuyển",
  "settings.shipping.alert.disconnect-confirm":
    "Bạn có chắc muốn ngắt kết nối đơn vị vận chuyển này?",
  "settings.shipping.alert.disconnect-success": "Đã ngắt kết nối",
  "settings.shipping.alert.disconnect-error": "Lỗi ngắt kết nối",
  "settings.shipping.guide.ghn.step1": "Truy cập api.ghn.vn",
  "settings.shipping.guide.ghn.step2": "Đăng ký/Đăng nhập tài khoản",
  "settings.shipping.guide.ghn.step3": 'Vào mục "Documents" lấy Token',
  "settings.shipping.guide.ghn.step4": "Nhập Token và Shop ID vào form",
  "settings.shipping.guide.ghtk.step1":
    "Đăng nhập khachhang.giaohangtietkiem.vn",
  "settings.shipping.guide.ghtk.step2":
    'Vào "Thông tin shop" hoặc "Quản lý API"',
  "settings.shipping.guide.ghtk.step3": "Sao chép API Token",
  "settings.shipping.guide.viettel.step1": "Đăng nhập partner.viettelpost.vn",
  "settings.shipping.guide.viettel.step2": 'Vào "Cấu hình tài khoản"',
  "settings.shipping.guide.viettel.step3": "Sao chép Token API",
  "settings.shipping.guide.jt.step1": "Liên hệ J&T để đăng ký partner",
  "settings.shipping.guide.jt.step2": "Nhận Client ID và Secret Key",
  "settings.shipping.modal.token-guide.ghn":
    "Lấy token tại: api.ghn.vn → Documents",
  "settings.shipping.modal.token-guide.ghtk":
    "Lấy token tại: khachhang.giaohangtietkiem.vn → Thông tin shop",
  "settings.shipping.modal.token-guide.viettel":
    "Lấy token tại: partner.viettelpost.vn → Cấu hình tài khoản",
  "settings.shipping.modal.token-guide.jt":
    "Liên hệ J&T để được cấp tài khoản API",

  /* Settings - Customer */
  "settings.customer.tier.bronze": "Đồng",
  "settings.customer.tier.silver": "Bạc",
  "settings.customer.tier.gold": "Vàng",
  "settings.customer.tier.diamond": "Kim Cương",
  "settings.customer.alert.success": "Đã lưu cài đặt thành công!",
  "settings.customer.alert.error": "Lỗi khi lưu cài đặt",
  "settings.customer.alert.missing-info": "Vui lòng nhập đầy đủ thông tin",
  "settings.customer.alert.min-tiers": "Phải có ít nhất 1 hạng khách hàng",
  "settings.customer.loading": "Đang tải...",
  "settings.customer.saving": "Đang lưu...",
  "settings.customer.point-rule": "Quy tắc tích điểm",
  "settings.customer.point-value": "1 điểm =",
  "settings.customer.currency": "VNĐ",
  "settings.customer.tier-title": "Mốc tích điểm & Hạng khách hàng",
  "settings.customer.add-tier": "Thêm hạng",
  "settings.customer.new-tier": "Hạng mới",
  "settings.customer.table.color": "Màu",
  "settings.customer.table.name": "Tên hạng",
  "settings.customer.table.points": "Điểm tối thiểu",
  "settings.customer.table.actions": "Thao tác",
  "settings.customer.placeholder.name": "Tên hạng",
  "settings.customer.placeholder.points": "Điểm",
  "settings.customer.points-suffix": "điểm",
  "settings.customer.note-title": "Lưu ý:",
  "settings.customer.note-content":
    "Hạng của khách hàng sẽ tự động cập nhật dựa trên tổng điểm tích lũy. Các hạng được sắp xếp theo thứ tự điểm tối thiểu từ thấp đến cao.",
  "settings.customer.save-btn": "Lưu thay đổi",

  /* Settings - Staff */
  "settings.staff.alert.load-error": "Không thể tải cài đặt",
  "settings.staff.alert.save-success": "Đã lưu cài đặt thành công!",
  "settings.staff.alert.save-error": "Không thể lưu cài đặt",
  "settings.staff.alert.position-exists": "Vị trí này đã tồn tại",
  "settings.staff.shift-title": "Cấu hình khung giờ làm việc",
  "settings.staff.shift-desc":
    'Thiết lập các ca làm việc mặc định. Click "Lưu cài đặt" để lưu vào hệ thống.',
  "settings.staff.add-shift": "Thêm Ca",
  "settings.staff.from": "Từ",
  "settings.staff.to": "Đến",
  "settings.staff.delete": "Xóa",
  "settings.staff.position-title": "Vị trí công việc",
  "settings.staff.position-desc":
    "Danh sách các chức danh/vị trí công việc. Click vào dấu × để xóa vị trí.",
  "settings.staff.add-position": "Thêm vị trí mới",
  "settings.staff.position-placeholder": "Nhập tên vị trí...",
  "settings.staff.save-btn": "Lưu cài đặt",
  "settings.staff.saving": "Đang lưu...",

  /* Settings - Partner & API */
  "settings.partner.title": "API Key",
  "settings.partner.doc-btn": "Tài liệu tích hợp",
  "settings.partner.create-btn": "+ Tạo API Key",
  "settings.partner.alert.empty":
    'Chưa có API Key nào. Nhấn "+ Tạo API Key" để bắt đầu.',
  "settings.partner.alert.create-error": "Vui lòng nhập tên API Key",
  "settings.partner.alert.create-success": "Tạo API Key thành công!",
  "settings.partner.alert.create-fail": "Lỗi tạo API Key",
  "settings.partner.alert.revoke-title": "Xóa API Key",
  "settings.partner.alert.revoke-confirm":
    "Bạn có chắc chắn muốn xóa API key này? Hành động này không thể hoàn tác!",
  "settings.partner.alert.revoke-success": "Đã thu hồi API key",
  "settings.partner.alert.revoke-fail": "Lỗi thu hồi API Key: ",
  "settings.partner.alert.regenerate-title": "Làm mới API Key",
  "settings.partner.alert.regenerate-confirm":
    "Bạn có chắc chắn muốn tạo lại API Key? Key cũ sẽ bị vô hiệu hóa ngay lập tức!",
  "settings.partner.alert.regenerate-success": "Đã tạo lại API Key thành công!",
  "settings.partner.alert.regenerate-fail": "Lỗi tạo lại API Key",
  "settings.partner.alert.update-fail": "Lỗi cập nhật API Key",
  "settings.partner.analytics.total": "Tổng requests",
  "settings.partner.analytics.today": "Hôm nay",
  "settings.partner.analytics.success-rate": "Tỷ lệ thành công",
  "settings.partner.analytics.avg-time": "Thời gian TB",
  "settings.partner.table.name": "Tên",
  "settings.partner.table.keys": "API Keys",
  "settings.partner.table.permissions": "Quyền truy cập",
  "settings.partner.table.note": "Ghi chú",
  "settings.partner.table.action": "Hành động",
  "settings.partner.modal.create.title": "Tạo API Key mới",
  "settings.partner.modal.create.name": "Tên API Key *",
  "settings.partner.modal.create.name-placeholder":
    "VD: n8n Automation, App Mobile...",
  "settings.partner.modal.create.permissions": "Quyền truy cập",
  "settings.partner.modal.create.permissions-desc":
    "Chọn quyền và nhấn × để xóa",
  "settings.partner.modal.create.permissions-placeholder":
    "Chọn quyền truy cập...",
  "settings.partner.modal.create.env": "Môi trường API",
  "settings.partner.modal.create.env-test": "Test (Thử nghiệm)",
  "settings.partner.modal.create.env-live": "Live (Thực tế)",
  "settings.partner.modal.create.desc": "Mô tả",
  "settings.partner.modal.create.desc-placeholder":
    "Mô tả mục đích sử dụng API Key...",
  "settings.partner.modal.create.cancel": "Hủy",
  "settings.partner.modal.create.submit": "Tạo API Key",
  "settings.partner.modal.create.submitting": "Đang tạo...",
  "settings.partner.modal.result.title": "API Key đã tạo",
  "settings.partner.modal.result.important":
    "Quan trọng! Hãy lưu API Key này ngay. Nó chỉ được hiển thị một lần duy nhất!",
  "settings.partner.modal.result.copy": "Sao chép",
  "settings.partner.modal.result.copied": "✓ Đã sao chép!",
  "settings.partner.modal.result.copy-alert":
    "Đã sao chép API Key vào clipboard!",
  "settings.partner.modal.result.expires": "Hết hạn:",
  "settings.partner.modal.result.close": "Đã lưu",

  /* Partner Permissions */
  "settings.partner.perm.orders-read": "Đọc đơn",
  "settings.partner.perm.orders-write": "Ghi đơn",
  "settings.partner.perm.products-read": "Đọc sản phẩm",
  "settings.partner.perm.products-write": "Ghi sản phẩm",
  "settings.partner.perm.inventory-read": "Đọc kho",
  "settings.partner.perm.inventory-write": "Ghi kho",
  "settings.partner.perm.recipes-read": "Đọc công thức",
  "settings.partner.perm.recipes-write": "Ghi công thức",
  "settings.partner.perm.customers-read": "Đọc khách hàng",
  "settings.partner.perm.customers-write": "Ghi khách hàng",
  "settings.partner.perm.user-read": "Đọc thông tin tài khoản",

  "settings.partner.env.test-desc":
    "Dùng để thử nghiệm API. Dữ liệu tạo ra sẽ được đánh dấu is_test=true, không ảnh hưởng đến báo cáo doanh thu thực tế.",
  "settings.partner.env.live-desc":
    "Dùng cho môi trường thực tế (Production). Mọi dữ liệu sẽ được ghi nhận vào hệ thống thật và ảnh hưởng đến báo cáo.",
  "settings.partner.env.live-label": "Live:",
  "settings.partner.create-btn-pro-auto": "+ Tạo API Key (Gói Pro Auto)",
  "settings.partner.list-title": "Danh sách API Keys",
  "settings.partner.pro-feature-tooltip":
    "Tính năng yêu cầu gói Pro Auto trở lên",
  "settings.partner.upgrade-alert.text": "Bạn cần nâng cấp lên gói",
  "settings.partner.upgrade-alert.action": "để tạo và quản lý API Key.",
  "settings.partner.upgrade-alert.link": "Nâng cấp ngay",
  "settings.partner.modal.confirm.cancel": "Hủy",
  "settings.partner.modal.confirm.confirm": "Xác nhận",

  "settings.webhook.title": "Webhook Subscriptions",
  "settings.webhook.doc-btn": "Tài liệu API",
  "settings.webhook.create-btn": "+ Tạo Webhook",
  "settings.webhook.create-btn-pro-auto": "+ Tạo Webhook (Gói Pro Auto)",
  "settings.webhook.pro-feature-tooltip":
    "Tính năng yêu cầu gói Pro Auto trở lên",
  "settings.webhook.upgrade-alert.text": "Bạn cần nâng cấp lên gói",
  "settings.webhook.upgrade-alert.action": "để sử dụng Webhook.",
  "settings.webhook.upgrade-alert.link": "Nâng cấp ngay",

  "settings.webhook.alert.empty":
    'Chưa có webhook nào. Nhấn "+ Tạo Webhook" để bắt đầu nhận thông báo tự động.',
  "settings.webhook.alert.create-success": "Tạo webhook thành công!",
  "settings.webhook.alert.create-error": "Vui lòng kiểm tra lại thông tin.",
  "settings.webhook.alert.create-fail": "Lỗi tạo webhook",
  "settings.webhook.alert.delete-success": "Đã xóa webhook",
  "settings.webhook.alert.delete-fail": "Lỗi xóa webhook",
  "settings.webhook.alert.update-fail": "Lỗi cập nhật webhook",
  "settings.webhook.alert.rotate-confirm":
    "Bạn có chắc muốn tạo lại Secret Key? Key cũ sẽ bị vô hiệu hóa ngay lập tức!",
  "settings.webhook.alert.rotate-success": "Đã tạo lại Secret Key thành công!",
  "settings.webhook.alert.rotate-fail": "Lỗi tạo lại Secret Key",
  "settings.webhook.alert.delete-confirm":
    "Bạn có chắc chắn muốn xóa webhook này? Hành động này không thể hoàn tác!",

  "settings.webhook.table.url": "URL",
  "settings.webhook.table.events": "Sự kiện",
  "settings.webhook.table.status": "Trạng thái",
  "settings.webhook.table.last-triggered": "Lần gửi cuối",
  "settings.webhook.table.action": "Hành động",
  "settings.webhook.status.active": "Hoạt động",
  "settings.webhook.status.inactive": "Tắt",

  "settings.webhook.modal.create.title": "Tạo Webhook mới",
  "settings.webhook.modal.create.desc":
    "Webhook cho phép VMASS gửi thông báo tự động đến URL của bạn khi có sự kiện xảy ra (đơn hàng mới, thanh toán, v.v.).",
  "settings.webhook.modal.create.url-label": "URL nhận Webhook *",
  "settings.webhook.modal.create.url-placeholder":
    "https://your-server.com/webhook",
  "settings.webhook.modal.create.url-help":
    "URL phải là HTTPS và có thể nhận POST requests",
  "settings.webhook.modal.create.events-label":
    "Chọn sự kiện muốn nhận thông báo *",
  "settings.webhook.modal.create.events-placeholder": "Chọn sự kiện...",
  "settings.webhook.modal.create.events-help": "Nhấn × để xóa sự kiện đã chọn",
  "settings.webhook.modal.create.cancel": "Hủy",
  "settings.webhook.modal.create.submit": "Tạo Webhook",
  "settings.webhook.modal.create.submitting": "Đang tạo...",

  "settings.webhook.modal.secret.title": "Webhook Secret Key",
  "settings.webhook.modal.secret.important":
    "Quan trọng! Hãy lưu Secret Key này ngay. Nó chỉ được hiển thị một lần duy nhất!",
  "settings.webhook.modal.secret.label":
    "Secret Key (dùng để verify signature)",
  "settings.webhook.modal.secret.copy": "Sao chép",
  "settings.webhook.modal.secret.copied": "✓ Đã sao chép!",
  "settings.webhook.modal.secret.verify-guide": "Cách verify signature:",
  "settings.webhook.modal.secret.close": "Đã lưu Secret Key",

  "settings.webhook.modal.logs.title": "Lịch sử gửi Webhook",
  "settings.webhook.modal.logs.empty": "Chưa có log nào",
  "settings.webhook.modal.logs.time": "Thời gian",
  "settings.webhook.modal.logs.event": "Event",
  "settings.webhook.modal.logs.status": "Status",
  "settings.webhook.modal.logs.response-time": "Response Time",
  "settings.webhook.modal.logs.close": "Đóng",

  "settings.webhook.modal.confirm.title": "Xác nhận",
  "settings.webhook.modal.confirm.cancel": "Hủy",
  "settings.webhook.modal.confirm.confirm": "Xác nhận",

  "settings.webhook.event.order.created": "Đơn hàng mới được tạo",
  "settings.webhook.event.order.paid": "Đơn hàng đã thanh toán",
  "settings.webhook.event.order.shipped": "Đơn hàng đã giao cho vận chuyển",
  "settings.webhook.event.order.completed": "Đơn hàng hoàn thành",
  "settings.webhook.event.order.cancelled": "Đơn hàng bị hủy",
  "settings.webhook.event.product.updated": "Sản phẩm được cập nhật",
  "settings.webhook.event.inventory.low_stock": "Nguyên liệu sắp hết",
  "settings.webhook.event.inventory.expiring": "Nguyên liệu sắp hết hạn",
  "settings.webhook.event.customer.created": "Khách hàng mới",
  "settings.webhook.event.payment.received": "Nhận thanh toán",

  "settings.ai.title": "Tích hợp Trợ lý ảo AI (Multi-Agent)",
  "settings.ai.switch.on": "Đang BẬT",
  "settings.ai.switch.off": "Đang TẮT",
  "settings.ai.switch.desc":
    "Khi bật, AI sẽ tự động trả lời tin nhắn thay cho Auto-reply thông thường.",
  "settings.ai.provider.label": "Mô hình ưu tiên (Primary Provider)",
  "settings.ai.provider.gemini": "Google Gemini (Khuyên dùng - Miễn phí/Rẻ)",
  "settings.ai.provider.openai": "OpenAI (GPT-4o - Thông minh hơn/Trả phí)",
  "settings.ai.failover.label": "Tự động chuyển đổi khi lỗi (Failover)",
  "settings.ai.failover.desc":
    "Nếu mô hình chính gặp lỗi (Hết quota, server lỗi), hệ thống sẽ tự động dùng mô hình còn lại.",
  "settings.ai.gemini.label": "Gemini API Key",
  "settings.ai.gemini.placeholder": "Nhập Google Gemini API Key...",
  "settings.ai.gemini.help.text": "Lấy key tại ",
  "settings.ai.gemini.help.link": "Google AI Studio",
  "settings.ai.openai.label": "OpenAI API Key",
  "settings.ai.openai.placeholder": "Nhập OpenAI API Key (sk-...)...",
  "settings.ai.openai.help.text": "Lấy key tại ",
  "settings.ai.openai.help.link": "OpenAI Dashboard",
  "settings.ai.persona.label": "Vai trò (Persona)",
  "settings.ai.persona.desc":
    'Định nghĩa tính cách của AI. Ví dụ: "Bạn là nhân viên tư vấn nhiệt tình, sử dụng nhiều emoji."',
  "settings.ai.knowledge.label": "Thông tin chung (Knowledge Base)",
  "settings.ai.knowledge.placeholder":
    "Ví dụ:\n- Wifi: CoffeeHouse / pass: 12345678\n- Giờ mở cửa: 7h - 22h\n- Địa chỉ: 123 Nguyễn Văn Linh...",
  "settings.ai.knowledge.desc":
    "AI sẽ dùng thông tin này để trả lời các câu hỏi chung của khách hàng.",
  "settings.ai.save": "Lưu cấu hình",
  "settings.ai.save-btn": "Lưu cấu hình AI",

  /* Shipping Providers */
  "settings.shipping.provider.ghn.name": "Giao Hàng Nhanh",
  "settings.shipping.provider.ghn.desc":
    "Giao hàng nhanh trong nội thành và toàn quốc",
  "settings.shipping.provider.ghtk.name": "Giao Hàng Tiết Kiệm",
  "settings.shipping.provider.ghtk.desc":
    "Giao hàng tiết kiệm chi phí toàn quốc",
  "settings.shipping.provider.viettelpost.name": "Viettel Post",
  "settings.shipping.provider.viettelpost.desc":
    "Dịch vụ bưu chính Viettel toàn quốc",
  "settings.shipping.provider.jt.name": "J&T Express",
  "settings.shipping.provider.jt.desc": "Giao hàng nhanh J&T Express",

  /* Quick Reply Settings */
  "settings.quickreply.title": "Mẫu Trả Lời Nhanh",
  "settings.quickreply.add": "Thêm mẫu",
  "settings.quickreply.empty.title": "Chưa có mẫu tin nhắn nào",
  "settings.quickreply.create-first": "Tạo mẫu đầu tiên",
  "settings.quickreply.col.title": "Tiêu đề",
  "settings.quickreply.col.content": "Nội dung",
  "settings.quickreply.col.shortcut": "Phím tắt",
  "settings.quickreply.col.category": "Danh mục",
  "settings.quickreply.col.action": "Thao tác",
  "settings.quickreply.modal.title-add": "Thêm Mẫu Tin Nhắn",
  "settings.quickreply.modal.title-edit": "Sửa Mẫu Tin Nhắn",
  "settings.quickreply.modal.label.title": "Tiêu đề *",
  "settings.quickreply.modal.placeholder.title": "VD: Cảm ơn quý khách",
  "settings.quickreply.modal.label.content": "Nội dung *",
  "settings.quickreply.modal.placeholder.content":
    "Nội dung tin nhắn sẽ được gửi...",
  "settings.quickreply.modal.label.shortcut": "Phím tắt",
  "settings.quickreply.modal.placeholder.shortcut": "VD: /thanks",
  "settings.quickreply.modal.help.shortcut":
    "Gõ phím tắt để nhanh chóng tìm mẫu",
  "settings.quickreply.modal.label.category": "Danh mục",
  "settings.quickreply.cat.general": "Chung",
  "settings.quickreply.cat.greeting": "Chào hỏi",
  "settings.quickreply.cat.thanks": "Cảm ơn",
  "settings.quickreply.cat.faq": "FAQ",
  "settings.quickreply.cat.promotion": "Khuyến mãi",
  "settings.quickreply.modal.cancel": "Hủy",
  "settings.quickreply.modal.save": "Tạo mới",
  "settings.quickreply.modal.update": "Cập nhật",
  "settings.quickreply.notify.load-error":
    "Không thể tải danh sách mẫu tin nhắn",
  "settings.quickreply.notify.input-error": "Vui lòng nhập tiêu đề và nội dung",
  "settings.quickreply.notify.update-success": "Đã cập nhật mẫu tin nhắn",
  "settings.quickreply.notify.create-success": "Đã tạo mẫu tin nhắn mới",
  "settings.quickreply.notify.save-error": "Không thể lưu mẫu tin nhắn",
  "settings.quickreply.notify.delete-confirm":
    "Bạn có chắc muốn xóa mẫu tin nhắn này?",
  "settings.quickreply.notify.delete-success": "Đã xóa mẫu tin nhắn",
  "settings.quickreply.notify.delete-error": "Không thể xóa mẫu tin nhắn",

  /* Auto Reply Settings */
  "settings.autoreply.title": "Trả Lời Tự Động",
  "settings.autoreply.add": "Thêm quy tắc",
  "settings.autoreply.empty.title": "Chưa có quy tắc trả lời tự động",
  "settings.autoreply.create-first": "Tạo quy tắc đầu tiên",
  "settings.autoreply.col.enable": "Bật",
  "settings.autoreply.col.name": "Tên quy tắc",
  "settings.autoreply.col.keyword": "Từ khóa",
  "settings.autoreply.col.response": "Trả lời",
  "settings.autoreply.col.page": "Fanpage",
  "settings.autoreply.col.match": "Đã match",
  "settings.autoreply.col.action": "Thao tác",
  "settings.autoreply.modal.title-add": "Thêm Quy Tắc Trả Lời Tự Động",
  "settings.autoreply.modal.title-edit": "Sửa Quy Tắc",
  "settings.autoreply.modal.label.name": "Tên quy tắc *",
  "settings.autoreply.modal.placeholder.name": "VD: Chào mừng khách mới",
  "settings.autoreply.modal.label.page": "Áp dụng cho Fanpage",
  "settings.autoreply.modal.option.all-pages": "Tất cả Fanpage",
  "settings.autoreply.modal.label.trigger": "Từ khóa kích hoạt",
  "settings.autoreply.modal.placeholder.trigger":
    "xin chào, hello, hi, chào (phân cách bằng dấu phẩy)",
  "settings.autoreply.modal.help.trigger":
    "Khi khách nhắn tin chứa bất kỳ từ khóa nào, bot sẽ tự động trả lời",
  "settings.autoreply.modal.label.response": "Nội dung trả lời *",
  "settings.autoreply.modal.placeholder.response":
    "Xin chào! Cảm ơn bạn đã liên hệ...",
  "settings.autoreply.modal.label.priority": "Độ ưu tiên",
  "settings.autoreply.modal.help.priority":
    "Số cao hơn = ưu tiên cao hơn (khi nhiều quy tắc khớp)",
  "settings.autoreply.modal.cancel": "Hủy",
  "settings.autoreply.modal.save": "Tạo mới",
  "settings.autoreply.modal.update": "Cập nhật",
  "settings.autoreply.test.placeholder": "Nhập tin nhắn để test auto-reply...",
  "settings.autoreply.test.button": "Test",
  "settings.autoreply.test.matched": "Matched!",
  "settings.autoreply.test.no-match": "No match",
  "settings.autoreply.test.rule": "Quy tắc:",
  "settings.autoreply.test.response": "Trả lời:",
  "settings.autoreply.notify.load-error": "Không thể tải danh sách quy tắc",
  "settings.autoreply.notify.input-error":
    "Vui lòng nhập tên và nội dung trả lời",
  "settings.autoreply.notify.update-success": "Đã cập nhật quy tắc",
  "settings.autoreply.notify.create-success": "Đã tạo quy tắc mới",
  "settings.autoreply.notify.save-error": "Không thể lưu quy tắc",
  "settings.autoreply.notify.delete-confirm":
    "Bạn có chắc muốn xóa quy tắc này?",
  "settings.autoreply.notify.delete-success": "Đã xóa quy tắc",
  "settings.autoreply.notify.delete-error": "Không thể xóa quy tắc",
  "settings.autoreply.notify.toggle-error": "Không thể thay đổi trạng thái",

  /* Upgrade Page */
  "upgrade.title": "Nâng cấp tài khoản",
  "upgrade.subtitle": "Chọn gói phù hợp với nhu cầu kinh doanh của bạn",
  "upgrade.current-package": "Đang sử dụng",
  "upgrade.expired": "Hết hạn",
  "upgrade.remaining-days": "Còn lại {days} ngày",
  "upgrade.lifetime": "Trọn đời",
  "upgrade.activated": "ĐÃ KÍCH HOẠT",
  "upgrade.renew": "GIA HẠN",
  "upgrade.downgrade": "HẠ CẤP",
  "upgrade.upgrade": "NÂNG CẤP",
  "upgrade.contact": "LIÊN HỆ",
  "upgrade.using": "ĐANG DÙNG",
  "upgrade.best-value": "Ưa chuộng nhất",

  "upgrade.feature.billing": "Tính tiền",
  "upgrade.feature.print_invoice": "In hóa đơn",
  "upgrade.feature.accounts": "Tài khoản Thu ngân, Bếp & Phục vụ",
  "upgrade.feature.sales": "Trọn bộ nghiệp vụ Quản lý bán hàng",
  "upgrade.feature.products": "Quản lý Sản phẩm",
  "upgrade.feature.materials": "Quản lý Nguyên vật liệu",
  "upgrade.feature.staff": "Quản lý và chấm công Nhân viên",
  "upgrade.feature.chain": "Quản lý nhiều chi nhánh",
  "upgrade.feature.reports": "Báo cáo doanh thu & Lợi nhuận",
  "upgrade.feature.social": "Kết nối Mạng xã hội",
  "upgrade.feature.shipping": "Kết nối Vận chuyển",
  "upgrade.feature.ecommerce": "Kết nối TikTok Shop / Shopee",
  "upgrade.feature.einvoice": "Hóa đơn điện tử",
  "upgrade.feature.api": "Tích hợp webhook / API",
  "upgrade.feature.api-limit": "Giới hạn Request API",
  "upgrade.feature.automation": "Hệ thống Automation",
  "upgrade.feature.support": "Hỗ trợ kỹ thuật & Setup",

  "upgrade.value.products.free": "30 sản phẩm",
  "upgrade.value.products.basic": "Không giới hạn",
  "upgrade.value.materials.free": "30 nguyên liệu",
  "upgrade.value.materials.basic": "Không giới hạn",
  "upgrade.value.staff.free": "2 nhân viên",
  "upgrade.value.unlimited": "Không giới hạn",
  "upgrade.value.reports.basic": "Báo cáo hôm nay",
  "upgrade.value.reports.detailed": "Báo cáo doanh thu theo thời gian",
  "upgrade.value.reports.advanced": "Báo cáo lợi nhuận chuyên sâu",
  "upgrade.value.api.limit": "30.000 / tháng",
  "upgrade.value.api.custom": "Tùy chỉnh",
  "upgrade.value.support.docs": "Tài liệu",
  "upgrade.value.support.online": "Online 24/7",
  "upgrade.value.support.priority": "Priority 1-1",

  "upgrade.package.free.title": "GÓI MIỄN PHÍ",
  "upgrade.package.basic.title": "GÓI CƠ BẢN",
  "upgrade.package.pro.title": "PRO",
  "upgrade.package.pro-auto.title": "PRO + Automation",
  "upgrade.package.enterprise.title": "GÓI ENTERPRISE",

  "upgrade.time.1m": "1 tháng",
  "upgrade.time.6m": "6 tháng",
  "upgrade.time.1y": "1 năm",
  "upgrade.time.2y": "2 năm",
  "upgrade.time.5y": "5 năm",

  "upgrade.modal.payment.title": "Thông tin chuyển khoản",
  "upgrade.modal.payment.instant-title": "Đủ điều kiện kích hoạt ngay",
  "upgrade.modal.payment.deduct-intro":
    "Tổng giá trị khấu trừ ({amount} đ) đủ để thanh toán gói cước này.",
  "upgrade.modal.payment.deduct-note":
    "Bạn không cần phải thanh toán thêm. Hệ thống sẽ kích hoạt ngay lập tức.",
  "upgrade.modal.payment.instruction":
    "Bạn hãy chọn thời gian muốn nâng cấp, sau đó chuyển khoản vào số tài khoản phía dưới, với số tiền và nội dung tương ứng. Sau khi bạn chuyển, phần mềm sẽ tự động nâng cấp ngay lập tức!",
  "upgrade.modal.payment.term": "Thời hạn:",
  "upgrade.modal.payment.scan-note": "Quét để thanh toán",
  "upgrade.modal.payment.owner": "Chủ thẻ:",
  "upgrade.modal.payment.account": "Số tài khoản:",
  "upgrade.modal.payment.bank": "Ngân hàng:",
  "upgrade.modal.payment.amount": "Số tiền:",
  "upgrade.modal.payment.content": "Nội dung:",
  "upgrade.modal.payment.remaining": "(Hạn mức còn lại)",
  "upgrade.modal.payment.wallet": "(Ví)",
  "upgrade.modal.payment.original-price": "Giá gốc:",
  "upgrade.modal.payment.total": "Còn phải trả:",
  "upgrade.modal.payment.btn-instant": "Xác nhận & Kích hoạt ngay",
  "upgrade.modal.payment.btn-submit": "Xác nhận đã thanh toán & Yêu cầu nâng cấp",
  "upgrade.modal.payment.surplus-refund": "Hoàn dư vào ví:",
  "upgrade.promo.title": "Mã khuyến mại",
  "upgrade.promo.placeholder": "Nhập mã khuyến mại",
  "upgrade.promo.apply": "Áp dụng",
  "upgrade.promo.remove": "Hủy mã",
  "upgrade.promo.btn-create": "Tạo mã mới",
  "upgrade.promo.empty": "Chưa có mã khuyến mại nào",
  "upgrade.promo.modal-create": "Tạo mã khuyến mại",
  "upgrade.promo.modal-edit": "Chỉnh sửa mã khuyến mại",
  "upgrade.promo.col-code": "Mã code",
  "upgrade.promo.col-desc": "Mô tả",
  "upgrade.promo.col-discount": "Giảm giá",
  "upgrade.promo.col-packages": "Gói áp dụng",
  "upgrade.promo.col-usage": "Đã dùng / Tối đa",
  "upgrade.promo.col-date": "Thời hạn",
  "upgrade.promo.col-status": "Trạng thái",
  "upgrade.promo.discount-type": "Loại giảm",
  "upgrade.promo.discount-value": "Giá trị",
  "upgrade.promo.max-discount": "Giảm tối đa (đ)",
  "upgrade.promo.max-uses": "Số lượt tối đa",
  "upgrade.promo.start-date": "Ngày bắt đầu",
  "upgrade.promo.end-date": "Ngày kết thúc",
  "menu.upgrade-promo": "Mã KM nâng cấp",
  "upgrade.modal.payment.manual-note":
    "Bạn chỉ cần quét mã QR để thanh toán. Sau khi thanh toán thành công, phần mềm sẽ tự động nâng cấp ngay lập tức!",

  "upgrade.modal.downgrade.title": "Xác nhận hạ cấp",
  "upgrade.modal.downgrade.intro":
    "Hệ thống sẽ chuyển đổi giá trị còn lại của gói hiện tại:",
  "upgrade.modal.downgrade.remaining-value": "Giá trị còn lại:",
  "upgrade.modal.downgrade.equivalent": "(Tương đương {days} ngày)",
  "upgrade.modal.downgrade.exchange": "Quy đổi sang gói mới:",
  "upgrade.modal.downgrade.refund": "Số tiền hoàn lại vào ví:",
  "upgrade.modal.downgrade.warning":
    "Lưu ý: Hành động này không thể hoàn tác. Gói cước mới sẽ được kích hoạt ngay lập tức.",
  "upgrade.modal.downgrade.calculating": "Đang tính toán...",
  "upgrade.modal.downgrade.cancel": "Hủy bỏ",
  "upgrade.modal.downgrade.confirm": "Xác nhận hạ cấp",
  "upgrade.modal.downgrade.ineligible": "Không đủ điều kiện (Dưới 1 tháng)",

  "upgrade.modal.success.title": "Nâng cấp thành công!",
  "upgrade.modal.success.msg": "Chúc mừng bạn đã nâng cấp thành công!",
  "upgrade.modal.success.lifetime":
    "Tài khoản của bạn đã được nâng cấp trọn đời",
  "upgrade.modal.success.new-expiry": "Hạn sử dụng mới:",
  "upgrade.modal.success.close": "Đóng",

  "profile.fullname": "Tên của bạn",
  "profile.description": "Mô tả",
  "profile.address": "Địa chỉ",
  "profile.phone": "Điện thoại",
  "profile.email": "Email",
  "profile.company-name": "Tên cửa hàng",
  "profile.company-address": "Địa chỉ cửa hàng",
  "profile.company-website": "Website",
  "profile.company-start-time": "Giờ mở cửa",
  "profile.company-end-time": "Giờ đóng cửa",
  "profile.company-menu-hash": "Menu Online",
  "profile.bankPay": "Ngân hàng",
  "profile.namePay": "Chủ tài khoản",
  "profile.numberPay": "Số tài khoản",
  "profile.update-personal": "CẬP NHẬT THÔNG TIN CÁ NHÂN",
  "profile.update-company": "CẬP NHẬT THÔNG TIN CỬA HÀNG",
  "profile.placeholder.fullname": "Ví dụ: Nguyễn Văn A",
  "profile.placeholder.description":
    "Ví dụ: Nhân viên nhiệt tình, yêu cà phê...",
  "profile.placeholder.address": "Ví dụ: 123 Nguyễn Văn A, Quận 1, TP.HCM",
  "profile.placeholder.phone": "Ví dụ: 0901 234 567",
  "profile.placeholder.email": "Ví dụ: nguyenvana@gmail.com",
  "profile.placeholder.hotline": "Ví dụ: 1900 1234",
  "profile.placeholder.website": "Ví dụ: vmass.vn",
  "profile.placeholder.bank": "Chọn ngân hàng",
  "profile.placeholder.account-name": "Ví dụ: NGUYEN VAN A",
  "profile.placeholder.account-number": "Ví dụ: 0123456789",
  "profile.business-type.cafe": "Quán cà phê, trà sữa",
  "profile.business-type.restaurant": "Nhà hàng, quán ăn",
  "profile.business-type.retail": "Bán lẻ",
  "profile.business-type.grocery": "Tạp hóa, siêu thị mini",
  "profile.business-type.pharmacy": "Nhà thuốc, dược phẩm",
  "profile.business-type.electronics": "Điện máy, công nghệ",
  "profile.business-type.spa": "Spa, thẩm mỹ viện, salon",
  "profile.business-type.fashion": "Thời trang",
  "profile.business-type.cosmetics": "Mỹ phẩm",
  "profile.business-type.unknown": "Chưa xác định",
  "profile.business-type.label": "Loại hình kinh doanh",
  "profile.payment-info.title": "THÔNG TIN THANH TOÁN",

  /* Affiliate List */
  "affiliate.col.name": "Tên",
  "affiliate.col.email": "Email",
  "affiliate.col.phone": "SĐT",
  "affiliate.col.bank": "Ngân hàng",
  "affiliate.col.status": "Trạng thái",
  "affiliate.col.date": "Ngày đăng ký",
  "affiliate.col.action": "Hành động",
  "affiliate.empty": "Chưa có dữ liệu",
  "affiliate.status.approved": "Đã duyệt",
  "affiliate.status.pending": "Chờ duyệt",
  "affiliate.status.deactivated": "Ngừng kích hoạt",

  /* Guest View & Orders */
  "guest.cart": "Giỏ hàng",
  "guest.price": "Đơn giá",
  "guest.quantity": "Số lượng",
  "guest.total": "Thành tiền",
  "guest.product": "Sản phẩm",
  "guest.total-amount": "Tổng tiền",
  "guest.payment": "Thanh toán",
  "guest.call-service": "Gọi phục vụ",
  "guest.call-service-cooldown": "Gọi lại sau {seconds}s",
  "guest.request-payment": "Yêu cầu thanh toán",
  "guest.invoice": "Hóa đơn thanh toán",

  /* Order Summary */
  "order.summary.discount": "Chiết khấu",
  "order.summary.tax": "Thuế phí",
  "order.summary.fee": "Phí khác",
  "order.summary.gift": "Quà tặng",
  "order.summary.total-payment": "Tổng tiền thanh toán",

  /* Product Management Tools */
  "product.tooltip.category":
    'Là danh mục cha của sản phẩm này. Ví dụ: Danh mục "Cà phê" là danh mục cha của sản phẩm "Cà phê sữa đá".',
  "product.tooltip.price":
    'Giá này là giá bán ra của sản phẩm nếu như "Giá khuyến mãi" không được tick chọn.',
  "product.tooltip.topping":
    'Là nơi để nhập các "sản phẩm phụ" với sản phẩm này và giá tiền tương ứng được cộng thêm vào giá bán.',
  "product.tooltip.ice":
    "Tick chọn 5 ô để khách hàng/người gọi sản phẩm có thể chọn Lượng đá của sản phẩm.",
  "product.tooltip.sugar":
    "Tick chọn 5 ô để khách hàng/người gọi sản phẩm có thể chọn Độ ngọt của sản phẩm.",
  /* Recipe Builder */
  "recipe.unit.default": "Cái, hộp, gói...",
  "recipe.unit.cafe": "Ly, cốc, đĩa...",
  "recipe.unit.fashion": "Cái, chiếc, bộ, đôi...",
  "recipe.unit.cosmetics": "Lọ, chai, tuýp...",
  "recipe.unit.retail": "Cái, gói, hộp, kg...",
  "recipe.unit.grocery": "Cái, gói, hộp, kg...",
  "recipe.unit.pharmacy": "Hộp, vỉ, viên, tuýp...",
  "recipe.unit.electronics": "Cái, chiếc, bộ, thùng...",
  "recipe.unit.spa": "Lượt, buổi, liệu trình...",
  "recipe.unit.generic": "đơn vị",
  "recipe.title": "Định lượng nguyên liệu",
  "recipe.count-badge": "nguyên liệu",
  "recipe.empty-state":
    'Chưa có nguyên liệu nào. Nhấn "Thêm nguyên liệu" để bắt đầu.',
  "recipe.label.name": "Tên nguyên liệu",
  "recipe.placeholder.select": "Chọn hoặc tạo mới...",
  "recipe.create-label": 'Tạo mới "{val}"',
  "recipe.label.usage": "SL sử dụng",
  "recipe.label.total": "Thành tiền",
  "recipe.btn.delete": "Xóa dòng này",
  "recipe.btn.delete-tooltip": "Xóa nguyên liệu",
  "recipe.new-stock.title": "Nhập kho nguyên liệu mới:",
  "recipe.label.unit": "Đơn vị",
  "recipe.label.import-qty": "SL Nhập",
  "recipe.label.cost-price": "Giá vốn",
  "recipe.unit.per-unit": " / đơn vị",
  "recipe.label.paid": "Đã trả",
  "recipe.label.provider": "Nhà Cung Cấp",
  "recipe.create-provider": 'Tạo "{val}"',
  "recipe.label.debt": "Còn nợ",
  "recipe.btn.add": "Thêm nguyên liệu",
  "recipe.footer.total-cost": "Tổng giá vốn:",
  "recipe.footer.expected-profit": "Lợi nhuận dự kiến:",

  "product.name": "Tên sản phẩm",
  "product.price": "Giá bán",
  "product.promotion-price": "Giá khuyến mãi",
  "product.price.cost": "Giá vốn",
  "product.image": "Hình ảnh",
  "label.enter-barcode": "Nhập mã vạch",
  "label.enter-product-name": "Nhập tên sản phẩm",
  "stock.unit": "Đơn vị tính",
  "label.select-or-create": "Chọn hoặc tạo mới...",
  "label.create-new": "Tạo mới",
  "label.select-create-provider": "Chọn hoặc tạo nhà cung cấp...",
  "unit.placeholder.default": "Cái, hộp, gói...",
  "unit.placeholder.cafe": "Ly, cốc, đĩa...",
  "unit.placeholder.fashion": "Cái, chiếc, bộ, đôi...",
  "unit.placeholder.cosmetics": "Lọ, chai, tuýp...",
  "unit.placeholder.retail": "Cái, gói, hộp, kg...",
  "unit.placeholder.grocery": "Cái, gói, hộp, kg...",
  "unit.placeholder.pharmacy": "Hộp, vỉ, viên, tuýp...",
  "unit.placeholder.electronics": "Cái, chiếc, bộ, thùng...",
  "unit.placeholder.spa": "Lượt, buổi, liệu trình...",
  "modal.stock.stt": "STT",
  "modal.product.unit": "Định lượng",
  "modal.product.combo": "Combo",
  "product.edit_cost": "Sửa định lượng",
  "tooltip.enable-combo": "Bật chế độ Combo/Định lượng",
  "modal.product.variant": "Biến thể",
  "tooltip.not-for-combo": "Không áp dụng cho hàng Combo",
  "modal.stock.supplier": "Nhà cung cấp",
  "modal.product.paid": "Đã trả",
  "modal.stock.remaining": "Còn nợ",
  "modal.product.image": "Hình ảnh",
  "tooltip.unit-hint": "Nhập đơn vị tính cho sản phẩm",
  "warehouse.import-quantity": "Số lượng nhập",

  "product.add-title": "Thêm sản phẩm",
  "product.import-excel": "Nhập từ Excel",
  "product.import-image": "Nhập từ hình ảnh",
  "product.notify.stock-success": "Tạo nguyên liệu mới thành công",
  "product.sku": "Mã SKU",
  "product.barcode": "Barcode",
  "product.stock-count": "Tồn kho",

  "breakeven.title": "Điểm hòa vốn",
  "breakeven.period.day": "Ngày",
  "breakeven.period.month": "Tháng",
  "breakeven.period.quarter": "Quý",
  "breakeven.period.year": "Năm",
  "breakeven.fallback.active":
    "Đang dùng dữ liệu ước tính từ kỳ trước hoặc danh mục SP",
  "breakeven.fallback.inactive":
    "Bật để dùng dữ liệu ước tính khi không có đơn hàng",
  "breakeven.fallback.has-data":
    "Đang có dữ liệu thực tế trong kỳ, không cần dùng dữ liệu ước tính",
  "breakeven.fixed-costs.title": "Chi Phí Cố Định (VNĐ)",
  "breakeven.fixed-costs.rent": "Tiền thuê mặt bằng",
  "breakeven.fixed-costs.salary": "Lương nhân viên cố định",
  "breakeven.fixed-costs.depreciation": "Khấu hao thiết bị",
  "breakeven.fixed-costs.management": "Quản lý & Marketing",
  "breakeven.fixed-costs.other": "Chi phí cố định khác",
  "breakeven.product.title": "Thông Tin Sản Phẩm",
  "breakeven.product.price": "Giá bán trung bình/SP",
  "breakeven.product.variable-cost": "Giá vốn trung bình/SP",
  "breakeven.product.profit-margin": "Biên lợi nhuận %",
  "breakeven.product.price.tooltip.no-data":
    "Chưa có đơn hàng trong kỳ nên chưa thể tính giá bán trung bình",
  "breakeven.product.variable-cost.tooltip.no-data":
    "Chỉ số này được tính dựa trên sản phẩm đã bán",
  "breakeven.product.profit-margin.tooltip.no-data":
    "Cần có giá bán và giá vốn để tính biên lợi nhuận",
  "breakeven.product.profit-margin.tooltip.desc":
    "Biên lợi nhuận = (Giá bán - Giá vốn) / Giá bán × 100%",
  "breakeven.loading": "Đang tải dữ liệu...",
  "breakeven.empty.title": "Chưa thể tính điểm hòa vốn",
  "breakeven.empty.desc":
    "Cần có ít nhất 1 đơn hàng trong kỳ để xác định biên lợi nhuận thực tế.",
  "breakeven.empty.sub": "Sẽ xuất hiện sau khi có đơn hàng đầu tiên.",
  "breakeven.result.fixed-cost": "Tổng chi phí cố định",
  "breakeven.result.revenue": "Doanh thu hiện tại",
  "breakeven.result.gross-profit": "Lãi gộp hiện tại",
  "breakeven.result.sold-quantity": "Số lượng đã bán",
  "breakeven.result.breakeven-units": "Số lượng hòa vốn",
  "breakeven.result.breakeven-revenue": "Doanh thu hòa vốn",
  "breakeven.table.title": "Bảng Chi Tiết Phân Tích Lợi Nhuận",
  "breakeven.table.volume": "Số Lượng",
  "breakeven.table.revenue": "Doanh Thu",
  "breakeven.table.variable-cost": "CP Biến Đổi",
  "breakeven.table.fixed-cost": "CP Cố Định",
  "breakeven.table.total-cost": "Tổng CP",
  "breakeven.table.profit": "Lợi Nhuận",
  "breakeven.error.price-invalid": "Giá bán trung bình phải lớn hơn 0.",
  "breakeven.error.cost-invalid": "Chi phí biến đổi không được âm.",
  "breakeven.error.margin-invalid":
    "Giá bán phải lớn hơn chi phí biến đổi đơn vị.",
  "breakeven.error.fetch-fail": "Không thể lấy dữ liệu",
  "breakeven.error.connect-fail": "Lỗi kết nối: ",
  "breakeven.chart.title": "Biểu Đồ Phân Tích Điểm Hòa Vốn",
  "breakeven.chart.revenue": "Doanh thu (TR)",
  "breakeven.chart.total-cost": "Tổng chi phí (TC)",
  "breakeven.chart.fixed-cost": "Chi phí cố định (FC)",
  "breakeven.chart.x-axis": "Số lượng sản phẩm (Q)",
  "breakeven.chart.y-axis": "Giá trị (VNĐ)",
  "profile.validate.required":
    "Hãy bổ sung đầy đủ thông tin được đánh dấu * để phần mềm có thể hoạt động được tốt nhất!",
  "profile.success": "Thành công",
  "profile.error": "Có lỗi xảy ra, vui lòng thử lại.",
  "company-uuid": "Mã định danh",

  "upgrade.notify.payment-received":
    "Đã nhận thanh toán {amount}đ từ {gateway}",
  "upgrade.notify.success":
    "Nâng cấp tài khoản thành công! Vui lòng kiểm tra lại hạn sử dụng.",

  /* Navigation Tabs */
  "settings.nav.general": "Cài đặt chung",
  "settings.nav.invoice": "Cài đặt hóa đơn",
  "settings.nav.social": "Kết nối mạng xã hội",
  "settings.nav.shipping": "Kết nối vận chuyển",
  "settings.nav.staff": "Cài đặt nhân viên",
  "settings.nav.customer": "Cài đặt khách hàng",
  "settings.nav.ecommerce": "Kết nối sàn TMĐT",
  "settings.nav.einvoice": "Hóa đơn điện tử",
  "settings.nav.apikeys": "API Keys",
  "settings.nav.webhooks": "Webhooks",
  "settings.nav.email": "Cấu hình Email",
  "settings.nav.ai": "Trợ lý AI",

  /* Notifications & Confirms */
  "settings.notification.no-data": "Không có dữ liệu",
  "settings.notification.saved": "Đã lưu cấu hình!",
  "settings.notification.error": "Có lỗi xảy ra",
  "settings.social.fb.disconnect-success": "Đã ngắt kết nối Fanpage!",
  "settings.social.fb.disconnect-error": "Lỗi khi ngắt kết nối Fanpage",
  "settings.social.fb.confirm-disconnect":
    "Bạn có chắc muốn ngắt kết nối Fanpage này?",
  "settings.social.zalo.disconnect-success": "Đã ngắt kết nối Zalo OA!",
  "settings.social.zalo.disconnect-error": "Lỗi khi ngắt kết nối Zalo OA",
  "settings.social.zalo.confirm-disconnect":
    "Bạn có chắc muốn ngắt kết nối Zalo OA này?",
  "settings.ecommerce.shopee.connect-error": "Lỗi khi kết nối Shopee",
  "settings.ecommerce.shop.disconnect-success": "Đã ngắt kết nối Shop!",
  "settings.ecommerce.shop.disconnect-error": "Lỗi khi ngắt kết nối Shop",
  "settings.ecommerce.shop.confirm-disconnect":
    "Bạn có chắc muốn ngắt kết nối Shop này?",
  "settings.ecommerce.tiktok.connect-error": "Lỗi khi kết nối TikTok Shop",
  "settings.ecommerce.tiktok.disconnect-success":
    "Đã ngắt kết nối TikTok Shop!",
  "settings.ecommerce.tiktok.disconnect-error":
    "Lỗi khi ngắt kết nối TikTok Shop",
  "settings.ecommerce.product-import-success": "Đã import sản phẩm!",
  "settings.ecommerce.product-import-error": "Lỗi khi import sản phẩm",
  "settings.ecommerce.order-sync-success": "Đã đồng bộ đơn hàng!",
  "settings.ecommerce.order-sync-error": "Lỗi khi đồng bộ đơn hàng",
  "settings.einvoice.save-success": "Đã lưu cấu hình hóa đơn điện tử!",
  "settings.einvoice.save-error": "Lỗi lưu cấu hình hóa đơn điện tử",
  "settings.email.save-success": "Đã lưu cấu hình email thành công!",
  "settings.email.save-error": "Lỗi lưu cấu hình email",
  "settings.email.test-success": "Đã gửi email test thành công!",
  "settings.email.test-error": "Lỗi gửi email test",

  /* Social Settings (Zalo) */
  "settings.zalo.title": "Zalo Official Account",
  "settings.zalo.guide": "Hướng dẫn",
  "settings.zalo.guide.title": "Cách kết nối Zalo OA:",
  "settings.zalo.guide.step1": "Nhấn nút 'Kết nối Zalo OA mới'",
  "settings.zalo.guide.step2": "Đăng nhập Zalo (nếu cần)",
  "settings.zalo.guide.step3": "Chọn OA bạn muốn kết nối",
  "settings.zalo.guide.step4": "Cấp quyền cho ứng dụng",
  "settings.zalo.guide.step5": "Hoàn tất!",
  "settings.zalo.desc":
    "Kết nối Zalo OA để nhận và trả lời tin nhắn khách hàng từ Zalo.",
  "settings.zalo.upgrade-warning":
    "Bạn cần nâng cấp lên gói Basic để kết nối Zalo OA.",
  "settings.zalo.upgrade-btn": "Nâng cấp ngay",
  "settings.zalo.connect-locked": "Kết nối Zalo OA mới (Yêu cầu gói Basic)",
  "settings.zalo.connect-btn": "Kết nối Zalo OA mới",
  "settings.zalo.loading": "Đang tải...",
  "settings.zalo.no-oa": "Chưa có Zalo OA nào được kết nối.",
  "settings.zalo.table.name": "Tên Zalo OA",
  "settings.zalo.table.id": "OA ID",
  "settings.zalo.table.date": "Ngày kết nối",
  "settings.zalo.table.action": "Thao tác",
  "settings.zalo.disconnect-btn": "Ngắt kết nối",

  /* Ecommerce Settings (Shopee/TikTok) */
  "settings.ecommerce.shopee.guide": "Hướng dẫn",
  "settings.ecommerce.shopee.guide.title": "Cách kết nối Shopee:",
  "settings.ecommerce.shopee.guide.step1": "Nhấn nút 'Kết nối Shop mới'",
  "settings.ecommerce.shopee.guide.step2": "Đăng nhập Shopee (nếu cần)",
  "settings.ecommerce.shopee.guide.step3": "Chọn Shop bạn muốn kết nối",
  "settings.ecommerce.shopee.guide.step4": "Cấp quyền cho ứng dụng",
  "settings.ecommerce.shopee.guide.step5": "Hoàn tất!",
  "settings.ecommerce.shopee.desc":
    "Kết nối Shopee để đồng bộ đơn hàng, sản phẩm và tồn kho.",
  "settings.ecommerce.upgrade-warning":
    "Bạn cần nâng cấp lên gói Basic để kết nối.",
  "settings.ecommerce.connect-locked": "Kết nối Shop mới (Yêu cầu gói Basic)",
  "settings.ecommerce.connect-btn": "Kết nối Shop mới",
  "settings.ecommerce.loading": "Đang tải...",
  "settings.ecommerce.no-shop": "Chưa có Shop nào được kết nối.",
  "settings.ecommerce.table.name": "Tên Shop",
  "settings.ecommerce.table.id": "Shop ID",
  "settings.ecommerce.table.region": "Khu vực",
  "settings.ecommerce.table.date": "Ngày kết nối",
  "settings.ecommerce.table.action": "Thao tác",
  "settings.ecommerce.action.syncing": "Đang đồng bộ...",
  "settings.ecommerce.action.import-product": "Import sản phẩm",
  "settings.ecommerce.action.sync-order": "Đồng bộ đơn hàng",
  "settings.ecommerce.action.disconnect": "Ngắt kết nối",
  "settings.ecommerce.tiktok.guide": "Hướng dẫn",
  "settings.ecommerce.tiktok.guide.title": "Cách kết nối TikTok Shop:",
  "settings.ecommerce.tiktok.desc":
    "Kết nối TikTok Shop để đồng bộ đơn hàng, sản phẩm và tồn kho.",

  /* E-Invoice Settings */
  "settings.einvoice.title": "Cấu hình hóa đơn điện tử",
  "settings.einvoice.upgrade-warning":
    "Bạn cần nâng cấp lên gói Pro để sử dụng tính năng Hóa đơn điện tử.",
  "settings.einvoice.provider": "Nhà cung cấp HĐĐT",
  "settings.einvoice.vat-rate": "Thuế suất VAT mặc định (%)",
  "settings.einvoice.api-info": "Thông tin đăng nhập API",
  "settings.einvoice.username": "Tên đăng nhập",
  "settings.einvoice.password": "Mật khẩu",
  "settings.einvoice.company-info": "Thông tin doanh nghiệp",
  "settings.einvoice.tax-id": "Mã số thuế",
  "settings.einvoice.company-name": "Tên công ty",
  "settings.einvoice.address": "Địa chỉ",
  "settings.einvoice.phone": "Số điện thoại",
  "settings.einvoice.email": "Email",
  "settings.einvoice.series": "Ký hiệu hóa đơn",
  "settings.einvoice.bank-info": "Thông tin ngân hàng (tùy chọn)",
  "settings.einvoice.bank-account": "Số tài khoản",
  "settings.einvoice.bank-name": "Tên ngân hàng",
  "settings.einvoice.save-btn": "Lưu cấu hình",
  "settings.einvoice.saving": "Đang lưu...",
  "settings.einvoice.api-url": "URL API",
  "settings.einvoice.api-url-help":
    "Dùng Test để thử nghiệm, Production khi đi vào hoạt động thực tế",
  "settings.einvoice.signing-method": "Phương thức ký hóa đơn",
  "settings.einvoice.sign-type": "Loại ký số",
  "settings.einvoice.sign-type-help":
    "USB Token (thủ công), HSM (tự động server), eSign (ký từ xa qua CA)",
  "settings.einvoice.esign-config": "Cấu hình eSign nâng cao",
  "settings.einvoice.esign-provider": "Nhà cung cấp CA",
  "settings.einvoice.esign-username": "Tên đăng nhập eSign",
  "settings.einvoice.esign-password": "Mật khẩu eSign",
  "settings.einvoice.esign-serial": "Số serial chứng thư",
  "settings.einvoice.test-connection": "Kiểm tra kết nối",
  "settings.einvoice.testing": "Đang kiểm tra...",
  "settings.einvoice.test-success": "Kết nối thành công!",
  "settings.einvoice.test-fail": "Không thể kết nối đến server",
  "settings.ai.saving-btn": "Đang lưu...",
  "settings.ai.notification.success": "Đã lưu cấu hình AI Agent thành công!",
  "settings.ai.notification.error": "Có lỗi xảy ra khi lưu cấu hình",
  "settings.ai.notification.success-title": "Thành công",
  "settings.ai.notification.error-title": "Lỗi",
  "facebook.go-to-messenger": "Vào Chat",

  "warehouse.transfer-search": "Tìm tên Phiếu chuyển kho",
  "warehouse.transfer": "Phiếu chuyển kho",
  "warehouse.transfer-stock": "Mặt hàng chuyển",
  "warehouse.transfer-title": "Cập nhật phiếu chuyển kho",
  "warehouse.transfer-name": "Tên người chuyển kho",
  "warehouse.transfer-quantity": "Số lượng chuyển",
  "warehouse.transfer-price": "Giá chuyển",

  /* Inventory Audit */
  "audit.title": "Kiểm kho và điều chỉnh chênh lệch tồn kho",
  "audit.button.create": "Tạo phiên kiểm kho",
  "audit.modal.detail.title": "Chiết tiết phiên kiểm kho",
  "audit.date": "Ngày kiểm",
  "audit.status": "Trạng thái",
  "audit.note": "Ghi chú",
  "audit.table.stock": "Nguyên liệu",
  "audit.table.system": "Hệ thống",
  "audit.table.actual": "Thực tế",
  "audit.table.discrepancy": "Chênh lệch",
  "audit.table.reason": "Lý do",
  "audit.total-discrepancy": "Tổng giá trị chênh lệch",
  "audit.button.continue": "Tiếp tục kiểm kho",
  "audit.status.completed": "Hoàn thành",
  "audit.status.pending": "Đang kiểm",

  /* Stock Return */
  "return.title": "Hoàn hàng về nhà cung cấp",
  "return.button.create": "Tạo phiếu hoàn hàng",
  "return.modal.detail.title": "Chi tiết phiếu hoàn hàng",
  "return.date": "Ngày hoàn",
  "return.status": "Trạng thái",
  "return.reason": "Lý do",
  "return.table.stock": "Nguyên liệu",
  "return.table.quantity": "Số lượng",
  "return.table.price": "Đơn giá",
  "return.table.provider": "Nhà cung cấp",
  "return.table.total": "Thành tiền",
  "return.total-value": "Tổng giá trị",
  "return.status.completed": "Hoàn thành",
  "return.status.pending": "Đang xử lý",

  /* Stock Disposal */
  "disposal.title": "Tiêu hủy nguyên liệu hết hạn, hư hỏng",
  "disposal.button.create": "Tạo phiếu tiêu hủy",
  "disposal.modal.detail.title": "Chi tiết phiếu tiêu hủy",
  "disposal.date": "Ngày tiêu hủy",
  "disposal.type": "Loại",
  "disposal.status": "Trạng thái",
  "disposal.type.expired": "Hết hạn sử dụng",
  "disposal.type.damaged": "Hư hỏng",
  "disposal.type.other": "Khác",
  "disposal.status.completed": "Hoàn thành",
  "disposal.status.pending": "Chờ duyệt",
  "disposal.status.rejected": "Từ chối",
  "disposal.table.stock": "Nguyên liệu",
  "disposal.table.quantity": "Số lượng",
  "disposal.table.unit": "ĐVT",
  "disposal.table.provider": "NCC",
  "disposal.table.refundable": "Hoàn tiền",
  "disposal.table.price": "Đơn giá",
  "disposal.table.total": "Thành tiền",
  "disposal.table.reason": "Lý do",
  "disposal.total": "Tổng cộng",
  "disposal.button.close": "Đóng",
  "disposal.refundable.yes": "Có",
  "disposal.refundable.no": "Không",

  /* Invoice (Order) */
  "invoice.title": "Hóa đơn",
  "invoice.tab.info": "Hóa đơn bán hàng",
  "invoice.tab.deleted": "Đã hủy",
  "invoice.empty": "Chưa có dữ liệu...",
  "invoice.menu.restore": "Phục hồi hóa đơn",
  "invoice.menu.destroy": "Xóa vĩnh viễn",
  "invoice.badge.id": "Mã hoá đơn",
  "invoice.badge.no-print": "Chưa in hoá đơn",
  "invoice.discount": "Chiết khấu",
  "invoice.tax": "Thuế",
  "invoice.fee": "Phụ phí",
  "invoice.no-permission": "Bạn không có quyền sử dụng tính năng này!",
  "invoice.confirm.destroy": "Bạn chắc chắn muốn xóa vĩnh viễn hóa đơn này?",
  "invoice.success.restore": "Phục hồi hóa đơn thành công",
  "invoice.error.unknown": "Có lỗi không xác định xảy ra.",

  /* Home Page (Dashboard) */
  "home.wizard.title": "Thiết lập cài đặt ban đầu",
  "home.warning.add-product": "Vui lòng thêm sản phẩm đầu tiên của bạn",
  "home.warning.update-info": "Vui lòng cập nhật thông tin cửa hàng",
  "home.warning.update-payment": "Vui lòng cập nhật thông tin tin thanh toán",
  "home.warning.dismiss-template": "Bạn đang xem dữ liệu mẫu. Vui lòng ẩn hoặc xóa dữ liệu mẫu khi bắt đầu sử dụng thực tế",
  "home.warning.dismiss-btn": "Ẩn dữ liệu mẫu",
  "home.warning.dismiss-confirm": "Bạn có chắc chắn muốn ẩn toàn bộ dữ liệu mẫu không?",
  "home.warning.dismiss-success": "Đã ẩn dữ liệu mẫu thành công!",
  "home.warning.here": "tại đây",
  "home.status-order": "Trạng thái đơn hàng",
  "home.btn.order-preview": "Xem đơn hàng",
  "home.table.title-orders": "CÁC SẢN PHẨM ĐANG ĐẶT",
  "home.table.title-adjust": "ĐIỀU CHỈNH ĐƠN HÀNG",
  "home.btn.save-provisional": "Lưu tạm",
  "home.btn.provisional-invoice": "Hóa đơn lưu tạm",
  "home.btn.return-order": "Trả hàng",

  "home.header.product": "Tên sản phẩm",
  "home.header.quantity": "Số lượng",
  "home.header.price": "Đơn giá",
  "home.header.total": "Thành tiền",
  "home.header.delete": "Xóa",
  "home.empty": "Chưa có sản phẩm nào được đặt!",
  "home.summary.total": "Tổng số tiền",
  "home.summary.discount": "Chiết khấu",
  "home.summary.tax": "Thuế phí",
  "home.summary.fee-other": "Phí khác",
  "home.summary.shipping": "Phí vận chuyển",
  "home.summary.payment-total": "Số tiền cần thanh toán",
  "home.shipping.ghn": "Giao Hàng Nhanh",
  "home.shipping.ghtk": "Giao Hàng Tiết Kiệm",
  "home.shipping.viettelpost": "Viettel Post",
  "home.shipping.vnpost": "VN Post",
  "home.shipping.ahamove": "Ahamove",
  "home.shipping.lalamove": "Lalamove",
  "home.shipping.grabexpress": "GrabExpress",
  "home.shipping.shopeexpress": "Shopee Xpress",
  "home.shipping.jtexpress": "J&T Express",
  "home.shipping.ninjavan": "Ninja Van",
  "home.shipping.bestexpress": "BEST Express",
  "home.shipping.kerryexpress": "Kerry Express",
  "home.summary.customer-pay": "Tiền khách đưa",
  "home.summary.refund": "Tiền trả lại khách",
  "home.summary.missing": "Còn thiếu",
  "home.order.ice": "Đá",
  "home.order.sugar": "Độ ngọt",

  "home.placeholder.customer-name": "Tên khách hàng",
  "home.placeholder.phone": "Số điện thoại",
  "home.btn.complete-adjust": "Hoàn tất điều chỉnh",
  "home.tooltip.missing-amount":
    'Số tiền còn thiếu sẽ được ghi nhận vào "Công nợ của khách hàng". Hãy điền tên và số điện thoại của khách hàng vào ô dưới.',
  "home.tooltip.done-pay":
    'Khi tick vào ô này. Tổng hoá đơn sẽ được ghi nhận vào "Công nợ của khách hàng". Hãy điền tên và số điện thoại của khách hàng vào ô dưới.',
  "home.tooltip.discount": "Số tiền này sẽ được trừ với ô Tổng số tiền.",
  "home.tooltip.tax-fee": "Số tiền này sẽ được cộng với ô Tổng số tiền.",
  "home.tooltip.fee-other": "Số tiền này sẽ được cộng với ô Tổng số tiền.",
  "home.notify.no-products": "Chưa đặt sản phẩm. Thêm ít nhất 1 sản phẩm",
  "general.loading": "Đang tải...",
  "general.done": "Xong",
  "general.not-yet": "Chưa xong",
  "general.error.title": "Lỗi !",
  "home.btn.close": "Đóng",
  "home.btn.order": "Đặt hàng (F9)",
  "home.btn.payment": "Hoàn tất thanh toán! (F9)",
  "home.btn.print-provisional": "In tạm tính (F8)",
  "home.btn.calculating": "Đang tính...",

  "home.alert.call-payment": "Khách gọi thanh toán!",
  "home.alert.call-service": "Khách gọi phục vụ!",
  "home.alert.stock-warning": "Cảnh báo nguyên liệu sắp hết",
  "home.notify.no-order-discount": "Chưa có đơn hàng nào để áp dụng chiết khấu",
  "home.notify.open-menu-print":
    'Vui lòng mở menu "Khác" để in hóa đơn tạm tính',
  "home.notify.no-order-print": "Chưa có đơn hàng nào để in",
  "home.notify.no-payment-btn": "Không tìm thấy nút thanh toán",
  "home.notify.no-order-pay": "Chưa có đơn hàng nào để thanh toán",
  "home.notify.save-not-supported": "Chức năng lưu tạm chưa được hỗ trợ",
  "home.notify.no-order-save": "Chưa có đơn hàng nào để lưu tạm",
  "home.notify.scan-success": "Quét mã thành công",
  "home.notify.updated": "Đã cập nhật",
  "home.notify.success": "Thành công",
  "home.notify.update-failed": "Cập nhật thất bại",
  "home.notify.error": "Lỗi !",
  "home.notify.no-permission": "Bạn không có quyền sử dụng tính năng này!",
  "general.setting": "Cài đặt",
  "general.error.invalid-data": "Dữ liệu không hợp lệ",
  "home.summary.no-info": "Chưa có thông tin",
  "home.summary.no-setup": "chưa thiết lập",
  "home.summary.no-data": "Chưa có dữ liệu...",
  "home.btn.save-all": "Lưu tất cả thay đổi",
  "home.notify.transfer-success": "Chuyển bàn thành công",
  "home.notify.transfer-failed": "Chuyển bàn thất bại",
  "home.notify.save-error":
    "Đã xảy ra lỗi khi lưu thông tin chiết khấu/thuế/phí",
  "home.notify.status-error": "Có lỗi xảy ra khi cập nhật trạng thái đơn hàng.",

  /* Shortcuts */
  "home.shortcut.f1": "Mở trang hướng dẫn",
  "home.shortcut.f2": "Tìm kiếm sản phẩm",
  "home.shortcut.f3": "Quản lý sản phẩm",
  "home.shortcut.f4": "Chiết khấu / Thuế / Phí",
  "home.shortcut.f8": "In hóa đơn tạm tính",
  "home.shortcut.f9": "Đặt hàng / Thanh toán",
  "home.shortcut.f10": "Lưu hóa đơn tạm",
  "home.shortcut.title": "Phím tắt",
  "home.shortcut.close": "Bấm ESC để đóng",

  /* Provisional Invoice (Drafts) */
  "home.provisional.title": "Hóa đơn lưu tạm",
  "home.provisional.empty": "Chưa có hóa đơn nào được lưu!",
  "home.provisional.btn-reorder": "ĐẶT LẠI",
  "home.provisional.btn-cancel": "HỦY",
  "home.provisional.counter": "Quầy thu ngân",

  /* Order History & Return */
  "home.history.title": "Tra cứu lịch sử đơn hàng",
  "home.history.search": "Tra cứu",
  "home.history.empty": "Không có đơn hàng nào trong khoảng thời gian đã chọn.",
  "home.history.loading": "Đang tải dữ liệu...",
  "home.history.error": "Đã xảy ra lỗi khi tải dữ liệu. Vui lòng thử lại.",
  "home.history.invoice": "Hóa đơn",
  "home.history.sku": "Mã sản phẩm",
  "home.history.btn-return": "Trả hàng",
  "home.history.confirm-return": "Bạn chắc chắn muốn trả mặt hàng này?",
  "home.history.return-success": "Trả hàng và khôi phục kho thành công.",

  /* Common Labels & Options */
  "home.label.product-name": "Tên sản phẩm",
  "home.label.quantity": "Số lượng",
  "home.label.price": "Đơn giá",
  "home.label.total": "Tổng tiền",
  "home.label.delete": "Xóa",
  "home.label.customer-name": "Tên khách hàng",
  "home.label.phone": "Số điện thoại",
  "home.btn.order-now": "Đặt ngay !",
  "home.msg.preview-detail": "Chi tiết xem trước",

  "home.option.payment.cash": "Tiền mặt",
  "home.option.payment.transfer": "Chuyển khoản",
  "home.option.payment.card": "Thẻ tín dụng",
  "home.option.payment.credit": "Công nợ",
  "home.option.shipping.select": "Vận chuyển",
  "home.placeholder.staff": "Nhân viên",
  "home.placeholder.shipping": "Vận chuyển",
  "home.placeholder.payment": "Phương thức thanh toán",

  /* Analytics */
  "analytics.tabs.overview": "Tổng quan",
  "analytics.tabs.products": "Sản phẩm",
  "analytics.tabs.materials": "Nguyên vật liệu",
  "analytics.tabs.customers": "Khách hàng",
  "analytics.tabs.staff": "Nhân viên",
  "analytics.tabs.debt": "Nhà cung cấp",
  "analytics.tabs.payment": "Thanh toán",
  "analytics.tabs.other": "Khác",

  "analytics.summary.total_products": "Tổng sản phẩm",
  "analytics.summary.products_with_variants": "Sản phẩm có biến thể",
  "analytics.summary.products_on_sale": "Đang giảm giá",
  "analytics.summary.products_without_recipe": "Chưa định lượng",
  "analytics.summary.unsold_products_count": "Sản phẩm chưa bán",
  "analytics.summary.avg_profit_margin": "Tỷ lệ lợi nhuận TB",
  "analytics.summary.total_materials": "Tổng NVL trong kho",
  "analytics.summary.low_stock": "Còn dưới 20% | 10%",
  "analytics.summary.unassigned_materials": "Chưa định lượng",
  "analytics.summary.total_inventory_value": "Tổng giá trị tồn kho",
  "analytics.summary.import_value": "Giá trị nhập hàng",
  "analytics.summary.import_count": "Số lần nhập hàng",
  "analytics.summary.total_new_customers": "Khách mới",
  "analytics.summary.total_returning_customers": "Khách quay lại",
  "analytics.summary.total_spent": "Tổng chi tiêu",
  "analytics.summary.avg_spent_per_customer": "Giá trị TB/KH",
  "analytics.summary.customer_debt": "Công nợ",
  "analytics.summary.return_rate": "Tỷ lệ quay lại",
  "analytics.summary.total_sales": "Tổng doanh số",
  "analytics.summary.total_bills": "Tổng số đơn",
  "analytics.summary.total_items": "Tổng sản phẩm",
  "analytics.summary.avg_revenue_per_hour": "Doanh thu TB/giờ",
  "analytics.summary.active_staff": "Đang làm việc",

  "analytics.table.top_selling": "TOP SẢN PHẨM BÁN CHẠY",
  "analytics.table.top_slow": "TOP SẢN PHẨM BÁN CHẬM",
  "analytics.table.payment_method": "PHƯƠNG THỨC THANH TOÁN",

  "analytics.error.agency": "Có lỗi xảy ra khi lấy dữ liệu ĐẠI LÝ",
  "analytics.error.activity": "Có lỗi xảy ra khi lấy dữ liệu HOẠT ĐỘNG",
  "analytics.error.outcome": "Có lỗi xảy ra khi lấy dữ liệu PHIẾU CHI",
  "analytics.error.income": "Có lỗi xảy ra khi lấy dữ liệu PHIẾU THU",
  "analytics.error.sold_products":
    "Có lỗi xảy ra khi lấy dữ liệu SẢN PHẨM ĐÃ BÁN",
  "analytics.error.material_import":
    "Có lỗi xảy ra khi lấy dữ liệu NGUYÊN LIỆU NHẬP",
  "analytics.error.debt": "Có lỗi xảy ra khi lấy dữ liệu CÔNG NỢ",
  "analytics.error.material_usage":
    "Có lỗi xảy ra khi lấy dữ liệu NGUYÊN LIỆU SỬ DỤNG",
  "analytics.error.table": "Có lỗi xảy ra khi lấy dữ liệu TỪNG BÀN",
  "analytics.error.payment_method":
    "Có lỗi xảy ra khi lấy dữ liệu PHƯƠNG THỨC THANH TOÁN",
  "analytics.error.top_products": "Có lỗi xảy ra khi lấy dữ liệu TOP SẢN PHẨM",
  "analytics.error.best_selling":
    "Có lỗi xảy ra khi lấy dữ liệu SẢN PHẨM BÁN CHẠY",
  "analytics.error.customer": "Có lỗi xảy ra khi lấy dữ liệu KHÁCH HÀNG",
  "analytics.error.staff": "Có lỗi xảy ra khi lấy dữ liệu NHÂN VIÊN",
  "analytics.error.booking": "Có lỗi xảy ra khi lấy dữ liệu BOOKING",
  "analytics.error.materials": "Có lỗi xảy ra khi lấy dữ liệu Nguyên vật liệu",
  "analytics.dashboards.outcome": "PHIẾU CHI",
  "analytics.dashboards.income": "PHIẾU THU",
  "analytics.dashboards.stock-log": "LỊCH SỬ NHẬP KHO",
  "analytics.dashboards.make-product": "LỊCH SỬ SẢN XUẤT",
  "analytics.dashboards.order-table": "THỐNG KÊ BÀN",
  "analytics.dashboards.debt": "CÔNG NỢ",
  "analytics.chart.income": "Doanh thu",
  "analytics.chart.outcome": "Chi phí",
  "analytics.filter.my_store": "Cửa hàng của tôi",
  "analytics.filter.all": "Tất cả",
  "analytics.filter.today": "Hôm nay",
  "analytics.upgrade.notification":
    "Gói cước hiện tại của bạn chỉ được xem báo cáo ngày hiện tại. Vui lòng nâng cấp để xem lịch sử!",
  "analytics.upgrade.title": "Giới hạn gói cước",
  "analytics.profit": "Lợi nhuận",
  "analytics.imported-stock-quantity": "Lượng hàng đã nhập",
  "analytics.total-stock-value": "Tổng giá trị hàng hóa",
  "analytics.pnl.title": "Báo cáo Lãi/Lỗ Chi Tiết",
  "analytics.pnl.revenue-header": "💰 DOANH THU",
  "analytics.pnl.sales-revenue": "Doanh thu bán hàng",
  "analytics.pnl.gross-revenue": "Doanh thu gộp",
  "analytics.pnl.discount": "(-) Chiết khấu",
  "analytics.pnl.tax": "(+) Thuế",
  "analytics.pnl.other-fees": "(+) Phí khác",
  "analytics.pnl.other-income": "Doanh thu khác",
  "analytics.pnl.total-revenue": "TỔNG DOANH THU",
  "analytics.pnl.cost-header": "📉 CHI PHÍ",
  "analytics.pnl.cogs": "Giá vốn hàng bán",
  "analytics.pnl.material-cost": "Chi phí nguyên vật liệu",
  "analytics.pnl.gross-profit": "Lãi gộp",
  "analytics.pnl.operating-expenses": "Chi phí hoạt động",
  "analytics.pnl.fixed-costs": "Chi phí cố định (Điện, nước, nhân sự...)",
  "analytics.pnl.gift-cost": "🎁 Chi phí quà tặng khuyến mãi",
  "analytics.pnl.total-expenses": "TỔNG CHI PHÍ",
  "analytics.pnl.net-profit": "💰 LỢI NHUẬN RÒNG",
  "analytics.pnl.net-loss": "📉 LỖ RÒNG",

  "analytics.table.stt": "STT",
  "analytics.table.name": "Tên",
  "analytics.table.quantity": "Số lượng",
  "analytics.table.total": "Tổng",
  "analytics.table.price": "Đơn giá",
  "analytics.table.product": "Sản phẩm",
  "analytics.table.sold_quantity": "SL bán",
  "analytics.table.revenue": "Doanh thu",
  "analytics.table.cogs": "Giá vốn",
  "analytics.table.profit": "Lợi nhuận",
  "analytics.table.ratio": "Tỷ lệ",
  "analytics.table.material": "Nguyên liệu",
  "analytics.table.stock": "Tồn kho",
  "analytics.table.total_import": "Tổng nhập",
  "analytics.table.value": "Giá trị",
  "analytics.table.remaining": "Còn lại",
  "analytics.table.gift": "Quà tặng",
  "analytics.table.discount": "Chiết khấu",
  "analytics.table.method": "Phương thức",
  "analytics.table.order_count": "Số đơn",
  "analytics.table.product_count": "Số sản phẩm",
  "analytics.table.total_amount": "Tổng tiền",
  "analytics.table.stock_status.critical": "Nguy hiểm",
  "analytics.table.stock_status.warning": "Sắp hết",
  "analytics.table.stock_status.normal": "Bình thường",
  "analytics.table.unit_price": "Đơn giá",

  "analytics.export.stt": "STT",
  "analytics.export.name": "Tên",
  "analytics.export.quantity": "Số lượng",
  "analytics.export.total": "Tổng",

  "analytics.staff.rank": "Rank",
  "analytics.staff.name": "Nhân viên",
  "analytics.staff.position": "Chức vụ",
  "analytics.staff.sales": "Doanh số",
  "analytics.staff.bill_count": "Số đơn",
  "analytics.staff.product_count": "Số sản phẩm",
  "analytics.staff.revenue_per_hour": "Doanh thu/h",
  "analytics.staff.commission": "Hoa hồng",
  "analytics.staff.bonus": "Thưởng",
  "analytics.staff.overtime": "Tăng ca (h)",
  "analytics.staff.advance": "Tiền ứng",
  "analytics.staff.fined": "Phạt",
  "analytics.staff.no_data": "Không có dữ liệu nhân viên",
  "analytics.staff.top": "🏆 Top",

  "analytics.booking.title": "Thống kê đặt bàn",
  "analytics.booking.summary.total": "Tổng booking",
  "analytics.booking.summary.pending": "Chờ xác nhận",
  "analytics.booking.summary.confirmed": "Đã xác nhận",
  "analytics.booking.summary.completed": "Hoàn thành",
  "analytics.booking.summary.cancelled": "Đã hủy",
  "analytics.booking.summary.guests": "Tổng khách",
  "analytics.booking.source.phone": "Điện thoại",
  "analytics.booking.source.walk_in": "Đến trực tiếp",
  "analytics.booking.source.website": "Website",
  "analytics.booking.source.app": "Ứng dụng",
  "analytics.booking.source.facebook": "Facebook",
  "analytics.booking.source.zalo": "Zalo",
  "analytics.booking.table.stt": "#",
  "analytics.booking.table.date": "Ngày",
  "analytics.booking.table.time": "Giờ",
  "analytics.booking.table.customer": "Khách hàng",
  "analytics.booking.table.phone": "SĐT",
  "analytics.booking.table.party_size": "Số người",
  "analytics.booking.table.status": "Trạng thái",
  "analytics.booking.table.source": "Nguồn",
  "analytics.booking.table.no_data": "Không có dữ liệu đặt bàn",

  "analytics.customer.name": "Khách hàng",
  "analytics.customer.phone": "SĐT",
  "analytics.customer.order_count": "Số đơn",
  "analytics.customer.products_purchased": "Sản phẩm đã mua",
  "analytics.customer.total_spent": "Chi tiêu",
  "analytics.customer.point": "Điểm",
  "analytics.customer.debt": "Công nợ",
  "analytics.customer.created_at": "Thời gian tạo",
  "analytics.customer.no_data": "Không có dữ liệu",

  "chat.permission_denied": "Bạn không có quyền sử dụng tính năng này!",
  "chat.internal_msg": "Tin nhắn cửa hàng",
  "chat.search_placeholder": "Tìm kiếm",
  "chat.max_files_error": "Tối đa 3 tệp tin được cho phép",
  "chat.no_file_guest_error": "Không hỗ trợ gửi file cho khách",
  "chat.file_size_error": "Kích thước tối đa 100 MB / tệp",

  "chat.facebook.messenger": "Tin nhắn Facebook",
  "chat.facebook.syncing": "Đang tải tin nhắn từ Facebook...",
  "chat.facebook.synced_success": "Đã đồng bộ {count} cuộc hội thoại",
  "chat.facebook.sync_failed": "Đồng bộ thất bại",
  "chat.facebook.sync_error": "Lỗi khi tải tin nhắn",
  "chat.facebook.all_pages": "Tất cả Fanpage",
  "chat.facebook.customer": "Khách hàng",
  "chat.facebook.no_messages": "Chưa có cuộc hội thoại nào",
  "chat.facebook.no_messages_hint": "Tin nhắn từ khách hàng sẽ hiển thị tại đây",
  "chat.facebook.outside_24h": "Ngoài 24h - Chọn Message Tag để gửi:",
  "chat.facebook.select_tag": "-- Chọn Tag --",
  "chat.facebook.tag.human_agent": "Hỗ trợ khách hàng (7 ngày)",
  "chat.facebook.tag.post_purchase": "Cập nhật đơn hàng",
  "chat.facebook.tag.account_update": "Thông báo tài khoản",
  "chat.facebook.tag.event_update": "Cập nhật sự kiện",
  "chat.facebook.send": "Gửi",
  "chat.facebook.send_file_error": "Không thể gửi tin nhắn",
  "chat.facebook.sync_btn": "Làm mới",
  "chat.facebook.processing": "Đang tải...",
  "chat.facebook.search_customer": "Tìm kiếm khách hàng...",
  "chat.facebook.send_error": "Không thể gửi file",
  "chat.facebook.token_expired_title": "⚠️ Token Facebook đã hết hạn! Tin nhắn không thể gửi/nhận.",
  "chat.facebook.token_reconnect_btn": "Kết nối lại Facebook",

  // Facebook Comments Module
  "fb.comment.tab": "Bình luận Facebook",
  "fb.comment.status-replied": "Đã phản hồi",
  "fb.comment.filter-all": "Tất cả",
  "fb.comment.filter-unread": "Chưa đọc",
  "fb.comment.filter-unreplied": "Chưa trả lời",
  "fb.comment.no-pages-desc": "Bạn chưa kết nối Fanpage nào. Vui lòng kết nối Fanpage tại tab Facebook để sử dụng tính năng quản lý bình luận.",
  "fb.comment.sync-posts": "Tải bài viết",
  "fb.comment.syncing": "Đang tải dữ liệu...",
  "fb.comment.synced": "Cập nhật bài viết thành công!",
  "fb.comment.loading-posts": "Đang tải bài viết...",
  "fb.comment.no-posts": "Chưa có bài viết nào",
  "fb.comment.no-posts-hint": "Dữ liệu đang được tự động tải từ Fanpage",
  "fb.comment.loading-comments": "Đang tải bình luận...",
  "fb.comment.no-comments": "Chưa có bình luận nào",
  "fb.comment.select-post": "Chọn một bài viết để xem bình luận",
  "fb.comment.post-detail": "Chi tiết bài viết",
  "fb.comment.view-on-fb": "Xem trên Facebook",
  "fb.comment.like": "Thích",
  "fb.comment.reply": "Trả lời",
  "fb.comment.hide": "Ẩn",
  "fb.comment.unhide": "Hiện",
  "fb.comment.hidden": "Đã ẩn",
  "fb.comment.reply-placeholder": "Nhập phản hồi...",
  "fb.comment.edit": "Chỉnh sửa",
  "fb.comment.delete": "Xóa",
  "fb.comment.filter-all": "Tất cả",
  "fb.comment.filter-unread": "Chưa đọc",
  "fb.comment.filter-unreplied": "Chưa trả lời",
  "fb.comment.status-replied": "Đã trả lời",
  "fb.comment.loading-posts": "Đang tải bài viết...",
  "fb.comment.no-pages-desc": "Chưa có Fanpage nào được kết nối với VMASS. Vui lòng sử dụng mã truy cập (Token) Fanpage để bắt đầu quản lý bình luận.",
  "fb.comment.unknown": "Ẩn danh",
  "fb.comment.page-badge": "Fanpage",
  "fb.comment.unread": "Chưa đọc",
  "fb.comment.error-hide": "Không thể ẩn bình luận",
  "fb.comment.error-delete": "Không thể xóa bình luận",
  "fb.comment.error-edit": "Không thể sửa bình luận",
  "fb.comment.error-like": "Không thể thích bình luận",
  "fb.comment.error-sync": "Lỗi đồng bộ dữ liệu",
  "fb.comment.delete-confirm": "Bạn có chắc chắn muốn xóa bình luận này?",

  "topnav.search.placeholder.default": "Tìm kiếm...",
  "topnav.search.placeholder.dashboard": "Tìm kiếm sản phẩm...",
  "topnav.search.placeholder.product": "Tìm sản phẩm...",
  "topnav.search.placeholder.stock": "Tìm nguyên liệu...",
  "topnav.search.placeholder.customer": "Tìm khách hàng...",
  "topnav.search.placeholder.order": "Tìm đơn hàng...",
  "topnav.search.placeholder.staff": "Tìm nhân viên...",
  "topnav.search.placeholder.promotion": "Tìm khuyến mãi...",
  "topnav.search.placeholder.provider": "Tìm nhà cung cấp...",
  "topnav.search.placeholder.income": "Tìm phiếu thu...",
  "topnav.search.placeholder.outcome": "Tìm phiếu chi...",
  "topnav.search.placeholder.cash-flow": "Tìm phiếu thu, phiếu chi...",
  "topnav.search.placeholder.treasury": "Tìm tài sản...",
  "topnav.search.placeholder.warehouse_export": "Tìm phiếu xuất kho...",
  "topnav.search.placeholder.warehouse_import": "Tìm phiếu nhập kho...",
  "topnav.search.placeholder.warehouse_transfer": "Tìm phiếu chuyển kho...",
  "topnav.search.placeholder.todo": "Tìm công việc...",

  "topnav.menu.account": "Tài khoản",
  "topnav.menu.cashier": "Thu ngân",
  "topnav.menu.waiter": "Chạy bàn",
  "topnav.menu.kitchen": "Bếp / Pha chế",
  "topnav.menu.settings": "Cài đặt",
  "topnav.menu.logout": "Đăng xuất",

  "topnav.noti.todo.message": "Kiểm tra 'Việc cần làm' ngay bây giờ",
  "topnav.noti.todo.title": "Lời nhắc",
  "topnav.noti.order.message": "Có sản phẩm mới được đặt. Nhận ngay!",
  "topnav.noti.stock_down.message": "Mức nguyên liệu xuống thấp!",
  "topnav.noti.stock_down.title": "Đề xuất mua thêm",

  "page.heading.excel": "Excel",
  "page.heading.add_from_image": "Thêm sản phẩm từ hình ảnh",
  "page.heading.create_quantitative": "Tạo định lượng",
  "page.heading.add_bulk": "Thêm sản phẩm hàng loạt",
  "page.heading.add_quantitative_one": "Tạo định lượng",
  "page.heading.best_seller": "Khuyên dùng",
  "page.heading.un_best_seller": "Bỏ khuyên dùng",
  "page.heading.mark_best_seller": "Đánh dấu khuyên dùng",
  "page.heading.soft_hide_mixed": "Ẩn/Hiện sản phẩm",
  "page.heading.soft_hide_show": "Hiện sản phẩm",
  "page.heading.soft_hide_hide": "Ẩn sản phẩm",
  "page.heading.print_sticker": "In tem",
  "page.heading.import_excel_title": "Nhập dữ liệu từ file excel",
  "page.heading.import_result": "Kết quả Import",
  "page.heading.import_btn": "Import",
  "page.heading.error.limit":
    "Gói cước hiện tại của bạn đã đạt giới hạn sản phẩm. Vui lòng nâng cấp để thêm mới!",
  "page.heading.error.limit_title": "Giới hạn gói cước",

  "product.confirm.delete":
    "Bạn có chắc chắn muốn xóa những sản phẩm này không?",
  "product.error.invalid-data": "Dữ liệu không hợp lệ",
  "product.error.variant-required": "Biến thể yêu cầu giá và số lượng",

  "product.multi.name": "Tên sản phẩm",
  "product.multi.barcode": "Barcode",
  "product.multi.sku": "SKU",
  "product.multi.unit": "Đơn vị",
  "product.multi.category": "Danh mục",
  "product.multi.hot": "Hot",
  "product.multi.price": "Giá bán",
  "product.multi.price_sale": "Giá KM",
  "product.multi.active_sale": "Bật KM",
  "product.multi.recipe": "Định lượng",
  "product.multi.variant": "Biến thể",
  "product.multi.image": "Hình ảnh",
  "product.multi.soft_hide": "Ẩn",

  "product.variant.default": "Thuộc tính mặc định",
  "product.variant.coming_soon": "Sắp bắt đầu từ {date}",
  "product.variant.starts_from": "Bắt đầu từ {date}",
  "product.variant.name": "Tên biến thể",
  "product.variant.sku": "SKU",
  "product.variant.price": "Giá bán",
  "product.variant.stock": "Tồn kho",
  "product.variant.promo_time": "Thời gian KM",
  "product.variants": "Biến thể",

  "customer.export.stt": "Stt",
  "customer.export.name": "Tên khách hàng",
  "customer.export.phone": "Số điện thoại",
  "customer.export.email": "Email",
  "customer.export.address": "Địa chỉ",
  "customer.export.used": "Số lần sử dụng",
  "customer.export.point": "Số điểm",
  "customer.export.armorial": "Huy hiệu",
  "customer.export.tags": "Tags",
  "customer.export.debt": "Công nợ",
  "customer.export.total_spent": "Tổng chi tiêu",
  "customer.export.created_at": "Ngày SD đầu tiên",
  "customer.export.updated_at": "Ngày cập nhật",
  "customer.export.filename": "Danh sách khách hàng",

  "stock.export.stt": "Stt",
  "stock.export.id": "ID",
  "stock.export.name": "Tên nguyên liệu",
  "stock.export.sku": "SKU",
  "stock.export.unit": "Đơn vị",
  "stock.export.category": "Danh mục",
  "stock.export.warehouse": "Kho",
  "stock.export.min_stock_threshold": "Tồn tối thiểu",
  "stock.export.batch_code": "Mã lô",
  "stock.export.storage_location": "Vị trí lưu kho",
  "stock.export.stock_note": "Ghi chú nhập kho",
  "stock.export.price_new": "Giá nhập",
  "stock.export.inventory": "Tồn kho",
  "stock.export.total": "Tổng tiền",
  "stock.export.created_at": "Ngày tạo",
  "stock.export.updated_at": "Ngày cập nhật",
  "stock.export.filename": "Danh sách Nguyên vật liệu",

  "income.export.stt": "Stt",
  "income.export.name": "Tên phiếu thu",
  "income.export.value": "Giá trị",
  "income.export.address": "Địa chỉ",
  "income.export.note": "Mô tả",
  "income.export.created_at": "Ngày tạo",
  "income.export.statistic": "Thống kê",
  "income.statistic.exclude": "Không đưa vào thống kê",
  "income.statistic.include": "Đưa vào thống kê",
  "income.export.creator": "Người tạo",
  "income.export.filename": "Danh sách Phiếu thu",

  "outcome.export.stt": "Stt",
  "outcome.export.name": "Tên phiếu chi",
  "outcome.export.value": "Giá trị",
  "outcome.export.address": "Địa chỉ",
  "outcome.export.note": "Mô tả",
  "outcome.export.created_at": "Ngày tạo",
  "outcome.export.statistic": "Thống kê",
  "outcome.statistic.exclude": "Không đưa vào thống kê",
  "outcome.statistic.include": "Đưa vào thống kê",
  "outcome.export.creator": "Người tạo",
  "outcome.export.filename": "Danh sách Phiếu chi",

  "todo.export.filename": "Danh sách công việc",
  "page.heading.excel.tooltip": "Tải dữ liệu về file Excel",
  "analytics.export.product": "Sản phẩm",
  "analytics.export.revenue": "Doanh thu",
  "analytics.export.method": "Phương thức",
  "analytics.export.order_count": "Số đơn",
  "analytics.export.supplier": "Nhà cung cấp",
  "analytics.export.customer": "Khách hàng",
  "analytics.export.phone": "SĐT",
  "analytics.export.spent": "Chi tiêu",
  "analytics.export.created_at": "Thời gian tạo",
  "analytics.export.material": "Nguyên liệu",
  "analytics.export.unit": "Đơn vị",
  "analytics.export.table": "Bàn",
  "analytics.export.discount": "Giảm giá",
  "analytics.export.stock": "Tồn kho",
  "analytics.export.min_stock": "Tồn tối thiểu",
  "analytics.export.date": "Ngày",
  "analytics.export.time": "Giờ",
  "analytics.export.party_size": "Số người",
  "analytics.export.status": "Trạng thái",
  "analytics.export.source": "Nguồn",
  "analytics.export.sheet.sold_products": "Sản phẩm bán",
  "analytics.export.sheet.top_spenders": "KH chi tiêu cao",
  "analytics.export.sheet.imported_materials": "NL nhập",
  "analytics.export.sheet.used_materials": "NL sử dụng",
  "analytics.export.sheet.booking": "Đặt bàn",
  "analytics.export.success": "Xuất file Excel thành công!",

  /* AI Configuration */
  "settings.ai.default_persona":
    "Bạn là nhân viên hỗ trợ khách hàng thân thiện.",

  /* Upgrade */
  "upgrade.price.currency": "{price} đ",
  "pricing.title": "Bảng giá phần mềm quản lý bán hàng",
  "pricing.subtitle":
    "Lựa chọn gói phù hợp với quy mô kinh doanh của bạn. Bạn có thể thay đổi gói, nâng cấp, hạ cấp bất cứ lúc nào.",
  "pricing.support.title": "Bạn cần hỗ trợ?",
  "pricing.support.desc":
    "Liên hệ với chúng tôi để được tư vấn gói phù hợp với nhu cầu của bạn",
  "pricing.btn.home": "Trang chủ",
  "pricing.btn.zalo": "Chat Zalo",
  "pricing.footer.copyright": "© {year} VMASS - Phần mềm quản lý bán hàng",

  "upgrade.feature.billing": "Tính tiền",
  "upgrade.feature.print_invoice": "In hóa đơn",
  "upgrade.feature.accounts": "Tài khoản nhân viên",
  "upgrade.feature.sales": "Quản lý bán hàng",
  "upgrade.feature.products": "Sản phẩm & Tồn kho",
  "upgrade.feature.materials": "Quản lý Nguyên vật liệu",
  "upgrade.feature.staff": "Quản lý và chấm công Nhân viên",
  "upgrade.feature.chain": "Quản lý nhiều chi nhánh",
  "upgrade.feature.reports": "Báo cáo doanh thu & Lợi nhuận",
  "upgrade.feature.social": "Kết nối Mạng xã hội",
  "upgrade.feature.shipping": "Kết nối Vận chuyển",
  "upgrade.feature.ecommerce": "Kết nối TikTok Shop / Shopee",
  "upgrade.feature.einvoice": "Hóa đơn điện tử",
  "upgrade.feature.api": "Tích hợp webhook / API",
  "upgrade.feature.api-limit": "Giới hạn Request API",
  "upgrade.feature.automation": "Hệ thống Automation",
  "upgrade.feature.support": "Hỗ trợ kỹ thuật & Setup",

  "upgrade.value.products.free": "30 sản phẩm",
  "upgrade.value.products.basic": "Không giới hạn",
  "upgrade.value.unlimited": "Không giới hạn",
  "upgrade.value.materials.free": "30 nguyên liệu",
  "upgrade.value.materials.basic": "Không giới hạn",
  "upgrade.value.staff.free": "2 nhân viên",
  "upgrade.value.reports.basic": "Báo cáo hôm nay",
  "upgrade.value.reports.detailed": "Báo cáo doanh thu theo thời gian",
  "upgrade.value.reports.advanced": "Báo cáo lợi nhuận chuyên sâu",
  "upgrade.value.api.limit": "30.000 / tháng",
  "upgrade.value.api.custom": "Tùy chỉnh",
  "upgrade.value.support.docs": "Tài liệu",
  "upgrade.value.support.online": "Online 24/7",
  "upgrade.value.support.priority": "Priority 1-1",

  "upgrade.package.free.title": "GÓI MIỄN PHÍ",
  "upgrade.package.basic.title": "GÓI CƠ BẢN",
  "upgrade.package.pro.title": "PRO",
  "upgrade.package.pro_auto.title": "PRO + Automation",
  "upgrade.package.enterprise.title": "GÓI ENTERPRISE",

  "upgrade.btn.try": "DÙNG THỬ NGAY",
  "upgrade.btn.register": "ĐĂNG KÝ NGAY",
  "upgrade.btn.contact": "LIÊN HỆ TƯ VẤN",
  "upgrade.tag.popular": "Ưa chuộng nhất",
  "upgrade.price.sub.month": "đ/tháng",

  "upgrade.time.1m": "1 Tháng",
  "upgrade.time.6m": "6 Tháng",
  "upgrade.time.1y": "1 Năm",
  "upgrade.time.2y": "2 Năm",
  "upgrade.time.5y": "5 Năm",

  "upgrade.features": "Tính năng",
  "make-product.select-or-create": "Chọn hoặc tạo mới",
  "make-product.unit": "Đơn vị tính",
  "make-product.no-recipe": "Sản phẩm này chưa được định lượng!",
  "make-product.cost-price": "Giá vốn (Cost)",
  "make-product.cost-ratio": "Giá vốn / Giá bán",
  "general.add": "Thêm",

  "stock.header.material_name": "Tên nguyên liệu",
  "stock.header.unit": "Đơn vị tính",
  "stock.header.total_import": "Tổng nhập",
  "stock.header.new_quantity": "Số lượng mới",
  "stock.header.inventory": "Tồn kho",
  "stock.header.below_20": "Còn dưới 20%",
  "stock.header.below_10": "Còn dưới 10%",
  "stock.header.true": "Đúng",
  "stock.header.false": "Không đúng",

  "income.header.name": "Tên phiếu thu",
  "income.header.payer": "Tên người nộp",
  "income.header.address": "Địa chỉ",
  "income.header.amount": "Số tiền",
  "income.header.description": "Mô tả",
  "income.header.status": "Tình trạng",
  "income.header.statistic": "Thống kê",
  "income.header.creator": "Người tạo phiếu",
  "income.header.created_at": "Thời gian tạo",

  "outcome.header.name": "Tên phiếu chi",
  "outcome.header.receiver": "Tên người nhận",
  "outcome.header.amount": "Số tiền",
  "outcome.header.description": "Mô tả",
  "outcome.header.address": "Địa chỉ",
  "outcome.header.status": "Trạng thái",
  "outcome.header.statistic": "Thống kê",
  "outcome.header.creator": "Người tạo",
  "outcome.header.created_at": "Thời gian tạo",

  "customer.header.name": "Tên khách hàng",
  "customer.header.phone": "Số điện thoại",
  "customer.header.email": "Email",
  "customer.header.address": "Địa chỉ",
  "customer.header.points": "Số điểm",
  "customer.header.used_count": "Số lần sử dụng",
  "customer.header.total_spent": "Tổng chi tiêu",
  "customer.header.rank": "Danh hiệu",
  "customer.header.debt": "Công nợ",
  "customer.header.created_at": "Ngày SD đầu tiên",
  "customer.header.updated_at": "Ngày cập nhật",

  "provider.header.name": "Tên nhà cung cấp",
  "provider.header.phone": "Số điện thoại",
  "provider.header.email": "Email",
  "provider.header.address": "Địa chỉ",
  "provider.header.total_import": "Tổng nhập",
  "provider.header.paid": "Đã thanh toán",
  "provider.header.remaining": "Còn lại",

  "warehouse.transfer.header.item": "Mặt hàng chuyển",
  "warehouse.transfer.header.quantity": "Số lượng chuyển",
  "warehouse.transfer.header.price": "Giá chuyển",
  "warehouse.transfer.header.description": "Mô tả",
  "warehouse.transfer.header.status": "Tình trạng",
  "warehouse.transfer.header.sender": "Tên người chuyển kho",
  "warehouse.transfer.header.phone": "Số điện thoại",
  "warehouse.transfer.header.carrier": "Tên người vận chuyển",
  "warehouse.transfer.header.carrier_phone": "Số điện thoại NVC",
  "warehouse.transfer.header.destination": "Chuyển đến kho",
  "warehouse.transfer.header.transport": "Phương tiện vận chuyển",
  "warehouse.transfer.header.shipping_cost": "Giá vận chuyển",
  "warehouse.transfer.header.creator": "Người nhập liệu",
  "warehouse.transfer.header.created_at": "Thời gian tạo",

  "warehouse.import.header.item": "Mặt hàng nhập",
  "warehouse.import.header.unit": "Đơn vị tính",
  "warehouse.import.header.quantity": "Số lượng nhập",
  "warehouse.import.header.price": "Giá nhập",
  "warehouse.import.header.status": "Tình trạng",
  "warehouse.import.header.importer": "Tên người nhập kho",
  "warehouse.import.header.phone": "Số điện thoại",
  "warehouse.import.header.address": "Địa chỉ",
  "warehouse.import.header.created_at": "Thời gian tạo",

  "warehouse.export.header.item": "Mặt hàng xuất",
  "warehouse.export.header.quantity": "Số lượng xuất",
  "warehouse.export.header.price": "Giá xuất",
  "warehouse.export.header.status": "Tình trạng",
  "warehouse.export.header.description": "Mô tả",
  "warehouse.export.header.creator": "Người nhập liệu",
  "warehouse.export.header.created_at": "Thời gian tạo",

  "treasury.header.name": "Tên tài sản",
  "treasury.header.value": "Số tiền",
  "treasury.header.note": "Mô tả",
  "treasury.header.statistic": "Thống kê",
  "treasury.header.creator": "Người tạo",
  "treasury.header.created_at": "Thời gian tạo",

  "modal.stock.stt": "STT",
  "modal.stock.sku": "Mã SKU",
  "modal.stock.barcode": "Barcode",
  "modal.stock.supplier": "Nhà cung cấp",
  "modal.stock.remaining": "Còn lại",
  "modal.stock.expired": "Hạn sử dụng",

  "table.import.sku": "Mã SKU",
  "table.import.barcode": "Barcode",
  "table.import.price_sale": "Giá bán",
  "table.import.price_promotion": "Giá khuyến mãi",
  "table.import.apply_promotion": "Áp dụng KM",
  "table.import.image": "Hình ảnh",
  "table.import.image_sub": "Hình ảnh phụ",
  "table.import.recommend": "Khuyên dùng",
  "table.import.hidden": "Ẩn sản phẩm",
  "table.import.description": "Mô tả",
  "table.import.size": "Size",
  "table.import.topping": "Topping",
  "table.import.ice": "Lượng đá",
  "table.import.sugar": "Độ ngọt",
  "table.import.color": "Màu sắc",
  "table.import.material": "Chất liệu",
  "table.import.result": "Kết quả Import",
  "table.import.reason": "Lý do lỗi",

  "modal.product.stt": "#",
  "modal.product.barcode_enter": "Barcode (Enter)",
  "modal.product.unit": "Định lượng",
  "modal.product.combo": "Combo/SX",
  "modal.product.variant": "Biến thể",
  "modal.product.supplier": "Nhà cung cấp",
  "modal.product.paid": "Đã trả",
  "modal.product.remaining": "Còn lại",
  "modal.product.image": "Hình ảnh",
  "modal.product.hot": "Hot",
  "modal.product.delete": "Xóa",
  "modal.auto-generate": "Tự động tạo",
  "modal.stock.confirm-import": "Xác nhận nhập kho",
  "modal.add-row": "Thêm dòng",
  "tooltip.not-for-combo": "Không áp dụng cho hàng Combo",
  "tooltip.unit-hint":
    "Hãy điền đơn vị tính nhỏ nhất của sản phẩm này, ví dụ dùng Gói thay vì Thùng",
  "tooltip.enable-combo":
    "Bật chế độ định lượng: Cho phép chọn nhiều nguyên liệu thành phần (Combo/SX). Giá vốn và Số lượng nhập của sản phẩm sẽ được tính theo định lượng thay vì nhập trực tiếp.",
  "label.create-new": "Tạo mới",
  "label.select-or-create": "Chọn hoặc tạo...",
  "label.enter-product-name": "Nhập tên sản phẩm...",
  "label.enter-barcode": "Nhập barcode...",
  "label.select-create-provider": "Chọn/tạo NCC...",
  "menu.product.recommended": "Sản phẩm khuyên dùng",
  "menu.product.discount": "Chiết khấu",
  "menu.product.recipe": "Định lượng",
  "menu.stock.inventory": "Tồn kho",
  "menu.stock.less-than-50": "Còn dưới 50%",
  "menu.stock.less-than-20": "Còn dưới 20%",
  "menu.stock.less-than-10": "Còn dưới 10%",
  "menu.stock.cost-price": "Giá vốn",
  "menu.stock.cost-price-done": "Đã nhập giá vốn",
  "menu.stock.cost-price-not-yet": "Chưa nhập giá vốn",
  "menu.stock.import-time": "Thời gian nhập",
  "menu.stock.recent-5-days": "5 ngày gần đây",
  "menu.stock.recent-10-days": "10 ngày gần đây",
  "todo.tasks": "Việc cần làm",
  "todo.today": "Trong ngày",
  "todo.this-week": "Trong tuần",
  "todo.this-month": "Trong tháng",
  "todo.upcoming": "Sắp diễn ra",
  "todo.next-1-hour": "Trong 1 giờ tới",
  "todo.next-3-hours": "Trong 3 giờ tới",
  "todo.next-6-hours": "Trong 6 giờ tới",
  "todo.past": "Đã diễn ra",
  "todo.past-7-days": "7 ngày trước",
  "todo.past-30-days": "30 ngày trước",
  "todo.past-6-months": "6 tháng trước",
  "chat.broadcast-all-stores": "Gửi đến tất cả cửa hàng",
  "menu.customer.debt": "Công nợ",
  "menu.customer.no-debt": "Không có công nợ",
  "menu.customer.have-debt": "Có công nợ",
  "menu.customer.badge": "Huy hiệu",
  "menu.customer.no-badge": "Chưa có huy hiệu",
  "menu.customer.bronze": "Hạng Đồng",
  "menu.customer.gold": "Hạng Vàng",
  "menu.customer.platinum": "Hạng Platinum",
  "menu.customer.tags": "Tags",
  "menu.provider.transaction": "Giao dịch",
  "menu.provider.paid-all": "Đã trả hết",
  "menu.provider.debt": "Còn nợ",
  "menu.provider.no-transaction": "Chưa có giao dịch",
  "menu.provider.products": "Mặt hàng",
  "menu.staff.work-status": "Tình trạng công việc",
  "menu.staff.working": "Đang làm",
  "menu.staff.quit": "Đã nghỉ việc",
  "menu.staff.position": "Vị trí công việc",
  "price.under-1m": "Dưới 1 triệu",
  "price.1m-to-10m": "Từ 1 triệu - 10 triệu",
  "price.over-10m": "Trên 10 triệu",
  "menu.finance.include-statistics": "Đưa vào thống kê",
  "menu.finance.price-range": "Khoảng giá",
  "menu.finance.creator": "Người nhập liệu",
  "menu.stock.status": "Trạng thái",
  "status.draft": "Nháp",
  "status.in-progress": "Đang kiểm",
  "status.completed": "Hoàn thành",
  "menu.stock.time": "Thời gian",
  "general.this-month": "Tháng này",
  "general.last-month": "Tháng trước",
  "menu.audit.result": "Kết quả",
  "menu.audit.has-discrepancy": "Có chênh lệch",
  "status.pending": "Chờ duyệt",
  "status.approved": "Đã duyệt",
  "status.rejected": "Từ chối",
  "menu.disposal.type": "Loại tiêu hủy",
  "disposal.expired": "Hết hạn",
  "disposal.damaged": "Hư hỏng",
  "menu.stock.statistics": "Thống kê",
  "menu.stock.total-tickets": "Tổng phiếu",
  "menu.stock.total-value": "Tổng giá trị",
  "status.processing": "Đang xử lý",
  "menu.warehouse.status": "Tình trạng",
  "menu.warehouse.quantity-range": "Số lượng",
  "menu.warehouse.unit": "Đơn vị tính",
  "quantity.under-10": "Dưới 10",
  "quantity.10-to-50": "Từ 10 - 50",
  "quantity.over-50": "Trên 50",

  "table.import.success": "Import thành công",
  "table.import.failed": "Thất bại",
  "table.import.error_reason": "Lý do lỗi",

  "modal.alert.min-one-material": "Vui lòng nhập ít nhất một nguyên liệu.",
  "modal.alert.check-required":
    "Vui lòng kiểm tra lại các trường bắt buộc:\n\n",
  "modal.alert.missing-unit": 'Dòng {index} - "{name}": Thiếu đơn vị',
  "modal.alert.price-must-positive":
    'Dòng {index} - "{name}": Đơn giá phải > 0',
  "modal.alert.quantity-must-positive":
    'Dòng {index} - "{name}": Số lượng nhập phải > 0',
  "modal.alert.barcode-duplicate-list":
    "Có mã Barcode bị trùng lặp trong danh sách nhập. Vui lòng kiểm tra lại.",
  "modal.alert.barcode-duplicate-db":
    'Barcode "{barcode}" đã tồn tại cho nguyên liệu "{name}". Vui lòng sử dụng mã khác.',
  "chat.all_messages": "Tất cả tin nhắn",

  "unit.placeholder.cafe": "Ly, cốc, đĩa...",
  "unit.placeholder.fashion": "Cái, chiếc, bộ, đôi...",
  "unit.placeholder.cosmetics": "Lọ, chai, tuýp...",
  "unit.placeholder.retail": "Cái, gói, hộp, kg...",
  "unit.placeholder.grocery": "Cái, gói, hộp, kg...",
  "unit.placeholder.pharmacy": "Hộp, vỉ, viên, tuýp...",
  "unit.placeholder.electronics": "Cái, chiếc, bộ, thùng...",
  "unit.placeholder.spa": "Lượt, buổi, liệu trình...",
  "unit.placeholder.default": "Cái, hộp, gói...",

  "product.price.cost": "Giá vốn",
  "product.promotion-price": "Giá khuyến mãi",

  "general.all": "Tất cả",
  "general.yes": "Có",
  "general.no": "Không",

  "modal.stock.stt": "STT",
  "modal.stock.sku": "Mã SKU",
  "modal.stock.barcode": "Mã vạch",
  "modal.stock.supplier": "Nhà cung cấp",
  "modal.stock.remaining": "Còn lại",
  "modal.stock.expired": "Hạn sử dụng",
  "modal.stock.confirm-import": "Xác nhận nhập",
  "modal.add-row": "Thêm dòng",
  "modal.auto-generate": "Tự động tạo",

  "tooltip.unit-hint": "Nhập đơn vị tính (ví dụ: kg, hộp...)",
  "tooltip.not-for-combo": "Không áp dụng cho hàng Combo",
  "tooltip.enable-combo": "Bật tính năng Combo (Định lượng)",

  "label.select-or-create": "Chọn hoặc tạo mới...",
  "label.create-new": "Tạo mới",
  "label.select-create-provider": "Chọn hoặc tạo nhà cung cấp...",
  "label.enter-barcode": "Nhập mã vạch",
  "label.enter-product-name": "Nhập tên sản phẩm",

  "modal.product.combo": "Combo",
  "modal.product.paid": "Đã trả",
  "page.heading.export-filename": "Danh sách sản phẩm",
  "product.alert.create-variant-missing-unit":
    "Vui lòng nhập Đơn vị tính trước khi tạo biến thể.",
  "product.alert.sync-stock-confirm":
    "Số lượng nhập ở form chính ({mainFormQuantity}) khác với tổng số lượng các biến thể ({totalVariantQuantity}).\n\nBạn có muốn cập nhật số lượng ở form chính thành {totalVariantQuantity} không?",
  "product.validation.missing-name": "Tên sản phẩm",
  "product.validation.missing-category": "Danh mục",
  "product.validation.missing-price": "Giá bán",
  "product.validation.missing-unit": "Đơn vị tính",
  "product.validation.missing-import-quantity": "Số lượng nhập",
  "product.validation.missing-cost-price": "Giá vốn",
  "product.validation.barcode-duplicate-list":
    'Mã vạch "{barcode}" bị trùng trong danh sách này',
  "product.validation.barcode-duplicate-system":
    'Mã vạch "{barcode}" đã tồn tại trên hệ thống',
  "product.alert.validation-check-info": "Vui lòng kiểm tra lại thông tin:\n",
  "label.create-new-value": 'Tạo "{value}"',
  "product.template.default": "Mau_Import_San_Pham.xlsx",
  "product.template.cafe": "Mau_san_pham_cafe.xlsx",
  "product.template.restaurant": "Mau_san_pham_nha_hang.xlsx",
  "product.template.fashion": "Mau_san_pham_thoi_trang.xlsx",
  "product.template.retail": "Mau_san_pham_tap_hoa.xlsx",
  "product.template.cosmetics": "Mau_san_pham_my_pham.xlsx",

  Ex: "Ví dụ",
  Example: "Ví dụ",
  Note: "Lưu ý",
  Preview: "Xem trước",
  "analytics.export.total_price": "Tổng tiền",
  "pages.print-tem": "In tem",
  "product.add-new": "Thêm mới",
  "product.title.update": "Cập nhật sản phẩm",
  "chat.files": "Tệp tin",
  "chat.filters": "Bộ lọc",
  "chat.unread_only": "Chưa đọc",
  "chat.tags": "Thẻ",
  "chat.tag_important": "Quan trọng",
  "chat.tag_pending": "Chờ xử lý",
  "chat.tag_customer": "Khách hàng",
  "chat.tag_new_lead": "Khách hàng mới",
  "chat.tag_closed": "Đóng",
  "invoice.tab.einvoice": "Hóa đơn điện tử",
  "einvoice.list.title": "Danh sách hóa đơn điện tử",
  "einvoice.status.draft": "Nháp",
  "einvoice.status.issued": "Đã phát hành",
  "einvoice.status.signed": "Đã ký",
  "einvoice.status.sent": "Đã gửi",
  "einvoice.status.cancelled": "Đã hủy",
  "einvoice.status.error": "Lỗi",
  "einvoice.status.processing": "Đang xử lý",
  "einvoice.action.view-pdf": "Xem PDF",
  "einvoice.action.download-pdf": "Tải PDF",
  "einvoice.action.send-email": "Gửi Email",
  "einvoice.action.cancel": "Hủy hóa đơn",
  "einvoice.action.check-status": "Kiểm tra trạng thái",
  "einvoice.correction.adjust": "Điều chỉnh",
  "einvoice.correction.replace": "Thay thế",
  "einvoice.correction.edit-draft": "Sửa nháp SePay",
  "einvoice.correction.modal-adjust-title": "Hóa đơn điều chỉnh SePay",
  "einvoice.correction.modal-replace-title": "Hóa đơn thay thế SePay",
  "einvoice.correction.submit": "Xác nhận gửi SePay",
  "einvoice.mapping.preview": "Preview đồng bộ VMASS",
  "einvoice.mapping.applied": "Đã áp dụng",
  "einvoice.mapping.pending": "Đang chờ áp dụng",
  "einvoice.mapping.conflict": "Xung đột, cần lập chứng từ mới",
  "einvoice.mapping.failed": "Lỗi kỹ thuật, sẽ tự thử lại",
  "einvoice.mapping.inventory": "Tồn kho theo hóa đơn",
  "einvoice.mapping.inventory-applied": "Nguyên liệu: hồi {restored}, trừ {deducted} lượt; biến thể: hồi {variantsRestored}, trừ {variantsDeducted}",
  "einvoice.correction.save-draft": "Lưu nháp tại SePay",
  "einvoice.correction.issue-now": "Phát hành ngay",
  "einvoice.action.issue-official": "Phát hành chính thức",
  "einvoice.action.reissue": "Phát hành lại",
  "einvoice.cancel.reason": "Lý do hủy",
  "einvoice.email.placeholder": "Nhập email nhận hóa đơn",
  "einvoice.alert.cancel-confirm":
    "Bạn có chắc chắn muốn hủy hóa đơn này không?",
  "einvoice.alert.email-success": "Đã gửi email thành công!",
  "einvoice.action.edit": "Sửa hóa đơn",
  "einvoice.edit.title": "Sửa thông tin hóa đơn",
  "einvoice.edit.customer-name": "Tên đơn vị / Người mua",
  "einvoice.edit.email": "Email nhận hóa đơn",
  "einvoice.edit.payment-method": "Hình thức thanh toán",
  "einvoice.edit.note": "Ghi chú",
  "einvoice.edit.placeholder.customer-name": "Tên công ty hoặc họ tên khách hàng",
  "einvoice.edit.placeholder.tax-id": "Mã số thuế doanh nghiệp",
  "einvoice.edit.placeholder.address": "Địa chỉ doanh nghiệp",
  "einvoice.edit.placeholder.email": "email@company.com",
  "einvoice.edit.placeholder.phone": "Số điện thoại nhận hóa đơn",
  "einvoice.edit.placeholder.note": "Ghi chú trên hóa đơn",
  "button.save-changes": "Lưu thay đổi",
  "einvoice.notification.status-updated": "Đã cập nhật trạng thái",
  "einvoice.notification.email-required": "Vui lòng nhập email",
  "einvoice.notification.cancel-reason-required": "Vui lòng nhập lý do hủy",
  "einvoice.notification.cancel-success": "Đã hủy hóa đơn",
  "einvoice.notification.issue-official-success": "Đã phát hành hóa đơn chính thức",
  "einvoice.notification.customer-name-required": "Vui lòng nhập tên khách hàng/đơn vị",
  "einvoice.notification.update-success": "Đã cập nhật thông tin hóa đơn",
  "einvoice.notification.missing-contact-info": "Hóa đơn thiếu Email và Số điện thoại. Vui lòng chọn 'Sửa hóa đơn' để bổ sung trước khi phát hành lại.",

  /* Table Headers - E-Invoice */
  "table.invoice-no": "Số hóa đơn",
  "table.customer": "Khách hàng",
  "table.date": "Ngày",
  "table.total": "Tổng tiền",
  "table.status": "Trạng thái",
  "table.action": "Thao tác",
  "table.no-data": "Không có dữ liệu",
  "button.refresh": "Làm mới",
  "button.cancel": "Hủy",
  "einvoice.checkbox.issue": "Phát hành hóa đơn điện tử",
  "einvoice.success.issued": "Đã phát hành hóa đơn điện tử thành công",
  "einvoice.error.issue-failed": "Lỗi phát hành hóa đơn điện tử",
  "settings.einvoice.sepay-client-id": "Client ID",
  "settings.einvoice.sepay-client-secret": "Client Secret",
  "settings.einvoice.sepay-template-code": "Mẫu số hóa đơn",
  "settings.einvoice.automation": "Cấu hình tự động",
  "settings.einvoice.auto-issue":
    "Luôn tick vào checkbox Phát hành hóa đơn (Mặc định: Tắt)",
  "settings.einvoice.auto-draft":
    "Luôn phát hành hóa đơn bản nháp khi không chọn phát hành (Mặc định: Bật)",
  "settings.email.placeholder.gmail-email": "Nhập Gmail",
  "settings.email.placeholder.smtp-email": "Nhập Email SMTP",
  "settings.einvoice.title": "Hóa đơn điện tử",
  "settings.einvoice.save-success": "Đã lưu cấu hình thành công",
  "settings.einvoice.save-error": "Lỗi lưu cấu hình",
  "settings.einvoice.test-success": "Kết nối thành công",
  "settings.einvoice.test-fail": "Kết nối thất bại",
  "settings.email.save-success": "Đã lưu cấu hình email thành công",
  "settings.email.save-error": "Lỗi lưu cấu hình email",
  "settings.email.test-success": "Đã gửi email thử nghiệm thành công",
  "settings.email.test-error": "Lỗi gửi email thử nghiệm",
  "table.phone": "SĐT",
  "table.address": "Địa chỉ",
  "table.email": "Email",
  "table.discount": "Chiết khấu",
  "table.payment_method": "TT Thanh toán",
  "table.note": "Ghi chú",
  "table.tax": "MST",
  /* Shopee Management Page */
  "menu.ecommerce": "Thương mại điện tử",
  "menu.shopee": "Shopee",
  "menu.tiktok-shop": "TikTok Shop",
  "menu.lazada": "Lazada",
  "menu.tiki": "Tiki",
  "ecommerce.coming-soon": "Sắp ra mắt",
  "ecommerce.coming-soon-desc": "Tính năng này đang được phát triển. Chúng tôi sẽ sớm hỗ trợ nền tảng này!",
  "shopee.tab.connection": "Kết nối",
  "shopee.tab.orders": "Đơn hàng",
  "shopee.tab.products": "Sản phẩm",
  "shopee.tab.inventory": "Tồn kho",
  "shopee.connection.title": "Kết nối Shop Shopee",
  "shopee.connection.desc": "Kết nối shop Shopee để đồng bộ đơn hàng, sản phẩm và tồn kho.",
  "shopee.connect.btn": "Kết nối Shop mới",
  "shopee.connect.error": "Lỗi kết nối Shopee",
  "shopee.disconnect.btn": "Ngắt kết nối",
  "shopee.disconnect.confirm": "Bạn có chắc chắn muốn ngắt kết nối shop này?",
  "shopee.disconnect.success": "Đã ngắt kết nối shop thành công",
  "shopee.disconnect.error": "Lỗi ngắt kết nối shop",
  "shopee.oauth.success": "Đã kết nối shop Shopee thành công.",
  "shopee.oauth.error.missing-params": "Shopee không trả về đủ thông tin xác thực.",
  "shopee.oauth.error.invalid-state": "Phiên kết nối Shopee không hợp lệ hoặc đã hết hạn. Vui lòng thử lại.",
  "shopee.oauth.error.not-configured": "Hệ thống chưa được cấu hình thông tin Shopee Partner.",
  "shopee.oauth.error.shop-already-connected": "Shop Shopee này đang được kết nối với một tài khoản VMASS khác.",
  "shopee.oauth.error.callback-failed": "Không thể hoàn tất kết nối Shopee. Vui lòng thử lại.",
  "shopee.oauth.error.upgrade-required": "Cần nâng cấp gói dịch vụ để sử dụng tích hợp Shopee.",
  "shopee.oauth.error.generic": "Shopee từ chối yêu cầu kết nối. Vui lòng thử lại.",
  "shopee.no-shop": "Chưa kết nối shop Shopee nào. Nhấn 'Kết nối Shop mới' để bắt đầu.",
  "shopee.select-shop": "Chọn shop",
  "shopee.table.name": "Tên Shop",
  "shopee.table.id": "Mã Shop",
  "shopee.table.region": "Khu vực",
  "shopee.table.token-expires": "Trạng thái Token",
  "shopee.table.connected": "Ngày kết nối",
  "shopee.token.expired": "Hết hạn",
  "shopee.token.active": "Hoạt động",
  "shopee.orders.filter.all": "Tất cả trạng thái",
  "shopee.orders.sync-btn": "Đồng bộ từ Shopee",
  "shopee.orders.bulk-sync": "Đồng bộ tất cả vào VMASS",
  "shopee.orders.sync.error": "Lỗi đồng bộ đơn hàng từ Shopee",
  "shopee.orders.sync-to-bill": "Đồng bộ vào VMASS",
  "shopee.orders.sync-bill.error": "Lỗi đồng bộ đơn hàng vào hệ thống",
  "shopee.orders.load.error": "Lỗi tải đơn hàng",
  "shopee.orders.empty": "Không có đơn hàng. Nhấn 'Đồng bộ từ Shopee' để lấy đơn.",
  "shopee.orders.col.sn": "Mã đơn",
  "shopee.orders.col.status": "Trạng thái",
  "shopee.orders.col.buyer": "Người mua",
  "shopee.orders.col.amount": "Tổng tiền",
  "shopee.orders.col.date": "Ngày tạo",
  "shopee.orders.col.synced": "Đã đồng bộ",
  "shopee.synced": "Đã đồng bộ",
  "shopee.not-synced": "Chưa đồng bộ",
  "shopee.products.mapped": "Liên kết sản phẩm",
  "shopee.products.view-shopee": "Xem SP trên Shopee",
  "shopee.products.import-btn": "Import từ Shopee",
  "shopee.products.load.error": "Lỗi tải sản phẩm từ Shopee",
  "shopee.products.import.error": "Lỗi import sản phẩm",
  "shopee.products.empty": "Chưa có liên kết sản phẩm. Nhấn 'Import từ Shopee' để lấy sản phẩm.",
  "shopee.products.col.name": "Tên sản phẩm",
  "shopee.products.col.sku": "SKU",
  "shopee.products.col.price": "Giá",
  "shopee.products.col.stock": "Tồn kho",
  "shopee.products.col.vmass": "Liên kết VMASS",
  "shopee.products.linked": "Đã liên kết",
  "shopee.products.not-linked": "Chưa liên kết",
  "shopee.products.map-btn": "Liên kết",
  "shopee.products.map.success": "Liên kết sản phẩm thành công",
  "shopee.products.map.error": "Lỗi liên kết sản phẩm",
  "shopee.products.map-modal.title": "Liên kết SP Shopee với VMASS",
  "shopee.products.map-modal.select": "Chọn sản phẩm VMASS",
  "shopee.products.map-modal.placeholder": "Chọn sản phẩm",
  "shopee.products.map-modal.save": "Lưu",
  "shopee.cancel": "Hủy",
  "shopee.inventory.title": "Đồng bộ tồn kho",
  "shopee.inventory.desc": "Đẩy tồn kho VMASS lên Shopee cho các sản phẩm đã liên kết.",
  "shopee.inventory.sync-btn": "Đồng bộ tồn kho lên Shopee",
  "shopee.inventory.sync.error": "Lỗi đồng bộ tồn kho",
  "shopee.inventory.no-linked": "Chưa có sản phẩm liên kết. Liên kết sản phẩm ở tab Sản phẩm trước.",
  "shopee.inventory.col.shopee-stock": "Tồn kho Shopee",
  "shopee.inventory.col.vmass-product": "SP VMASS",
  "shopee.inventory.col.sync-enabled": "Đồng bộ",
  "shopee.inventory.col.last-sync": "Lần cuối",
  "shopee.logistics.ship-btn": "Giao hàng",
  "shopee.logistics.track-btn": "Theo dõi",
  "shopee.logistics.ship.error": "Lỗi xếp lịch giao hàng",
  "shopee.logistics.track.error": "Lỗi tải thông tin vận chuyển",
  "shopee.logistics.modal.title": "Vận chuyển",
  "shopee.logistics.phone": "SĐT",
  "shopee.logistics.address": "Địa chỉ",
  "shopee.logistics.carrier": "Đơn vị vận chuyển",
  "shopee.logistics.tracking-no": "Mã vận đơn",
  "shopee.logistics.arrange": "Xếp lịch giao hàng",
  "shopee.logistics.pickup-address": "Địa chỉ lấy hàng",
  "shopee.logistics.confirm-ship": "Xác nhận giao hàng",
  "shopee.logistics.timeline": "Lịch trình vận chuyển",
  "shopee.logistics.no-tracking": "Chưa có thông tin vận chuyển.",
  "shopee.tab.returns": "Trả hàng",
  "shopee.tab.analytics": "Thống kê",
  "shopee.tab.settings": "Cài đặt",
  "shopee.tab.monitor": "Giám sát",
  "shopee.returns.title": "Trả hàng & Hoàn tiền",
  "shopee.returns.refresh": "Làm mới",
  "shopee.returns.empty": "Không có yêu cầu trả hàng/hoàn tiền.",
  "shopee.returns.col.sn": "Mã trả hàng",
  "shopee.returns.col.order": "Mã đơn hàng",
  "shopee.returns.col.reason": "Lý do",
  "shopee.returns.col.status": "Trạng thái",
  "shopee.returns.col.amount": "Số tiền hoàn",
  "shopee.returns.col.date": "Ngày",
  "shopee.returns.col.buyer": "Người mua",
  "shopee.returns.accept": "Chấp nhận",
  "shopee.returns.dispute": "Khiếu nại",
  "shopee.returns.load.error": "Lỗi tải danh sách trả hàng",
  "shopee.returns.detail.error": "Lỗi tải chi tiết trả hàng",
  "shopee.returns.detail.title": "Chi tiết trả hàng",
  "shopee.returns.confirm.prompt": "Bạn có chắc muốn chấp nhận yêu cầu trả hàng này?",
  "shopee.returns.confirm.error": "Lỗi xác nhận trả hàng",
  "shopee.returns.dispute.title": "Khiếu nại trả hàng",
  "shopee.returns.dispute.email": "Email liên hệ",
  "shopee.returns.dispute.reason": "Lý do khiếu nại",
  "shopee.returns.dispute.submit": "Gửi khiếu nại",
  "shopee.returns.dispute.success": "Đã gửi khiếu nại thành công",
  "shopee.returns.dispute.error": "Lỗi gửi khiếu nại",
  "shopee.returns.buyer-note": "Ghi chú người mua",
  "shopee.analytics.title": "Thống kê Shopee",
  "shopee.analytics.no-data": "Chưa có dữ liệu thống kê.",
  "shopee.analytics.total-orders": "Tổng đơn hàng",
  "shopee.analytics.revenue": "Doanh thu",
  "shopee.analytics.synced": "Đã đồng bộ VMASS",
  "shopee.analytics.products-linked": "Sản phẩm liên kết",
  "shopee.analytics.by-status": "Đơn hàng theo trạng thái",
  "shopee.analytics.last-7-days": "7 ngày gần đây",
  "shopee.analytics.col.date": "Ngày",
  "shopee.analytics.col.orders": "Đơn hàng",
  "shopee.analytics.col.revenue": "Doanh thu",
  "shopee.analytics.date-range": "Khoảng thời gian",
  "shopee.analytics.date-hint": "Dữ liệu Shopee chỉ tìm kiếm được trong vòng 90 ngày (3 tháng). Chọn khoảng thời gian để lọc.",
  "shopee.analytics.max-range": "Khoảng thời gian không được vượt quá 90 ngày (3 tháng)",
  "shopee.analytics.invalid-range": "Ngày bắt đầu phải trước ngày kết thúc",
  "shopee.settings.title": "Cài đặt Shopee",
  "shopee.settings.auto-sync-orders": "Tự động đồng bộ đơn hàng",
  "shopee.settings.auto-sync-orders.desc": "Tự động lấy đơn hàng mới từ Shopee",
  "shopee.settings.sync-interval": "Tần suất đồng bộ",
  "shopee.settings.sync-interval.desc": "Khoảng thời gian kiểm tra đơn hàng mới",
  "shopee.settings.auto-bill": "Tự động tạo hóa đơn",
  "shopee.settings.auto-bill.desc": "Tự động tạo hóa đơn VMASS từ đơn Shopee",
  "shopee.settings.auto-inventory": "Tự động đồng bộ tồn kho",
  "shopee.settings.auto-inventory.desc": "Tự động đẩy tồn kho VMASS sang Shopee",
  "shopee.settings.notifications": "Thông báo",
  "shopee.settings.notify-new-order": "Thông báo đơn hàng mới",
  "shopee.settings.notify-status": "Thay đổi trạng thái đơn",
  "shopee.settings.notify-return": "Yêu cầu trả hàng/hoàn tiền",
  "shopee.settings.save": "Lưu cài đặt",
  "shopee.settings.save.success": "Đã lưu cài đặt thành công",
  "shopee.settings.save.error": "Lỗi lưu cài đặt",
  "shopee.monitor.health": "Trạng thái kết nối",
  "shopee.monitor.no-shops": "Chưa kết nối shop nào.",
  "shopee.monitor.last-sync": "Đồng bộ cuối",
  "shopee.monitor.expiring-soon": "Sắp hết hạn",
  "shopee.monitor.activity": "Nhật ký hoạt động",
  "shopee.monitor.filter.all": "Tất cả",
  "shopee.monitor.no-activity": "Chưa có hoạt động gần đây.",
  "shopee.push.modal.title": "Đăng sản phẩm lên Shopee",
  "shopee.push.step": "Bước",
  "shopee.push.step.select": "Chọn sản phẩm VMASS",
  "shopee.push.step.category": "Chọn danh mục Shopee",
  "shopee.push.step.details": "Thông tin sản phẩm",
  "shopee.push.step.confirm": "Xác nhận & Đăng",
  "shopee.push.form.name": "Tên sản phẩm (5-120 ký tự)",
  "shopee.push.form.description": "Mô tả (tối thiểu 25 ký tự)",
  "shopee.push.form.price": "Giá",
  "shopee.push.form.weight": "Cân nặng (kg)",
  "shopee.push.form.condition": "Tình trạng",
  "shopee.push.form.condition.new": "Mới",
  "shopee.push.form.condition.used": "Đã qua sử dụng",
  "shopee.push.form.status": "Trạng thái đăng bán",
  "shopee.push.form.status.normal": "Đang bán (NORMAL)",
  "shopee.push.form.status.unlist": "Ẩn (UNLIST)",
  "shopee.push.form.logistics": "Kênh vận chuyển",
  "shopee.push.form.attributes": "Thuộc tính danh mục",
  "shopee.push.form.category": "Danh mục Shopee",
  "shopee.push.form.dimension": "Kích thước đóng gói",
  "shopee.push.btn.next": "Tiếp theo",
  "shopee.push.btn.back": "Quay lại",
  "shopee.push.btn.push": "Đăng lên Shopee",
  "shopee.push.btn.push-short": "Đăng lên Shopee",
  "shopee.push.btn.select": "Chọn",
  "shopee.push.btn.cancel": "Hủy",
  "shopee.push.validate.name": "Tên sản phẩm phải từ 5-120 ký tự",
  "shopee.push.validate.description": "Mô tả phải có ít nhất 25 ký tự",
  "shopee.push.validate.price": "Giá phải lớn hơn 0",
  "shopee.push.validate.weight": "Cân nặng phải từ 0.01 đến 50 kg",
  "shopee.push.validate.category": "Vui lòng chọn danh mục",
  "shopee.push.validate.logistics": "Vui lòng chọn ít nhất 1 kênh vận chuyển",

  "suggestion.title": "Gợi ý thêm",
  "suggestion.frequently-bought": "Thường mua cùng",
  "suggestion.bestseller": "Bán chạy",
  "analytics.product_customers.title": "Khách hàng đã mua",
  "analytics.product_customers.identified": "Khách xác định",
  "analytics.product_customers.anonymous": "Đơn khách lẻ",
  "analytics.product_customers.quantity": "Số lượng",
  "analytics.product_customers.revenue": "Doanh thu",
  "analytics.product_customers.search": "Tìm kiếm",
  "analytics.product_customers.customer": "Khách hàng",
  "analytics.product_customers.orders": "Số đơn",
  "analytics.product_customers.spent": "Chi tiêu",
  "analytics.product_customers.last_purchase": "Mua gần nhất",
  "analytics.product_customers.empty": "Chưa có khách hàng phù hợp",
  "analytics.product_customers.customers": "khách hàng",
  "analytics.summary.total_products_sold_period": "Mặt hàng đã bán trong kỳ",
  "analytics.summary.total_quantity_sold_period": "Số lượng bán trong kỳ",
  "analytics.summary.product_revenue_period": "Doanh thu sản phẩm",
  "analytics.summary.product_cost_period": "Giá vốn sản phẩm",
  "analytics.summary.product_gross_profit_period": "Lợi nhuận gộp",
  "analytics.summary.product_margin_period": "Tỷ suất lợi nhuận",
  "shopee.workspace.title": "Trung tâm vận hành Shopee",
  "shopee.workspace.subtitle": "Đơn hàng, catalog, tồn kho, giao vận và đối soát theo từng shop",
  "shopee.workspace.overview": "Tổng quan",
  "shopee.workspace.catalog": "Catalog",
  "shopee.workspace.inventory": "Tồn kho",
  "shopee.workspace.fulfillment": "Giao vận",
  "shopee.workspace.returns": "Trả hàng",
  "shopee.workspace.finance": "Tài chính",
  "shopee.workspace.automation": "Tự động hóa",
  "shopee.workspace.logs": "Nhật ký",
  "shopee.workspace.refresh": "Làm mới",
  "shopee.workspace.search": "Tìm kiếm",
  "shopee.workspace.from-date": "Từ ngày",
  "shopee.workspace.to-date": "Đến ngày",
  "shopee.workspace.loading": "Đang tải dữ liệu Shopee…",
  "shopee.workspace.no-data": "Không có dữ liệu phù hợp",
  "shopee.workspace.actions": "Thao tác",
  "shopee.workspace.gmv": "GMV",
  "shopee.workspace.refunds": "Hoàn tiền",
  "shopee.workspace.fees": "Phí Shopee",
  "shopee.workspace.net-revenue": "Doanh thu thuần",
  "shopee.workspace.payout": "Tiền thực nhận",
  "shopee.workspace.issues": "Vấn đề",
  "shopee.workspace.issue-center": "Trung tâm vấn đề",
  "shopee.workspace.order-issues": "đơn cần xử lý",
  "shopee.workspace.mapping-issues": "mapping cần xử lý",
  "shopee.workspace.job-issues": "job lỗi",
  "shopee.workspace.retry-selected-orders": "Xử lý lại đơn đã chọn",
  "shopee.workspace.auto-map-selected": "Auto-map SKU chính xác",
  "shopee.workspace.create-selected-drafts": "Tạo draft đã chọn",
  "shopee.workspace.issue-reason": "Vấn đề",
  "shopee.workspace.item-model": "Item / model",
  "shopee.workspace.job": "Job",
  "shopee.workspace.replay": "Chạy lại",
  "shopee.workspace.no-issues": "Không có vấn đề cần xử lý",
  "shopee.workspace.confirm-remediation": "Xác nhận khắc phục",
  "shopee.workspace.confirm-remediation-detail": "Tác vụ chỉ xử lý các bản ghi đã chọn và có cơ chế chống trùng.",
  "shopee.workspace.sync": "Đồng bộ",
  "shopee.workspace.mapping": "Mapping",
  "shopee.workspace.sync-state": "Trạng thái đồng bộ",
  "shopee.workspace.amount": "Số tiền",
  "shopee.workspace.create-bill": "Tạo Bill",
  "shopee.workspace.import-catalog": "Import catalog",
  "shopee.workspace.map-product": "Gán sản phẩm",
  "shopee.workspace.mapping-wizard": "Gán biến thể Shopee với VMASS",
  "shopee.workspace.search-product": "Tìm sản phẩm VMASS",
  "shopee.workspace.choose-product": "Chọn sản phẩm VMASS",
  "shopee.workspace.choose-variant": "Chọn biến thể VMASS",
  "shopee.workspace.create-draft": "Tạo draft VMASS",
  "shopee.workspace.update-listing": "Cập nhật listing",
  "shopee.workspace.list-listing": "Hiện bán",
  "shopee.workspace.unlist-listing": "Ẩn bán",
  "shopee.workspace.variant-prices": "Giá theo biến thể",
  "shopee.workspace.image-urls": "URL hình ảnh",
  "shopee.workspace.image-help": "Mỗi dòng một URL tài sản VMASS được cho phép; chỉ gửi khi bạn sửa trường này.",
  "shopee.workspace.length": "Dài (cm)",
  "shopee.workspace.width": "Rộng (cm)",
  "shopee.workspace.height": "Cao (cm)",
  "shopee.workspace.vmass-product-id": "ID sản phẩm VMASS",
  "shopee.workspace.vmass-variant-id": "ID biến thể VMASS (để trống với sản phẩm đơn)",
  "shopee.workspace.mapping-help": "Hệ thống xác minh sản phẩm thuộc đúng tenant và biến thể thuộc đúng sản phẩm trước khi lưu.",
  "shopee.workspace.sync-stock": "Đồng bộ tồn",
  "shopee.workspace.shopee-stock": "Tồn Shopee",
  "shopee.workspace.state": "Trạng thái",
  "shopee.workspace.reservation": "Giữ chỗ",
  "shopee.workspace.tracking": "Mã vận đơn",
  "shopee.workspace.ship": "Giao hàng",
  "shopee.workspace.ship-confirm": "Xác nhận giao hàng",
  "shopee.workspace.shipping-params-error": "Không lấy được tham số giao vận từ Shopee",
  "shopee.workspace.shipping-method": "Hình thức bàn giao",
  "shopee.workspace.pickup-address": "Địa chỉ lấy hàng",
  "shopee.workspace.pickup-time": "Khung giờ lấy hàng",
  "shopee.workspace.confirm": "Xác nhận",
  "shopee.workspace.accept": "Chấp nhận",
  "shopee.workspace.dispute": "Tranh chấp",
  "shopee.workspace.return-reason": "Lý do xử lý hoàn trả",
  "shopee.workspace.return-evidence": "Chứng cứ (các image ID, phân tách bằng dấu phẩy)",
  "shopee.workspace.sync-finance": "Đồng bộ đối soát",
  "shopee.workspace.create-income": "Tạo phiếu Thu",
  "shopee.workspace.save": "Lưu cấu hình",
  "shopee.workspace.sync-interval": "Chu kỳ đồng bộ (phút)",
  "shopee.workspace.resource": "Tài nguyên",
  "shopee.workspace.attempts": "Số lần thử",
  "shopee.workspace.created-at": "Thời điểm tạo",
  "shopee.workspace.retry": "Thử lại",
  "shopee.workspace.setting.auto_sync_orders": "Tự động đồng bộ đơn hàng",
  "shopee.workspace.setting.auto_create_bill": "Tự động tạo Bill khi sẵn sàng giao",
  "shopee.workspace.setting.auto_sync_inventory": "Tự động đồng bộ tồn kho",
  "shopee.workspace.setting.auto_sync_catalog": "Tự động đồng bộ catalog sản phẩm",
  "shopee.workspace.catalog-sync-interval": "Chu kỳ đồng bộ catalog (phút)",
  "shopee.workspace.catalog-sync-hint": "Từ 60 đến 10080 phút; mặc định 1440 phút (mỗi ngày).",
  "shopee.workspace.catalog-last-sync": "Catalog đồng bộ thành công gần nhất",
  "shopee.workspace.catalog-next-sync": "Lần đồng bộ catalog tiếp theo",
  "shopee.workspace.select-shop-for-automation": "Hãy chọn một gian hàng cụ thể để cấu hình tự động hóa.",
  "shopee.workspace.select-shop-for-listing": "Hãy chọn một gian hàng cụ thể trước khi thêm hoặc sửa sản phẩm.",
  "shopee.workspace.listing-load-incomplete": "Chưa tải đủ dữ liệu sản phẩm từ Shopee. Bạn có thể xem phần đã tải và thử lại.",
  "shopee.workspace.listing-no-candidates": "Không có sản phẩm VMASS khả dụng để đăng lên Shopee.",
  "shopee.workspace.setting.notify_new_order": "Thông báo khi có đơn Shopee mới",
  "shopee.workspace.setting.notify_status_change": "Thông báo khi trạng thái đơn thay đổi",
  "shopee.workspace.setting.notify_return": "Thông báo yêu cầu trả hàng",
  "shopee.workspace.inventory-safety-buffer": "Tồn kho đệm không đưa lên Shopee",
  "shopee.workspace.scope-not-granted": "Shop chưa cấp quyền Shopee cần thiết:",
  "shopee.workspace.group.overview": "TỔNG QUAN",
  "shopee.workspace.group.catalog": "KHO & SẢN PHẨM",
  "shopee.workspace.group.logistics": "VẬN CHUYỂN & TÀI CHÍNH",
  "shopee.workspace.group.system": "HỆ THỐNG",
  "shopee.workspace.tab.overview": "Tổng quan",
  "shopee.workspace.tab.orders": "Đơn hàng",
  "shopee.workspace.tab.products": "Sản phẩm đa kênh",
  "shopee.workspace.tab.mappings": "Ghép sản phẩm",
  "shopee.workspace.tab.inventory": "Tồn kho theo kênh",
  "shopee.workspace.tab.pricing": "Giá theo kênh",
  "shopee.workspace.tab.shipping": "Vận chuyển & Đóng gói",
  "shopee.workspace.tab.returns": "Trả hàng & Hoàn tiền",
  "shopee.workspace.tab.reconciliation": "Đối soát & Thanh toán",
  "shopee.workspace.tab.issues": "Trung tâm lỗi",
  "shopee.workspace.tab.connections": "Kênh bán & Kết nối",
  "shopee.workspace.tab.connections-short": "Kênh bán",
  "shopee.workspace.tab.automation": "Tự động hóa",
  "shopee.workspace.tab.logs": "Nhật ký tác vụ",
  "shopee.workspace.connect-required.title": "Yêu cầu kết nối tài khoản Shopee",
  "shopee.workspace.connect-required.desc": "Tài khoản của bạn chưa kết nối với gian hàng Shopee nào. Vui lòng kết nối tài khoản gian hàng Shopee để xem dữ liệu báo cáo, quản lý đơn hàng, sản phẩm và đồng bộ tồn kho.",
  "shopee.workspace.connect-required.feature.orders": "Đồng bộ đơn hàng tự động",
  "shopee.workspace.connect-required.feature.mapping": "Ghép SKU & quản lý tồn kho",
  "shopee.workspace.connect-required.feature.shipping": "Cập nhật trạng thái vận chuyển",
  "shopee.workspace.connect-required.feature.finance": "Đối soát doanh thu & thanh toán",
  "shopee.workspace.connect-required.connecting": "Đang kết nối...",
  "shopee.workspace.connect-required.cta": "🚀 Kết nối gian hàng Shopee ngay",
  "shopee.workspace.sidebar.shops-header": "Gian hàng",
  "shopee.workspace.sidebar.add-shop-title": "Kết nối gian hàng Shopee mới",
  "shopee.workspace.sidebar.refresh-title": "Làm mới dữ liệu",
  "shopee.workspace.sidebar.all-shops": "📊 Tất cả gian hàng ({count})",
  "shopee.workspace.sidebar.shop-fallback": "Shop {shopId}",
  "shopee.workspace.sidebar.connected-count": "{count} Kênh kết nối",
  "shopee.workspace.sidebar.not-connected": "Chưa kết nối",
  "shopee.workspace.common.sending-request": "Đang gửi yêu cầu...",
  "shopee.workspace.common.sync": "Đồng bộ",
  "shopee.workspace.common.edit": "Sửa",
  "shopee.workspace.common.per-page": "{size} / trang",
  "shopee.workspace.common.product-name": "Tên sản phẩm",
  "shopee.workspace.common.customer": "Khách hàng",
  "shopee.workspace.common.previous": "Trước",
  "shopee.workspace.common.next": "Sau",
  "shopee.workspace.common.loading": "Đang tải...",
  "shopee.workspace.common.page": "Trang",
  "shopee.workspace.common.of": "trên",
  "shopee.workspace.common.rows": "dòng",
  "shopee.workspace.common.all-statuses": "Tất cả trạng thái",
  "shopee.workspace.common.all-channels": "Tất cả kênh",
  "shopee.workspace.common.filter": "Bộ lọc",
  "shopee.workspace.common.tab-all-count": "Tất cả ({count})",
  "shopee.workspace.common.view-all": "Xem tất cả",
  "shopee.workspace.common.total": "Tổng",
  "shopee.workspace.common.note": "Ghi chú",
  "shopee.workspace.common.optional": "không bắt buộc",
  "shopee.workspace.common.note-placeholder": "Nhập ghi chú...",
  "shopee.workspace.common.last-7-days": "7 ngày qua",
  "shopee.workspace.common.last-30-days": "30 ngày qua",
  "shopee.workspace.catalog.channel-all": "Tất cả",
  "shopee.workspace.catalog.not-synced-yet": "Chưa đồng bộ",
  "shopee.workspace.catalog.minutes-ago": "{count} phút trước",
  "shopee.workspace.catalog.hours-ago": "{count} giờ trước",
  "shopee.workspace.catalog.channel-unlisted": "Chưa đăng",
  "shopee.workspace.catalog.publish-now": "Đăng ngay",
  "shopee.workspace.catalog.sync-error-short": "Lỗi sync",
  "shopee.workspace.catalog.out-of-stock": "Hết hàng",
  "shopee.workspace.catalog.listed": "Đã đăng",
  "shopee.workspace.catalog.view-error": "Xem lỗi",
  "shopee.workspace.catalog.mapping-saved": "Đã cập nhật mapping sản phẩm",
  "shopee.workspace.catalog.mapping-cleared": "Đã bỏ ghép sản phẩm Shopee khỏi VMASS",
  "shopee.workspace.catalog.inventory-sync-queued": "Đã lập lịch đồng bộ tồn kho",
  "shopee.workspace.catalog.import-queued": "Đã lập lịch import catalog",
  "shopee.workspace.catalog.kpi-total-listings": "Tổng listing",
  "shopee.workspace.catalog.kpi-total-listings-note": "{count} dòng mapping",
  "shopee.workspace.catalog.kpi-mapped": "Đã Mapping",
  "shopee.workspace.catalog.kpi-page-percent": "{percent}% trên trang",
  "shopee.workspace.catalog.kpi-unmapped": "Chưa Mapping",
  "shopee.workspace.catalog.note-needs-action": "Cần xử lý",
  "shopee.workspace.catalog.kpi-sync-errors": "Lỗi đồng bộ",
  "shopee.workspace.catalog.note-priority": "Ưu tiên xử lý",
  "shopee.workspace.catalog.kpi-out-of-stock": "Hết hàng",
  "shopee.workspace.catalog.note-at-shopee": "Tại kênh Shopee",
  "shopee.workspace.catalog.kpi-price-pending": "Chờ cập nhật giá",
  "shopee.workspace.catalog.note-sync-price": "Cần đồng bộ giá",
  "shopee.workspace.catalog.filter-aria": "Bộ lọc sản phẩm",
  "shopee.workspace.catalog.search-placeholder": "Tìm kiếm sản phẩm, SKU, barcode...",
  "shopee.workspace.catalog.channel-aria": "Kênh bán",
  "shopee.workspace.catalog.mapping-state-aria": "Trạng thái mapping",
  "shopee.workspace.catalog.sync-state-aria": "Trạng thái đồng bộ",
  "shopee.workspace.catalog.mapping-all": "Tất cả mapping",
  "shopee.workspace.catalog.mapping-mapped": "Đã mapping",
  "shopee.workspace.catalog.mapping-unmapped": "Chưa mapping",
  "shopee.workspace.catalog.sync-state-all": "Tình trạng sync",
  "shopee.workspace.catalog.sync-state-error": "Có lỗi",
  "shopee.workspace.catalog.add-product": "Thêm sản phẩm",
  "shopee.workspace.catalog.select-all-aria": "Chọn tất cả sản phẩm",
  "shopee.workspace.catalog.col-product": "Sản phẩm",
  "shopee.workspace.catalog.col-sku-vmass": "SKU VMASS",
  "shopee.workspace.catalog.col-price": "Giá bán",
  "shopee.workspace.catalog.col-stock": "Tồn kho",
  "shopee.workspace.catalog.col-sync-state": "Trạng thái đồng bộ",
  "shopee.workspace.catalog.col-last-update": "Cập nhật lần cuối",
  "shopee.workspace.catalog.select-row-aria": "Chọn {name}",
  "shopee.workspace.catalog.no-vmass-mapping": "Chưa mapping VMASS",
  "shopee.workspace.catalog.no-vmass-sku": "Chưa có SKU VMASS",
  "shopee.workspace.catalog.open-detail-aria": "Mở chi tiết",
  "shopee.workspace.catalog.pagination-summary": "Hiển thị {from} - {to} trên tổng {total} dòng mapping",
  "shopee.workspace.catalog.detail-sku-label": "SKU VMASS:",
  "shopee.workspace.catalog.detail-item-label": "Item Shopee:",
  "shopee.workspace.catalog.close-detail-aria": "Đóng chi tiết",
  "shopee.workspace.catalog.nav-stock": "Tồn kho",
  "shopee.workspace.catalog.nav-history": "Lịch sử",
  "shopee.workspace.catalog.unmapped-badge": "Chưa mapping",
  "shopee.workspace.catalog.sku-shopee": "SKU Shopee",
  "shopee.workspace.catalog.update-mapping": "Cập nhật mapping",
  "shopee.workspace.catalog.map-product-btn": "Ghép sản phẩm",
  "shopee.workspace.catalog.no-channel-info": "Chưa có thông tin sản phẩm",
  "shopee.workspace.catalog.publish-to": "Đăng lên {channel}",
  "shopee.workspace.catalog.sync-shopee-catalog": "Đồng bộ catalog Shopee",
  "shopee.workspace.catalog.unmap": "Bỏ ghép",
  "shopee.workspace.catalog.sku-name-placeholder": "SKU / tên sản phẩm",
  "shopee.workspace.catalog.draft-created": "Đã tạo draft sản phẩm VMASS với tồn kho bằng 0",
  "shopee.workspace.catalog.listing-show-queued": "Đã đưa yêu cầu hiển thị listing vào hàng đợi",
  "shopee.workspace.catalog.listing-hide-queued": "Đã đưa yêu cầu ẩn listing vào hàng đợi",
  "shopee.workspace.fulfillment.ship-queued": "Đã đưa yêu cầu giao hàng vào hàng đợi",
  "shopee.workspace.returns.status.requested": "Yêu cầu mới",
  "shopee.workspace.returns.status.in-inspection": "Đang kiểm tra",
  "shopee.workspace.returns.status.waiting-refund": "Chờ hoàn tiền",
  "shopee.workspace.returns.status.processing": "Đang xử lý",
  "shopee.workspace.returns.status.completed": "Hoàn tất",
  "shopee.workspace.returns.status.rejected": "Từ chối",
  "shopee.workspace.returns.status.restocked": "Đã nhập kho",
  "shopee.workspace.returns.status.waiting-confirm": "Chờ xác nhận",
  "shopee.workspace.returns.inspection-confirmed": "Đã xác nhận kiểm đếm hàng hoàn & cập nhật kho",
  "shopee.workspace.returns.dispute-queued": "Đã đưa yêu cầu tranh chấp vào hàng đợi",
  "shopee.workspace.returns.customer-fallback": "Khách hàng",
  "shopee.workspace.returns.reason-other": "Khác",
  "shopee.workspace.returns.reason-detail-fallback": "Yêu cầu trả hàng",
  "shopee.workspace.returns.item-fallback": "Sản phẩm",
  "shopee.workspace.returns.subtitle": "Quản lý toàn bộ yêu cầu trả hàng, hoàn tiền và đổi sản phẩm",
  "shopee.workspace.returns.export-excel": "Xuất Excel",
  "shopee.workspace.returns.report": "Báo cáo",
  "shopee.workspace.returns.create-request": "Tạo yêu cầu trả hàng",
  "shopee.workspace.returns.kpi-requested-note": "Yêu cầu mới & chờ xác nhận",
  "shopee.workspace.returns.kpi-processing-note": "Kiểm tra & đang xử lý",
  "shopee.workspace.returns.kpi-waiting-refund-note": "Đang chờ hoàn tiền",
  "shopee.workspace.returns.kpi-completed-note": "Đã xử lý xong",
  "shopee.workspace.returns.kpi-rejected-note": "Yêu cầu bị từ chối",
  "shopee.workspace.returns.total-refund-today": "Tổng tiền hoàn (hôm nay)",
  "shopee.workspace.returns.return-value-today": "Giá trị hàng trả (hôm nay)",
  "shopee.workspace.returns.pipeline.customer-request": "Khách gửi yêu cầu",
  "shopee.workspace.returns.pipeline.inspect": "Kiểm tra hàng",
  "shopee.workspace.returns.pipeline.approve": "Duyệt trả hàng",
  "shopee.workspace.returns.pipeline.restock-dispose": "Nhập kho / Tiêu hủy",
  "shopee.workspace.returns.pipeline.refund": "Hoàn tiền",
  "shopee.workspace.returns.search-placeholder": "Tìm kiếm mã trả hàng, mã đơn, tên, SĐT...",
  "shopee.workspace.returns.all-reasons": "Tất cả lý do",
  "shopee.workspace.returns.all-warehouses": "Tất cả kho",
  "shopee.workspace.returns.no-data": "Không có yêu cầu trả hàng nào",
  "shopee.workspace.returns.detail-title": "Chi tiết trả hàng",
  "shopee.workspace.returns.original-order": "Đơn hàng gốc",
  "shopee.workspace.returns.customer-media": "Ảnh/Video khách gửi",
  "shopee.workspace.returns.no-media": "Khách chưa đính kèm ảnh",
  "shopee.workspace.returns.returned-products": "Sản phẩm trả hàng",
  "shopee.workspace.returns.qty-label": "SL",
  "shopee.workspace.returns.inspection-title": "Kiểm tra hàng trả về",
  "shopee.workspace.returns.check.intact": "Hàng nguyên vẹn",
  "shopee.workspace.returns.check.packaging": "Bao bì, tem mác",
  "shopee.workspace.returns.check.accessories": "Phụ kiện đầy đủ",
  "shopee.workspace.returns.check.correct-product": "Đúng sản phẩm",
  "shopee.workspace.returns.check.defect": "Có lỗi / Hư hỏng",
  "shopee.workspace.returns.processing-title": "Xử lý trả hàng",
  "shopee.workspace.returns.action.restock": "Nhập kho",
  "shopee.workspace.returns.action.exchange": "Đổi hàng",
  "shopee.workspace.returns.action.discard": "Tiêu hủy",
  "shopee.workspace.returns.restock-warehouse": "Kho nhập",
  "shopee.workspace.returns.confirm-continue": "Xác nhận & Tiếp tục",
  "shopee.workspace.returns.popular-reasons": "Lý do trả hàng phổ biến",
  "shopee.workspace.returns.no-reason-data": "Chưa có dữ liệu lý do",
  "shopee.workspace.returns.top-returned": "Top sản phẩm bị trả nhiều",
  "shopee.workspace.returns.times-suffix": "lần",
  "shopee.workspace.returns.no-returned-products": "Chưa có sản phẩm hoàn trả",
  "shopee.workspace.returns.refund-trend": "Giá trị hoàn theo thời gian",
  "shopee.workspace.returns.performance": "Hiệu suất xử lý",
  "shopee.workspace.returns.avg-processing-time": "Thời gian xử lý TB",
  "shopee.workspace.returns.on-time-rate": "Tỷ lệ hoàn tất đúng hạn",
  "shopee.workspace.returns.sample-processing-time": "1.8 ngày",
  "shopee.workspace.returns.sample-processing-delta": "-0.3 ngày",
  "shopee.workspace.returns.dispute-modal-title": "Mở Tranh chấp Shopee",
  "shopee.workspace.returns.inspection-modal-title": "Phiếu Kiểm định Hàng hoàn (Return Inspection)",
  "shopee.workspace.returns.condition-placeholder": "Nhập tình trạng hàng thực tế nhận được...",
  "shopee.workspace.returns.stock-decision": "Quyết định Nhập kho (Stock Decision)",
  "shopee.workspace.returns.stock.resellable": "1. Hàng nguyên vẹn -> Nhập lại Kho bán",
  "shopee.workspace.returns.stock.defective": "2. Hàng hư hỏng / Bẩn -> Nhập Kho hàng lỗi",
  "shopee.workspace.returns.stock.discard": "3. Hư hỏng nặng / Hủy -> Không nhập kho",
  "shopee.workspace.returns.stock.shortage": "4. Thiếu sản phẩm / Tráo hàng -> Lập biên bản thiếu",
  "shopee.workspace.returns.evidence-placeholder": "Link ảnh / Video bằng chứng kiểm hàng (URL 1, URL 2)...",
  "shopee.workspace.returns.col.sn": "Mã trả hàng",
  "shopee.workspace.returns.col.order": "Đơn hàng gốc",
  "shopee.workspace.returns.col.channel": "Kênh",
  "shopee.workspace.returns.col.reason": "Lý do trả hàng",
  "shopee.workspace.returns.col.refund-value": "Giá trị hoàn",
  "shopee.workspace.returns.col.warehouse": "Kho",
  "shopee.workspace.returns.col.status": "Trạng thái",
  "shopee.workspace.returns.col.created-at": "Ngày tạo",
  "shopee.workspace.returns.action.inspect": "Kiểm hàng & Nhập kho",
  "shopee.workspace.returns.action.dispute": "Tạo Tranh chấp Shopee",
  "shopee.workspace.returns.view-detail-title": "Xem chi tiết",
  "shopee.workspace.automation.settings-saved": "Đã lưu cấu hình tự động hóa",
  "shopee.workspace.logs.replayed": "Đã replay job",
  "shopee.workspace.common.detail": "Chi tiết",
  "shopee.workspace.common.page-count": "/ {total} trang",
  "shopee.workspace.common.no-data": "Chưa có dữ liệu",
  "shopee.workspace.common.close": "Đóng",
  "shopee.workspace.orders.status.all": "Tất cả",
  "shopee.workspace.orders.status.unpaid": "Chưa thanh toán",
  "shopee.workspace.orders.status.ready-to-ship": "Chờ xử lý",
  "shopee.workspace.orders.status.processed": "Đã xử lý",
  "shopee.workspace.orders.status.shipped": "Đang giao",
  "shopee.workspace.orders.status.to-confirm-receive": "Chờ xác nhận nhận hàng",
  "shopee.workspace.orders.status.completed": "Đã giao",
  "shopee.workspace.orders.status.in-cancel": "Đang hủy",
  "shopee.workspace.orders.status.cancelled": "Đã hủy",
  "shopee.workspace.orders.status-unknown": "Chưa xác định",
  "shopee.workspace.orders.metric.total": "Tổng đơn",
  "shopee.workspace.orders.metric.total-indicator": "{count} trên trang",
  "shopee.workspace.orders.metric.pending": "Chờ xử lý",
  "shopee.workspace.orders.metric.pending-indicator": "{percent}% trang",
  "shopee.workspace.orders.metric.deadline": "Hạn giao cần chú ý",
  "shopee.workspace.orders.metric.deadline-overdue": "{count} đã quá hạn",
  "shopee.workspace.orders.metric.deadline-window": "{risk}/{total} có hạn giao",
  "shopee.workspace.orders.metric.deadline-none": "Không có đơn chờ giao",
  "shopee.workspace.orders.metric.gmv": "GMV đơn",
  "shopee.workspace.orders.metric.gmv-indicator": "{paid}/{eligible} đơn có số tiền",
  "shopee.workspace.orders.metric.delivered": "Đã giao",
  "shopee.workspace.orders.tabs-region-aria": "Thanh trạng thái đơn hàng, cuộn ngang để xem thêm",
  "shopee.workspace.orders.count-tooltip": "Số đơn trên trang hiện tại",
  "shopee.workspace.orders.select-all-aria": "Chọn tất cả đơn hàng",
  "shopee.workspace.orders.select-row-aria": "Chọn đơn {sn}",
  "shopee.workspace.orders.col.sn": "Mã đơn",
  "shopee.workspace.orders.col.channel": "Kênh bán",
  "shopee.workspace.orders.col.items": "Sản phẩm",
  "shopee.workspace.orders.col.amount": "Tổng tiền",
  "shopee.workspace.orders.col.tracking": "Vận đơn",
  "shopee.workspace.orders.col.time": "Thời gian",
  "shopee.workspace.orders.phone-hidden": "Thông tin đã ẩn",
  "shopee.workspace.orders.items-count": "{count} món",
  "shopee.workspace.orders.items-total-x": "Tổng x{count}",
  "shopee.workspace.orders.paid-time": "Thanh toán {time}",
  "shopee.workspace.orders.paid-time-missing": "Shopee chưa trả thời điểm thanh toán",
  "shopee.workspace.orders.sync-queued": "Đã lập lịch đồng bộ đơn hàng",
  "shopee.workspace.orders.sync-button": "Đồng bộ đơn hàng",
  "shopee.workspace.orders.selection-banner": "Đã chọn {count} đơn hàng.",
  "shopee.workspace.orders.export-selected": "Xuất đơn đã chọn",
  "shopee.workspace.orders.clear-selection": "Bỏ chọn",
  "shopee.workspace.orders.empty": "Không có đơn hàng phù hợp.",
  "shopee.workspace.orders.showing-summary": "Hiển thị {shown} / {total} đơn hàng",
  "shopee.workspace.orders.filter-title": "Bộ Lọc Tìm Kiếm",
  "shopee.workspace.orders.clear-filters": "Xóa lọc",
  "shopee.workspace.orders.filter-status-label": "Trạng thái đơn",
  "shopee.workspace.orders.filter-search-label": "Từ khóa tìm kiếm",
  "shopee.workspace.orders.search-placeholder": "Mã đơn hoặc mã vận đơn...",
  "shopee.workspace.orders.apply-filters": "Áp dụng bộ lọc",
  "shopee.workspace.orders.chart-title": "Phân Phối Trạng Thái Trên Trang",
  "shopee.workspace.orders.detail-title": "Chi Tiết Đơn Hàng Shopee #{orderSn}",
  "shopee.workspace.orders.detail-loading": "Đang tải dữ liệu chi tiết...",
  "shopee.workspace.orders.detail-load-error": "Không thể tải thêm chi tiết đơn hàng.",
  "shopee.workspace.orders.phone-label": "Số điện thoại:",
  "shopee.workspace.orders.tracking-label": "Mã vận đơn:",
  "shopee.workspace.orders.total-shopee": "Tổng tiền Shopee",
  "shopee.workspace.orders.created-at": "Thời gian tạo đơn",
  "shopee.workspace.orders.ship-deadline": "Hạn giao Shopee",
  "shopee.workspace.orders.items-title": "Danh Sách Sản Phẩm ({count})",
  "shopee.workspace.orders.price-per-item": "{price} / sản phẩm",
  "shopee.workspace.orders.create-bill": "Tạo Hóa Đơn VMASS",
  "shopee.workspace.orders.bill-created": "Đã tạo hóa đơn từ đơn Shopee",
  "shopee.workspace.orders.csv.order-code": "Mã đơn",
  "shopee.workspace.orders.csv.phone": "Điện thoại",
  "shopee.workspace.orders.csv.products": "Sản phẩm",
  "shopee.workspace.orders.csv.amount": "Tổng tiền",
  "shopee.workspace.overview.webhook.configured": "Đã cấu hình",
  "shopee.workspace.overview.webhook.processing": "Đang xử lý",
  "shopee.workspace.overview.webhook.degraded": "Cần kiểm tra",
  "shopee.workspace.overview.webhook.not-configured": "Chưa cấu hình",
  "shopee.workspace.overview.webhook.unknown": "Chưa rõ",
  "shopee.workspace.overview.kpi.new-orders": "Đơn hàng mới",
  "shopee.workspace.overview.kpi.new-trend": "Mới",
  "shopee.workspace.overview.kpi.new-comparison": "Đơn mới hôm nay",
  "shopee.workspace.overview.kpi.pending": "Chờ xử lý / Đóng gói",
  "shopee.workspace.overview.kpi.pending-trend": "Cần xử lý",
  "shopee.workspace.overview.kpi.pending-comparison": "Sẵn sàng bàn giao",
  "shopee.workspace.overview.kpi.expiring": "Sắp quá hạn bàn giao",
  "shopee.workspace.overview.kpi.expiring-priority": "Ưu tiên",
  "shopee.workspace.overview.kpi.expiring-safe": "An toàn",
  "shopee.workspace.overview.kpi.expiring-comparison": "Cần xử lý sớm",
  "shopee.workspace.overview.kpi.gmv": "Doanh thu hôm nay (GMV)",
  "shopee.workspace.overview.kpi.gmv-trend": "Tổng GMV",
  "shopee.workspace.overview.kpi.gmv-comparison": "Tổng doanh thu",
  "shopee.workspace.overview.kpi.ontime": "Tỷ lệ giao đúng hạn",
  "shopee.workspace.overview.kpi.ontime-trend": "Đạt chuẩn",
  "shopee.workspace.overview.kpi.ontime-comparison": "Chỉ số hiệu suất",
  "shopee.workspace.overview.issue.orders": "Đơn cần xử lý",
  "shopee.workspace.overview.issue.orders-desc": "Đơn hàng cần xử lý để đảm bảo thời gian giao.",
  "shopee.workspace.overview.issue.mappings": "Mapping cần xử lý",
  "shopee.workspace.overview.issue.mappings-desc": "SKU chưa được ghép hoặc ghép chưa chính xác.",
  "shopee.workspace.overview.issue.jobs": "Job lỗi",
  "shopee.workspace.overview.issue.jobs-desc": "Các tác vụ đồng bộ bị lỗi cần kiểm tra.",
  "shopee.workspace.overview.issue.products": "Sản phẩm thiếu thông tin",
  "shopee.workspace.overview.issue.products-desc": "Sản phẩm thiếu thông tin trên một số kênh.",
  "shopee.workspace.overview.issue.reconciliation": "Đối soát chênh lệch",
  "shopee.workspace.overview.issue.reconciliation-desc": "Đơn hàng có chênh lệch cần đối soát.",
  "shopee.workspace.overview.shop-fallback": "Shopee - Shop {shopId}",
  "shopee.workspace.overview.shop-label": "Shop {shopId}",
  "shopee.workspace.overview.activity.sync-default": "Đồng bộ",
  "shopee.workspace.overview.activity.just-now": "Vừa xong",
  "shopee.workspace.overview.activity.success": "Thành công",
  "shopee.workspace.overview.activity.attempts": "{count} lần chạy",
  "shopee.workspace.overview.banner-title": "Tổng Quan Sức Khỏe & Hiệu Suất Kênh Shopee",
  "shopee.workspace.overview.banner-healthy": "Hệ thống bình thường",
  "shopee.workspace.overview.banner-attention": "Cần chú ý",
  "shopee.workspace.overview.banner-shops-updated": "Kết nối {count} gian hàng | Cập nhật lúc: {time}",
  "shopee.workspace.overview.period.today": "Hôm nay",
  "shopee.workspace.overview.period.week": "7 ngày",
  "shopee.workspace.overview.period.month": "30 ngày",
  "shopee.workspace.overview.reload": "Tải lại dữ liệu",
  "shopee.workspace.overview.mapping-title": "Tiến độ Ghép sản phẩm (SKU Mapping)",
  "shopee.workspace.overview.mapping-tooltip": "Đồng bộ kho thực tế giữa Shopee & VMASS",
  "shopee.workspace.overview.mapping-percent": "{percent}% Đã ghép",
  "shopee.workspace.overview.mapping-progress": "Đã ghép {mapped} / {total} SKU sản phẩm",
  "shopee.workspace.overview.mapping-note": "Tự động đồng bộ tồn kho thực tế & chống overselling khi có đơn mới.",
  "shopee.workspace.overview.mapping-action": "Ghép SKU ngay",
  "shopee.workspace.overview.health-title": "Sức khỏe Đồng bộ & Kết nối Shopee",
  "shopee.workspace.overview.last-sync": "Lần đồng bộ gần nhất:",
  "shopee.workspace.overview.sparkline-label": "Trạng thái kết nối realtime",
  "shopee.workspace.overview.oauth-label": "OAuth Token:",
  "shopee.workspace.overview.oauth-valid": "Hợp lệ",
  "shopee.workspace.overview.oauth-invalid": "Hết hạn",
  "shopee.workspace.overview.api-label": "API Health:",
  "shopee.workspace.overview.api-good": "Tốt (Normal)",
  "shopee.workspace.overview.api-bad": "Cần kiểm tra",
  "shopee.workspace.overview.issues-title": "Trung tâm vấn đề",
  "shopee.workspace.overview.manage-connections": "Quản lý kết nối",
  "shopee.workspace.overview.channels-title": "Kênh bán hàng",
  "shopee.workspace.overview.channel-active": "Đang hoạt động",
  "shopee.workspace.overview.channel-error": "Lỗi kết nối",
  "shopee.workspace.overview.new-orders-colon": "Đơn mới:",
  "shopee.workspace.overview.no-shops": "Chưa có gian hàng kết nối",
  "shopee.workspace.overview.connect-more": "Kết nối thêm kênh bán",
  "shopee.workspace.overview.view-logs": "Xem nhật ký",
  "shopee.workspace.overview.activity-title": "Hoạt động đồng bộ gần đây",
  "shopee.workspace.overview.no-activity": "Chưa có nhật ký hoạt động gần đây",
  "shopee.workspace.overview.top-products": "Top sản phẩm bán chạy",
  "shopee.workspace.overview.top-products-note": "theo số lượng đơn",
  "shopee.workspace.overview.top-period": "Thống kê 7 ngày qua",
  "shopee.workspace.overview.product-unknown": "Sản phẩm chưa xác định",
  "shopee.workspace.overview.sold-count": "{count} đơn",
  "shopee.workspace.overview.no-products": "Chưa có dữ liệu sản phẩm",
  "shopee.workspace.overview.revenue-title": "Phân bố doanh thu theo kênh",
  "shopee.workspace.overview.revenue-period": "Doanh số 7 ngày qua",
  "shopee.workspace.overview.revenue-total-aria": "Tổng doanh thu {amount} đồng",
  "shopee.workspace.overview.total-revenue": "Tổng doanh thu",
  "shopee.workspace.error.no-response": "Yêu cầu Shopee không phản hồi. Vui lòng kiểm tra Redis và Shopee worker rồi thử lại.",
  "shopee.workspace.error.load-failed": "Không thể tải dữ liệu Shopee",
  "shopee.workspace.notice.job-completed": "Tác vụ Shopee đã hoàn tất",
  "shopee.workspace.notice.job-ended-status": "Tác vụ Shopee kết thúc ở trạng thái {status}",
  "shopee.workspace.notice.job-status-updated": "Job {status}",
  "shopee.workspace.notice.job-status-default": "đã cập nhật",
  "shopee.workspace.notice.new-order": "Đã nhận đơn hàng mới từ Shopee",
  "shopee.workspace.notice.action-queued": "Đã đưa tác vụ vào hàng đợi",
  "shopee.workspace.notice.action-success": "Đã cập nhật thành công",
  "shopee.workspace.common.back": "Quay lại",
  "shopee.workspace.common.next-step": "Tiếp theo",
  "shopee.workspace.connections.title": "Kênh bán & Gian hàng kết nối (Sales Channels)",
  "shopee.workspace.connections.subtitle": "Quản lý ủy quyền OAuth, chính sách đồng bộ và kết nối gian hàng Shopee",
  "shopee.workspace.connections.add-shop-wizard": "Thêm gian hàng Shopee mới (Wizard 6 bước)",
  "shopee.workspace.connections.status-active": "HOẠT ĐỘNG",
  "shopee.workspace.connections.region-id": "Region: {region} | Shop ID: {shopId}",
  "shopee.workspace.connections.scopes-label": "Quyền hạn ủy quyền (Scopes):",
  "shopee.workspace.connections.scope.orders": "Đơn hàng (Order)",
  "shopee.workspace.connections.scope.catalog": "Sản phẩm (Catalog)",
  "shopee.workspace.connections.scope.stock": "Tồn kho (Stock)",
  "shopee.workspace.connections.scope.finance": "Tài chính (Finance)",
  "shopee.workspace.connections.scope.return": "Trả hàng (Return)",
  "shopee.workspace.connections.last-sync-colon": "Đồng bộ gần nhất:",
  "shopee.workspace.connections.reauth-title": "Ủy quyền lại",
  "shopee.workspace.connections.reauth": "OAuth lại",
  "shopee.workspace.connections.disconnect-title": "Ngắt kết nối",
  "shopee.workspace.connections.disconnected-notice": "Đã ngắt kết nối shop {shop}",
  "shopee.workspace.connections.disconnect-btn": "Hủy",
  "shopee.workspace.connections.empty": "Chưa có gian hàng Shopee nào được kết nối.",
  "shopee.workspace.connections.connect-new": "+ Kết nối Shop Shopee mới",
  "shopee.workspace.connections.wizard.title": "Wizard Kết nối & Kích hoạt Gian hàng Shopee (Bước {step}/6)",
  "shopee.workspace.connections.wizard.step1-title": "Bước 1: Kết nối & Ủy quyền OAuth Shopee",
  "shopee.workspace.connections.wizard.step1-desc": "Bạn sẽ được chuyển hướng sang cổng ủy quyền chính thức của Shopee Partner Platform để đăng nhập gian hàng.",
  "shopee.workspace.connections.wizard.step1-permissions": "Quyền truy cập bao gồm:",
  "shopee.workspace.connections.wizard.step1-permissions-detail": "Đọc/ghi đơn hàng, đồng bộ danh mục sản phẩm, cập nhật số lượng tồn kho và xem lịch sử đối soát thanh toán.",
  "shopee.workspace.connections.wizard.open-oauth": "Chuyển đến trang đăng nhập & Ủy quyền Shopee",
  "shopee.workspace.connections.wizard.step2-title": "Bước 2: Lựa chọn Nhập dữ liệu ban đầu",
  "shopee.workspace.connections.wizard.step2-desc": "Chọn các loại dữ liệu bạn muốn import từ Shopee về VMASS:",
  "shopee.workspace.connections.wizard.step2-products": "Tất cả Sản phẩm & Biến thể từ Shopee",
  "shopee.workspace.connections.wizard.step2-orders": "Đơn hàng trong vòng 30 ngày gần đây",
  "shopee.workspace.connections.wizard.step2-logistics": "Thông tin địa chỉ lấy hàng & Đối tác vận chuyển",
  "shopee.workspace.connections.wizard.step3-title": "Bước 3: Xác định Nguồn dữ liệu Chuẩn (Source of Truth)",
  "shopee.workspace.connections.wizard.step3-desc": "Nguồn chuẩn sẽ quyết định hệ thống nào nắm quyền quản lý số lượng tồn kho chính:",
  "shopee.workspace.connections.wizard.step3-vmass-strong": "VMASS làm Nguồn chuẩn (Khuyên dùng):",
  "shopee.workspace.connections.wizard.step3-vmass-desc": "Tồn kho VMASS sẽ tự động đẩy sang Shopee sau khi xử lý đơn.",
  "shopee.workspace.connections.wizard.step3-shopee-strong": "Shopee làm Nguồn ban đầu:",
  "shopee.workspace.connections.wizard.step3-shopee-desc": "Lấy số lượng tồn kho trên Shopee làm mốc cho lần đồng bộ đầu tiên.",
  "shopee.workspace.connections.wizard.step4-title": "Bước 4: Kiểm tra Ghép sản phẩm (SKU Mapping)",
  "shopee.workspace.connections.wizard.step4-info": "Hệ thống phát hiện 85% SKU Shopee có mã trùng khớp hoàn toàn với SKU trong kho VMASS. Các SKU này sẽ được tự động ghép nối.",
  "shopee.workspace.connections.wizard.step4-note": "Các SKU chưa được ghép sẽ được quản lý tại tab \"Ghép sản phẩm\" sau khi kích hoạt.",
  "shopee.workspace.connections.wizard.step5-title": "Bước 5: Cấu hình Chính sách Tồn kho & Giá",
  "shopee.workspace.connections.wizard.allocation-label": "Chế độ phân bổ tồn kho",
  "shopee.workspace.connections.wizard.option-shared": "SHARED (Dùng chung 100% tồn kho có thể bán)",
  "shopee.workspace.connections.wizard.option-allocated": "ALLOCATED (Dành riêng hạn mức)",
  "shopee.workspace.connections.wizard.option-percentage": "PERCENTAGE (Chia theo % tỷ lệ)",
  "shopee.workspace.connections.wizard.safety-buffer-label": "Tồn kho an toàn (Safety Buffer)",
  "shopee.workspace.connections.wizard.safety-buffer-hint": "Ngăn ngừa overselling khi bán trên nhiều kênh.",
  "shopee.workspace.connections.wizard.step6-title": "Bước 6: Kiểm tra & Kích hoạt Gian hàng",
  "shopee.workspace.connections.wizard.step6-ready-strong": "Sẵn sàng kích hoạt!",
  "shopee.workspace.connections.wizard.step6-ready-detail": "Mọi cấu hình đã hợp lệ và không có xung đột nghiêm trọng.",
  "shopee.workspace.connections.wizard.check-oauth": "✔ Đã ủy quyền OAuth Shopee Partner API v2",
  "shopee.workspace.connections.wizard.check-sot": "✔ Nguồn tồn chuẩn: {value}",
  "shopee.workspace.connections.wizard.check-stock-mode": "✔ Chế độ tồn kho: {mode} (Safety Buffer: {buffer})",
  "shopee.workspace.connections.wizard.opening-shopee": "Đang mở cổng Shopee...",
  "shopee.workspace.connections.wizard.connect-now": "Kết nối Shopee OAuth Ngay",
  "shopee.workspace.connections.wizard.activate-done": "Đã kích hoạt thành công gian hàng Shopee mới",
  "shopee.workspace.connections.wizard.activate-now": "Kích hoạt Gian hàng Ngay",
  "shopee.workspace.inventory.status.unknown": "Chưa đủ dữ liệu",
  "shopee.workspace.inventory.status.unmapped": "Chưa ghép VMASS",
  "shopee.workspace.inventory.status.error": "Lỗi đồng bộ",
  "shopee.workspace.inventory.status.out-of-stock": "Hết hàng Shopee",
  "shopee.workspace.inventory.status.variance": "Chênh lệch",
  "shopee.workspace.inventory.status.synced": "Đồng bộ",
  "shopee.workspace.inventory.no-name": "Shopee không cung cấp tên sản phẩm",
  "shopee.workspace.inventory.sub.on-page": "Trên trang hiện tại",
  "shopee.workspace.inventory.sub.by-filter": "Theo bộ lọc hiện tại",
  "shopee.workspace.inventory.sub.from-loaded-mappings": "Theo dữ liệu mapping đã tải",
  "shopee.workspace.inventory.kpi.total": "Tổng mapping Shopee",
  "shopee.workspace.inventory.kpi.synced-sub": "Trên {count} dòng đã tải",
  "shopee.workspace.inventory.kpi.variance": "Chênh lệch tồn kho",
  "shopee.workspace.inventory.kpi.errors-sub": "{count} lỗi đồng bộ",
  "shopee.workspace.inventory.kpi.last-sync": "Cập nhật gần nhất",
  "shopee.workspace.inventory.col.vmass-stock": "Kho VMASS",
  "shopee.workspace.inventory.col.total": "Tổng",
  "shopee.workspace.inventory.col.diff-formula": "Shopee - VMASS",
  "shopee.workspace.inventory.col.condition": "Tình trạng",
  "shopee.workspace.inventory.col.updated": "Cập nhật",
  "shopee.workspace.inventory.col.last": "Lần cuối",
  "shopee.workspace.inventory.img-placeholder-aria": "Chưa có ảnh sản phẩm",
  "shopee.workspace.inventory.title": "Tồn kho Shopee",
  "shopee.workspace.inventory.subtitle": "Đối chiếu tồn kho sẵn sàng bán của VMASS với catalog Shopee đã đồng bộ.",
  "shopee.workspace.inventory.manage-mapping": "Quản lý ghép sản phẩm",
  "shopee.workspace.inventory.search-placeholder": "Tìm sản phẩm hoặc SKU Shopee...",
  "shopee.workspace.inventory.filter.all": "Tất cả tình trạng",
  "shopee.workspace.inventory.shop-colon": "Gian hàng:",
  "shopee.workspace.inventory.no-shop-selected": "Chưa chọn gian hàng",
  "shopee.workspace.inventory.loading": "Đang tải dữ liệu Shopee...",
  "shopee.workspace.inventory.empty": "Chưa có mapping Shopee phù hợp với bộ lọc.",
  "shopee.workspace.inventory.pagination-summary": "Hiển thị {from} - {to} trên tổng {total} mapping Shopee",
  "shopee.workspace.inventory.side.overview-title": "Tổng quan tồn kho",
  "shopee.workspace.inventory.legend.filtered": "Mapping theo bộ lọc",
  "shopee.workspace.inventory.legend.synced-page": "Đồng bộ trên trang",
  "shopee.workspace.inventory.legend.variance-page": "Chênh lệch trên trang",
  "shopee.workspace.inventory.side.top-variance": "Top chênh lệch tồn kho",
  "shopee.workspace.inventory.side.no-variance": "Chưa có chênh lệch tồn kho trong dữ liệu đã tải.",
  "shopee.workspace.inventory.side.alerts-title": "Cảnh báo tồn kho",
  "shopee.workspace.inventory.alert.out-of-stock": "{count} sản phẩm hết hàng Shopee",
  "shopee.workspace.inventory.alert.variance": "{count} sản phẩm chênh lệch tồn",
  "shopee.workspace.inventory.alert.variance-desc": "Shopee khác với VMASS",
  "shopee.workspace.inventory.alert.unmapped": "{count} sản phẩm chưa ghép VMASS",
  "shopee.workspace.inventory.alert.unmapped-desc": "Cần ghép sản phẩm trước khi đối chiếu",
  "shopee.workspace.pricing.kpi.total": "Tổng SKU",
  "shopee.workspace.pricing.kpi.synced": "Giá đồng bộ",
  "shopee.workspace.pricing.kpi.variance": "Chênh lệch giá",
  "shopee.workspace.pricing.kpi.pending": "Chưa cập nhật",
  "shopee.workspace.pricing.kpi.pending-sub": "Thiếu giá Shopee hoặc VMASS",
  "shopee.workspace.pricing.kpi.errors": "Lỗi giá",
  "shopee.workspace.pricing.subtitle": "Quản lý và đồng bộ giá bán sản phẩm giữa VMASS và các kênh bán hàng",
  "shopee.workspace.pricing.search-placeholder": "Tìm tên sản phẩm, SKU, barcode...",
  "shopee.workspace.pricing.category.all": "Tất cả danh mục",
  "shopee.workspace.pricing.category.fashion": "Thời trang",
  "shopee.workspace.pricing.category.electronics": "Thiết bị điện tử",
  "shopee.workspace.pricing.category.food": "Thực phẩm",
  "shopee.workspace.pricing.warehouse.main": "Kho chính",
  "shopee.workspace.pricing.warehouse.hanoi": "Kho Hà Nội",
  "shopee.workspace.pricing.warehouse.hcm": "Kho HCM",
  "shopee.workspace.pricing.pagination-summary": "Hiển thị {from} - {to} trên tổng {total} sản phẩm Shopee",
  "shopee.workspace.pricing.col.vmass-price": "Giá bán VMASS",
  "shopee.workspace.pricing.col.price-small": "Giá bán",
  "shopee.workspace.pricing.col.diff-range": "Cao nhất - Thấp nhất",
  "shopee.workspace.pricing.action.adjust-price": "Điều chỉnh giá",
  "shopee.workspace.pricing.action.sync-price-list": "Đồng bộ bảng giá",
  "shopee.workspace.pricing.action.cancel-rule": "Hủy quy tắc giá",
  "shopee.workspace.pricing.action.sync-price": "Đồng bộ giá",
  "shopee.workspace.pricing.action.batch-update": "Cập nhật hàng loạt",
  "shopee.workspace.pricing.action.price-rules": "Quy tắc giá",
  "shopee.workspace.pricing.alert.higher": "{count} sản phẩm giá cao hơn",
  "shopee.workspace.pricing.alert.lower": "{count} sản phẩm giá thấp hơn",
  "shopee.workspace.pricing.alert.unavailable": "{count} sản phẩm chưa đủ dữ liệu giá",
  "shopee.workspace.pricing.alert.threshold-desc": "so với VMASS > 10%",
  "shopee.workspace.pricing.sub.on-page-short": "Trên trang",
  "shopee.workspace.pricing.side.variance-title": "Tổng quan chênh lệch giá",
  "shopee.workspace.pricing.side.top-variance": "Top chênh lệch giá",
  "shopee.workspace.pricing.side.no-variance": "Chưa có chênh lệch giá trong dữ liệu Shopee đã tải.",
  "shopee.workspace.pricing.side.alerts-title": "Cảnh báo giá",
  "shopee.workspace.pricing.rule.title": "Thiết lập Quy tắc Giá bán theo Kênh (Price Policy Builder)",
  "shopee.workspace.pricing.rule.policy-mode": "Chiến lược tính giá (Policy Mode)",
  "shopee.workspace.pricing.rule.option-direct": "Đồng bộ Giá trực tiếp từ VMASS",
  "shopee.workspace.pricing.rule.option-percent": "Tăng theo Tỷ lệ % (Percent Markup)",
  "shopee.workspace.pricing.rule.option-fixed": "Cộng số tiền cố định (Fixed Markup)",
  "shopee.workspace.pricing.rule.option-cost-plus": "Giá vốn + Chi phí + Lợi nhuận (Cost Plus)",
  "shopee.workspace.pricing.rule.markup-percent-label": "Tỷ lệ tăng (%)",
  "shopee.workspace.pricing.rule.markup-amount-label": "Số tiền cộng thêm (VNĐ)",
  "shopee.workspace.pricing.rule.fee-label": "Phí sàn dự kiến (%)",
  "shopee.workspace.pricing.rule.packaging-label": "Phí đóng gói (VNĐ)",
  "shopee.workspace.pricing.rule.rounding-label": "Quy tắc làm tròn",
  "shopee.workspace.pricing.rule.rounding-none": "Không làm tròn",
  "shopee.workspace.pricing.rule.rounding-thousand": "Tròn nghìn (.000đ)",
  "shopee.workspace.pricing.rule.rounding-nine-thousand": "Đuôi 9.000đ (.9.000đ)",
  "shopee.workspace.pricing.rule.formula-strong": "Công thức áp dụng:",
  "shopee.workspace.pricing.rule.formula-text": "Giá sàn = [Giá VMASS + Phí cố định] / (1 - Phí sàn %) -> Làm tròn giá.",
  "shopee.workspace.pricing.rule.preview-no-base": "Chưa có giá VMASS từ dữ liệu Shopee đã tải để xem trước.",
  "shopee.workspace.pricing.rule.preview-from": "Xem trước từ giá VMASS {base}: {result}",
  "shopee.workspace.pricing.rule.save-preview": "Lưu Quy tắc & Xem trước",
  "shopee.workspace.pricing.approve.title": "Xác nhận Duyệt & Đẩy Bảng giá hàng loạt sang Shopee",
  "shopee.workspace.pricing.approve.warning-strong": "Cảnh báo an toàn:",
  "shopee.workspace.pricing.approve.warning-detail": "Thao tác này sẽ áp dụng quy tắc giá mới và đồng bộ bảng giá sản phẩm lên Shopee.",
  "shopee.workspace.pricing.approve.items-total": "Tổng số mặt hàng",
  "shopee.workspace.pricing.approve.rule-applied": "Quy tắc áp dụng",
  "shopee.workspace.pricing.approve.fee-deducted": "Phí sàn khấu trừ",
  "shopee.workspace.pricing.approve.queued": "Đã khởi chạy tác vụ cập nhật bảng giá hàng loạt sang Shopee",
  "shopee.workspace.pricing.approve.confirm": "Đồng ý Duyệt & Cập nhật Giá",
  "shopee.workspace.mapping.model-simple": "Sản phẩm đơn",
  "shopee.workspace.mapping.draft-created-from-listing": "Đã tạo sản phẩm VMASS từ listing Shopee",
  "shopee.workspace.mapping.no-provider-data": "Shopee không cung cấp dữ liệu",
  "shopee.workspace.mapping.tooltip-full": "SKU {sku} · Giá {price} · Tồn {stock}",
  "shopee.workspace.mapping.tooltip-price-stock": "Giá {price} · Tồn {stock}",
  "shopee.workspace.mapping.stock-colon": "Tồn:",
  "shopee.workspace.mapping.price-label": "Giá",
  "shopee.workspace.mapping.col.vmass-product": "Sản phẩm trên VMASS",
  "shopee.workspace.mapping.col.mapping": "Mapping",
  "shopee.workspace.mapping.pick-product-aria": "Chọn sản phẩm VMASS để mapping",
  "shopee.workspace.mapping.no-mapping-permission": "Bạn không có quyền mapping sản phẩm",
  "shopee.workspace.common.pick-product": "Chọn sản phẩm",
  "shopee.workspace.common.retry": "Thử lại",
  "shopee.workspace.common.yes": "Có",
  "shopee.workspace.common.no": "Không",
  "shopee.workspace.mapping.state-conflict": "Xung đột",
  "shopee.workspace.mapping.auto-map-launched": "Đã khởi chạy tự động ghép {count} mapping Shopee",
  "shopee.workspace.mapping.inventory-sync-queued": "Đã lập lịch đồng bộ tồn kho sản phẩm Shopee",
  "shopee.workspace.mapping.no-shop-selected": "Chưa có shop Shopee được chọn. Hãy kết nối hoặc chọn shop để tải dữ liệu mapping thật.",
  "shopee.workspace.mapping.kpi.total-sub": "{count} dòng mapping từ API",
  "shopee.workspace.mapping.kpi.rate-page": "{percent}% trên trang hiện tại",
  "shopee.workspace.mapping.kpi.rate": "Tỷ lệ mapping",
  "shopee.workspace.mapping.search-placeholder": "Tìm SKU, barcode, tên sản phẩm...",
  "shopee.workspace.mapping.title": "Mapping Shopee",
  "shopee.workspace.mapping.data-scope-banner": "Dữ liệu từ shop {shop}; các chỉ số trạng thái tính trên trang hiện tại.",
  "shopee.workspace.mapping.shop-unselected": "chưa chọn",
  "shopee.workspace.mapping.loading": "Đang tải dữ liệu mapping từ Shopee...",
  "shopee.workspace.mapping.empty": "Shopee không trả về mapping nào phù hợp với shop và bộ lọc hiện tại.",
  "shopee.workspace.mapping.detail-title": "Chi tiết mapping",
  "shopee.workspace.mapping.tab-info": "Thông tin",
  "shopee.workspace.mapping.tab-history": "Lịch sử",
  "shopee.workspace.mapping.status.disabled": "Ngừng đồng bộ",
  "shopee.workspace.mapping.status.error": "Lỗi sync",
  "shopee.workspace.mapping.status.healthy": "Ổn định",
  "shopee.workspace.mapping.status.mapping-required": "Chưa mapping",
  "shopee.workspace.mapping.status.out-of-stock": "Hết hàng",
  "shopee.workspace.mapping.section-vmass": "Thông tin VMASS",
  "shopee.workspace.mapping.section-shopee": "Dữ liệu Shopee",
  "shopee.workspace.mapping.available-stock": "Tồn khả dụng",
  "shopee.workspace.mapping.shopee-name-colon": "Tên trên Shopee:",
  "shopee.workspace.mapping.not-linked": "Chưa ghép kênh Shopee",
  "shopee.workspace.mapping.sync-enabled-colon": "Cho phép đồng bộ:",
  "shopee.workspace.mapping.auto-map-this": "Auto-map SKU này",
  "shopee.workspace.mapping.change": "Đổi mapping",
  "shopee.workspace.mapping.remove": "Gỡ mapping",
  "shopee.workspace.mapping.history-created": "Tạo mapping:",
  "shopee.workspace.mapping.history-updated": "Cập nhật mapping:",
  "shopee.workspace.mapping.history-last-sync": "Shopee sync gần nhất:",
  "shopee.workspace.mapping.sync-stock-to-shopee": "Đồng bộ tồn kho lên Shopee",
  "shopee.workspace.mapping.modal-title": "Chọn sản phẩm VMASS để ghép",
  "shopee.workspace.mapping.candidate-search-placeholder": "Tìm theo tên, SKU hoặc barcode VMASS",
  "shopee.workspace.mapping.candidates-loading": "Đang tải sản phẩm VMASS...",
  "shopee.workspace.mapping.choose-product": "Chọn sản phẩm VMASS",
  "shopee.workspace.mapping.nameless-product": "Sản phẩm không tên",
  "shopee.workspace.mapping.choose-variant": "Chọn biến thể VMASS",
  "shopee.workspace.mapping.no-variants-note": "Sản phẩm VMASS không có biến thể; mapping sẽ dùng tồn kho sản phẩm gốc.",
  "shopee.workspace.mapping.no-candidates": "Không có sản phẩm VMASS phù hợp với tìm kiếm.",
  "shopee.workspace.mapping.create-product": "Tạo sản phẩm mới",
  "shopee.workspace.mapping.save": "Lưu mapping",
  "shopee.workspace.mapping.auto-map-selected": "Đã chọn {count} mapping để tự động ghép",
  "einvoice.filter.issuance-status": "Trạng thái phát hành",
  "einvoice.filter.invoice-status": "Trạng thái hóa đơn",
  "einvoice.filter.all": "Tất cả",
  "einvoice.issuance-status.pending": "Đang xử lý",
  "einvoice.issuance-status.success": "Thành công",
  "einvoice.issuance-status.failed": "Lỗi",
  "einvoice.invoice-status.draft": "Nháp",
  "einvoice.invoice-status.issued": "Đã phát hành",
  "template.badge": "Dữ liệu mẫu",
  "template.convert": "Chuyển thành dữ liệu thật",
  "product.btn-update": "Cập nhật sản phẩm",
  "template.profile.title": "Dữ liệu hướng dẫn",
  "template.profile.description": "Các sản phẩm và nguyên liệu mẫu giúp bạn làm quen với hệ thống. Bạn có thể ẩn hoặc bật lại khi cần thiết.",
  "template.profile.dismiss": "Ẩn dữ liệu mẫu",
  "template.profile.show": "Bật lại dữ liệu mẫu",
  "template.profile.confirm": "Dữ liệu mẫu và các hóa đơn tạo từ chúng sẽ bị ẩn; tồn kho mẫu đã sử dụng sẽ được hoàn lại. Bạn có muốn tiếp tục?",
  "template.profile.show-confirm": "Bạn có chắc chắn muốn hiển thị lại dữ liệu mẫu không?",
  "template.profile.success": "Đã ẩn dữ liệu mẫu thành công",
  "template.profile.show-success": "Đã bật lại dữ liệu mẫu thành công!",
  "shopee.workspace.shipping.customer-fallback": "Khách hàng {number}",
  "shopee.workspace.shipping.product-fallback": "Sản phẩm Shopee",
  "shopee.workspace.shipping.service-standard": "Giao tiêu chuẩn",
  "shopee.workspace.shipping.status.ready-pickup": "Chờ lấy hàng",
  "shopee.workspace.shipping.status.processing": "Đang xử lý",
  "shopee.workspace.shipping.checklist.inspect": "Kiểm tra sản phẩm",
  "shopee.workspace.shipping.checklist.protect": "Bọc chống sốc",
  "shopee.workspace.shipping.col.order-sub": "Mã đơn | Kênh",
  "shopee.workspace.shipping.col.phone-sub": "SĐT",
  "shopee.workspace.shipping.col.amount": "Tiền hàng",
  "shopee.workspace.shipping.col.progress-sub": "Tiến trình",
  "shopee.workspace.shipping.print-slip-title": "In phiếu",
  "shopee.workspace.shipping.alert.print-slip": "In phiếu giao hàng cho đơn {sn}",
  "shopee.workspace.shipping.alert.update-status": "Cập nhật trạng thái đơn {sn}",
  "shopee.workspace.shipping.action.update-status": "Cập nhật trạng thái",
  "shopee.workspace.shipping.alert.cancel-order": "Hủy đơn {sn}",
  "shopee.workspace.shipping.action.cancel-order": "Hủy đơn hàng",
  "shopee.workspace.shipping.subtitle": "Quản lý quy trình xử lý, đóng gói và giao hàng cho các đơn trên tất cả kênh.",
  "shopee.workspace.shipping.create-shipping-order": "Tạo đơn giao hàng",
  "shopee.workspace.shipping.alert.print-labels-bulk": "In nhãn hàng loạt",
  "shopee.workspace.shipping.action.print-bulk": "In hàng loạt",
  "shopee.workspace.shipping.alert.export-excel": "Xuất danh sách Excel",
  "shopee.workspace.shipping.alert.syncing-orders": "Đang đồng bộ đơn hàng mới từ các sàn...",
  "shopee.workspace.shipping.kpi.overdue": "{count} đơn quá hạn",
  "shopee.workspace.shipping.kpi.packing": "Đang đóng gói",
  "shopee.workspace.shipping.kpi.packing-sub": "1 Đang thực hiện",
  "shopee.workspace.shipping.kpi.pickup-today": "Lấy hàng hôm nay",
  "shopee.workspace.shipping.kpi.handover": "Đã bàn giao",
  "shopee.workspace.shipping.kpi.shipping": "Đang giao",
  "shopee.workspace.shipping.kpi.shipping-sub": "Đang vận chuyển",
  "shopee.workspace.shipping.step.delivered": "Hoàn thành",
  "shopee.workspace.shipping.step.picking": "Soạn hàng",
  "shopee.workspace.shipping.action.print-label": "In vận đơn",
  "shopee.workspace.shipping.search-placeholder": "Tìm mã đơn, tên KH, SĐT...",
  "shopee.workspace.shipping.filter.all-carriers": "Tất cả đơn vị vận chuyển",
  "shopee.workspace.common.yesterday": "Hôm qua",
  "shopee.workspace.common.this-month": "Tháng này",
  "shopee.workspace.shipping.pagination-summary": "Hiển thị 1 - {count} trên tổng {total} đơn hàng",
  "shopee.workspace.shipping.perf.performance-today": "Hiệu suất hôm nay",
  "shopee.workspace.shipping.perf.updated-at": "Cập nhật 10:30",
  "shopee.workspace.shipping.perf.processed": "Đã xử lý",
  "shopee.workspace.shipping.perf.orders-value": "{count} đơn",
  "shopee.workspace.shipping.perf.on-time": "Đúng hạn",
  "shopee.workspace.shipping.perf.overdue": "Quá hạn",
  "shopee.workspace.shipping.perf.success-rate": "Tỷ lệ giao thành công",
  "shopee.workspace.shipping.perf.returns": "Đơn hoàn",
  "shopee.workspace.shipping.perf.top-carriers": "Top vận chuyển",
  "shopee.workspace.shipping.alert.close-detail": "Đóng bảng chi tiết",
  "shopee.workspace.shipping.section-customer": "Thông tin khách hàng",
  "shopee.workspace.shipping.title.call": "Gọi điện",
  "shopee.workspace.shipping.alert.call": "Gọi tới {phone}",
  "shopee.workspace.shipping.title.address": "Xem địa chỉ",
  "shopee.workspace.shipping.section-products": "Sản phẩm ({count})",
  "shopee.workspace.shipping.section-shipping-info": "Thông tin vận chuyển",
  "shopee.workspace.shipping.col.carrier": "Đơn vị vận chuyển",
  "shopee.workspace.shipping.title.copy-code": "Sao chép mã",
  "shopee.workspace.shipping.alert.copied": "Đã sao chép: {code}",
  "shopee.workspace.shipping.col.service": "Dịch vụ",
  "shopee.workspace.shipping.col.shipping-fee": "Phí vận chuyển",
  "shopee.workspace.shipping.col.cod": "Thu hộ (COD)",
  "shopee.workspace.shipping.col.total-collect": "Tổng thu",
  "shopee.workspace.shipping.checklist-title": "Checklist đóng gói",
  "shopee.workspace.shipping.alert.print-label": "In vận đơn cho {sn}",
  "shopee.workspace.shipping.action.print-slip": "In phiếu hàng",
  "shopee.workspace.shipping.alert.print-slip-order": "In phiếu hàng cho {sn}",
  "shopee.workspace.shipping.action.packed-done": "Đã đóng gói xong",
  "shopee.workspace.shipping.notice.packed-handover": "Đã hoàn tất đóng gói và chuyển sang trạng thái Chờ bàn giao",
  "shopee.workspace.shipping.alert.packed-done": "Đã hoàn tất đóng gói đơn {sn}",
  "shopee.workspace.shipping.action.complete-handover": "Hoàn tất & Chuyển Chờ bàn giao",
  "shopee.workspace.shipping.action.report-shortage": "Báo thiếu hàng",
  "shopee.workspace.shipping.action.delay-packing": "Tạm hoãn đóng gói",
  "shopee.workspace.shipping.scan.title": "Trạm đóng gói - Quét mã đơn hàng",
  "shopee.workspace.shipping.scan.desc": "Quét mã vạch hoặc nhập mã vận đơn / mã đơn hàng Shopee để kiểm đếm & in nhãn tức thì:",
  "shopee.workspace.shipping.scan.label": "Mã đơn / Mã vận đơn",
  "shopee.workspace.shipping.scan.placeholder": "VD: SP24072201 hoặc GHN1234567890...",
  "shopee.workspace.shipping.alert.not-found": "Không tìm thấy đơn hàng với mã: {code}",
  "shopee.workspace.shipping.scan.now": "Quét ngay",
  "shopee.workspace.finance.channel-pos": "POS - Cửa hàng",
  "shopee.workspace.finance.status.paid": "Đã thanh toán",
  "shopee.workspace.finance.status.pending-payment": "Chờ thanh toán",
  "shopee.workspace.finance.status.discrepancy": "Chênh lệch",
  "shopee.workspace.finance.status.dispute": "Tranh chấp",
  "shopee.workspace.finance.bank-encrypted": "Tài khoản mã hóa",
  "shopee.workspace.finance.payout.transferred": "Đã chuyển tiền",
  "shopee.workspace.finance.payout.processing": "Chờ xử lý",
  "shopee.workspace.finance.sync-queued": "Đã lập lịch đồng bộ đối soát",
  "shopee.workspace.finance.subtitle": "Theo dõi, đối soát và quản lý thanh toán từ tất cả các kênh bán hàng",
  "shopee.workspace.finance.forecast": "Dự báo tiền về",
  "shopee.workspace.finance.export-report": "Xuất báo cáo",
  "shopee.workspace.finance.action.sync": "Đồng bộ đối soát",
  "shopee.workspace.finance.kpi.revenue": "Doanh thu",
  "shopee.workspace.finance.kpi.vs-prev-period": "so với kỳ trước",
  "shopee.workspace.finance.kpi.pending-reconciliation": "Chờ đối soát",
  "shopee.workspace.finance.kpi.holding": "Đang giữ",
  "shopee.workspace.finance.kpi.refund": "Hoàn tiền",
  "shopee.workspace.finance.kpi.fees": "Phí & Khấu trừ",
  "shopee.workspace.finance.cashflow-title": "Dòng tiền (Cash Flow)",
  "shopee.workspace.finance.net-received": "Thực nhận",
  "shopee.workspace.finance.forecast.tomorrow": "Ngày mai",
  "shopee.workspace.finance.forecast.next-3-days": "3 ngày tới",
  "shopee.workspace.finance.forecast.next-week": "Tuần tới",
  "shopee.workspace.finance.forecast.view-detail": "Xem chi tiết dự báo →",
  "shopee.workspace.finance.filter.all-banks": "Tất cả tài khoản NH",
  "shopee.workspace.finance.col.sn": "Mã đối soát",
  "shopee.workspace.finance.col.period": "Kỳ đối soát",
  "shopee.workspace.finance.col.order-count": "Số đơn",
  "shopee.workspace.finance.col.payout-date": "Ngày thanh toán",
  "shopee.workspace.finance.action.export-excel-file": "Xuất file Excel",
  "shopee.workspace.finance.detail-title": "Chi tiết đối soát",
  "shopee.workspace.finance.meta.period": "Kỳ đối soát:",
  "shopee.workspace.finance.meta.payout-date": "Ngày thanh toán:",
  "shopee.workspace.finance.meta.bank-account": "Tài khoản nhận:",
  "shopee.workspace.finance.meta.transaction-code": "Mã giao dịch:",
  "shopee.workspace.finance.meta.status": "Trạng thái:",
  "shopee.workspace.finance.tab-orders": "Chi tiết đơn hàng ({count})",
  "shopee.workspace.finance.bd.gross-revenue": "Tổng doanh thu",
  "shopee.workspace.finance.bd.platform-deduction": "Giảm trừ bối sàn ^",
  "shopee.workspace.finance.bd.voucher": "Voucher sàn",
  "shopee.workspace.finance.bd.shipping-buyer": "Phí vận chuyển (khách trả)",
  "shopee.workspace.finance.bd.seller-discount": "Giảm giá từ sàn",
  "shopee.workspace.finance.bd.payment-fee": "Phí thanh toán",
  "shopee.workspace.finance.bd.service-fee": "Phí dịch vụ",
  "shopee.workspace.finance.bd.tax": "Thuế",
  "shopee.workspace.finance.bd.refunds": "Hoàn tiền / Trả hàng ^",
  "shopee.workspace.finance.bd.refund-fee": "Phí hoàn tiền",
  "shopee.workspace.finance.bd.other-deductions": "Khấu trừ khác",
  "shopee.workspace.finance.action.view-documents": "Xem chứng từ đối soát",
  "shopee.workspace.finance.action.download-statement": "Tải bảng đối soát",
  "shopee.workspace.finance.discrepancy.alert": "Chênh lệch cần kiểm tra:",
  "shopee.workspace.finance.discrepancy.desc": "Có {count} đơn hàng có chênh lệch giữa VMASS và sàn.",
  "shopee.workspace.finance.widget.success-rate": "Tỷ lệ đối soát thành công",
  "shopee.workspace.finance.legend.success": "Thành công:",
  "shopee.workspace.finance.legend.failed": "Thất bại:",
  "shopee.workspace.finance.widget.top-revenue-channels": "Kênh có doanh thu cao nhất",
  "shopee.workspace.finance.channel-others": "Khác",
  "shopee.workspace.finance.widget.popular-refund-reasons": "Lý do hoàn tiền phổ biến",
  "shopee.workspace.finance.reason.wrong-color": "Sai màu/sắc:",
  "shopee.workspace.finance.reason.wrong-size": "Không vừa size:",
  "shopee.workspace.finance.reason.defect": "Lỗi sản phẩm:",
  "shopee.workspace.finance.reason.not-liked": "Không thích:",
  "shopee.workspace.finance.insight.unpaid-orders": "Bạn có {count} đơn Shopee đã giao >10 ngày nhưng chưa nhận tiền.",
  "shopee.workspace.finance.insight.transfer-tomorrow": "Shopee sẽ chuyển khoảng 42 triệu vào ngày mai ({date}).",
  "shopee.workspace.finance.insight.fee-increase": "Phí vận chuyển TikTok Shop tăng {percent} so với tháng trước.",
  "shopee.workspace.finance.insight.view-more": "Xem thêm insight →",
  "shopee.workspace.issues.channel-other": "Kênh khác",
  "shopee.workspace.common.order-hash": "Đơn hàng",
  "shopee.workspace.common.product-hash": "Sản phẩm",
  "shopee.workspace.tab.shipping-short": "Vận chuyển",
  "shopee.workspace.issues.subtitle": "Theo dõi, xử lý và khắc phục các lỗi kết nối, đồng bộ và hệ thống",
  "shopee.workspace.issues.severity.critical": "Nghiêm trọng",
  "shopee.workspace.issues.severity.high": "Cao",
  "shopee.workspace.issues.severity.medium": "Trung bình",
  "shopee.workspace.issues.severity.low": "Thấp",
  "shopee.workspace.issues.status.unresolved": "Chưa xử lý",
  "shopee.workspace.issues.status.in-progress": "Đang xử lý",
  "shopee.workspace.issues.status.waiting": "Chờ xử lý",
  "shopee.workspace.issues.status.resolved": "Đã khắc phục",
  "shopee.workspace.issues.status.ignored": "Bỏ qua",
  "shopee.workspace.issues.type.order-sync": "Đồng bộ đơn hàng",
  "shopee.workspace.issues.type.product-sync": "Đồng bộ sản phẩm",
  "shopee.workspace.issues.type.system-task": "Tác vụ hệ thống",
  "shopee.workspace.issues.type.system": "Hệ thống",
  "shopee.workspace.issues.type.stock-sync": "Đồng bộ tồn kho",
  "shopee.workspace.issues.type.api-connection": "Kết nối API",
  "shopee.workspace.issues.type.payment": "Thanh toán",
  "shopee.workspace.issues.filter.all-types": "Tất cả loại lỗi",
  "shopee.workspace.issues.filter.all-severities": "Tất cả mức độ",
  "shopee.workspace.issues.error.order-sync": "Lỗi đồng bộ đơn hàng",
  "shopee.workspace.issues.error.check-order-status": "Cần kiểm tra trạng thái đơn",
  "shopee.workspace.issues.error.sku-mapping": "Lỗi ghép sản phẩm SKU",
  "shopee.workspace.issues.error.sku-unmapped": "Chưa ghép SKU VMASS hoặc lỗi đồng bộ kho",
  "shopee.workspace.issues.error.job-ended-status": "Job kết thúc trạng thái {status}",
  "shopee.workspace.issues.error.retried-times": "Thử lại {count} lần",
  "shopee.workspace.issues.action.process-label": "Xử lý lỗi {id}",
  "shopee.workspace.issues.action.process-now": "Xử lý ngay",
  "shopee.workspace.issues.action.ignore-label": "Bỏ qua lỗi {id}",
  "shopee.workspace.issues.action.ignore": "Bỏ qua",
  "shopee.workspace.issues.action.mark-resolved": "Đánh dấu đã xử lý",
  "shopee.workspace.issues.empty": "Không tìm thấy dữ liệu lỗi phù hợp",
  "shopee.workspace.issues.pagination-of": "trên tổng {total} lỗi",
  "shopee.workspace.issues.total-errors": "Tổng lỗi",
  "shopee.workspace.issues.chart.by-channel": "Lỗi theo kênh",
  "shopee.workspace.issues.chart.by-type": "Lỗi theo loại",
  "shopee.workspace.issues.chart.by-severity": "Lỗi theo mức độ",
  "shopee.workspace.issues.chart.timeline": "Biểu đồ lỗi theo thời gian",
  "shopee.workspace.issues.chart.top-errors": "Top lỗi thường gặp",
  "shopee.workspace.issues.times-count": "{count} lần",
  "shopee.workspace.issues.top.order-list": "Không thể lấy danh sách đơn hàng",
  "shopee.workspace.issues.top.invalid-data": "Dữ liệu không hợp lệ",
  "shopee.workspace.issues.top.negative-stock": "Tồn kho âm",
  "shopee.workspace.issues.top.payment-not-found": "Không tìm thấy giao dịch thanh toán",
  "shopee.workspace.issues.activity.processed": "đã xử lý lỗi TikTok Shop - Đồng bộ sản phẩm",
  "shopee.workspace.issues.activity.resolved": "đã khắc phục lỗi",
  "shopee.workspace.issues.drawer.title": "Chi tiết lỗi",
  "shopee.workspace.issues.drawer.info-title": "Thông tin lỗi",
  "shopee.workspace.issues.drawer.error-code": "Mã lỗi",
  "shopee.workspace.issues.drawer.request": "Yêu cầu",
  "shopee.workspace.issues.drawer.request-detail": "Chi tiết yêu cầu",
  "shopee.workspace.issues.drawer.response-detail": "Chi tiết phản hồi",
  "shopee.workspace.issues.drawer.impact-title": "Ảnh hưởng",
  "shopee.workspace.issues.drawer.impact-orders": "Đơn hàng bị ảnh hưởng",
  "shopee.workspace.issues.drawer.impact-products": "Sản phẩm bị ảnh hưởng",
  "shopee.workspace.issues.drawer.impact-revenue": "Doanh thu bị ảnh hưởng",
  "shopee.workspace.issues.drawer.suggestions-title": "Gợi ý xử lý",
  "shopee.workspace.issues.suggest.check-api": "Kiểm tra kết nối API Shopee",
  "shopee.workspace.issues.suggest.check-status": "Kiểm tra trạng thái hệ thống Shopee",
  "shopee.workspace.issues.suggest.retry-sync": "Thử đồng bộ lại sau ít phút",
  "shopee.workspace.issues.suggest.contact-support": "Liên hệ hỗ trợ nếu lỗi tiếp tục xảy ra",
  "shopee.workspace.issues.drawer.note-title": "Ghi chú nội bộ",
  "shopee.workspace.issues.confirm.title": "Xác nhận xử lý lỗi",
  "shopee.workspace.issues.confirm.desc": "Bạn có chắc chắn muốn thực hiện hành động này không?",
  "shopee.workspace.issues.confirm.items": "{label} ({count} mục)",
  "shopee.workspace.issues.confirm.ok": "Xác nhận",
  "shopee.workspace.issues.confirm.queued": "Đã đưa tác vụ khắc phục vào hàng đợi",
  "shopee.workspace.issues.kpi.all": "Tất cả lỗi",
  "shopee.workspace.issues.kpi.all-sub": "Tổng số vấn đề phát hiện",
  "shopee.workspace.issues.kpi.unresolved-sub": "Cần kiểm tra ngay",
  "shopee.workspace.issues.kpi.in-progress": "Lỗi đang xử lý",
  "shopee.workspace.issues.kpi.in-progress-sub": "Đang trong tiến trình",
  "shopee.workspace.issues.kpi.resolved": "Lỗi đã khắc phục",
  "shopee.workspace.issues.kpi.resolved-sub": "Đã được giải quyết",
  "shopee.workspace.issues.kpi.critical": "Lỗi nghiêm trọng",
  "shopee.workspace.issues.kpi.critical-sub": "Mức độ cao & nghiêm trọng",
  "shopee.workspace.issues.action.configure-alerts": "Cấu hình cảnh báo",
  "shopee.workspace.issues.action.system-logs": "Nhật ký hệ thống",
  "shopee.workspace.issues.col.channel-source": "Kênh / Nguồn",
  "shopee.workspace.issues.col.type": "Loại lỗi",
  "shopee.workspace.issues.col.severity": "Mức độ",
  "shopee.workspace.issues.col.object": "Đối tượng",
  "shopee.workspace.issues.col.message": "Thông báo lỗi",
  "shopee.workspace.listing.description-template": "{name} - Sản phẩm chất lượng cao",
  "shopee.workspace.listing.err.no-shop": "Chưa chọn gian hàng Shopee",
  "shopee.workspace.listing.err.no-product": "Chưa chọn sản phẩm VMASS",
  "shopee.workspace.listing.err.name-length": "Tên sản phẩm phải từ 5-120 ký tự",
  "shopee.workspace.listing.err.desc-length": "Mô tả phải có ít nhất 25 ký tự",
  "shopee.workspace.listing.err.price": "Giá phải lớn hơn 0",
  "shopee.workspace.listing.err.variant-price": "Giá của mọi biến thể phải lớn hơn 0",
  "shopee.workspace.listing.err.weight": "Cân nặng phải từ 0.01 đến 50 kg",
  "shopee.workspace.listing.err.no-category": "Chưa chọn danh mục Shopee",
  "shopee.workspace.listing.err.brand-load-failed": "Chưa tải được thương hiệu Shopee",
  "shopee.workspace.listing.err.no-brand": "Chưa chọn thương hiệu Shopee",
  "shopee.workspace.listing.err.no-logistics": "Chưa chọn kênh vận chuyển",
  "shopee.workspace.listing.err.missing-attribute": "Thiếu thuộc tính: {attribute}",
  "shopee.workspace.listing.err.dimensions": "Cần nhập đủ ba kích thước lớn hơn 0",
  "shopee.workspace.listing.update-queued": "Đã đưa yêu cầu cập nhật listing vào hàng đợi",
  "shopee.workspace.listing.publish-queued": "Đã đưa sản phẩm vào hàng đợi đăng Shopee",
  "shopee.workspace.listing.label.shop": "Gian hàng Shopee *",
  "shopee.workspace.listing.no-shops": "Chưa có gian hàng Shopee",
  "shopee.workspace.listing.primary-mark": "Chính",
  "shopee.workspace.listing.shop-hint": "Dữ liệu danh mục, thương hiệu và vận chuyển sẽ tải theo gian hàng đã chọn.",
  "shopee.workspace.listing.label.brand": "Thương hiệu Shopee",
};

export default viVn;
